var of = { exports: {} }, zn = {};
var Sr;
function ev() {
  if (Sr) return zn;
  Sr = 1;
  var N = /* @__PURE__ */ Symbol.for("react.transitional.element"), yl = /* @__PURE__ */ Symbol.for("react.fragment");
  function F(y, ml, sl) {
    var El = null;
    if (sl !== void 0 && (El = "" + sl), ml.key !== void 0 && (El = "" + ml.key), "key" in ml) {
      sl = {};
      for (var Rl in ml)
        Rl !== "key" && (sl[Rl] = ml[Rl]);
    } else sl = ml;
    return ml = sl.ref, {
      $$typeof: N,
      type: y,
      key: El,
      ref: ml !== void 0 ? ml : null,
      props: sl
    };
  }
  return zn.Fragment = yl, zn.jsx = F, zn.jsxs = F, zn;
}
var br;
function av() {
  return br || (br = 1, of.exports = ev()), of.exports;
}
var c = av(), df = { exports: {} }, Nn = {}, rf = { exports: {} }, hf = {};
var xr;
function nv() {
  return xr || (xr = 1, (function(N) {
    function yl(p, j) {
      var C = p.length;
      p.push(j);
      l: for (; 0 < C; ) {
        var W = C - 1 >>> 1, I = p[W];
        if (0 < ml(I, j))
          p[W] = j, p[C] = I, C = W;
        else break l;
      }
    }
    function F(p) {
      return p.length === 0 ? null : p[0];
    }
    function y(p) {
      if (p.length === 0) return null;
      var j = p[0], C = p.pop();
      if (C !== j) {
        p[0] = C;
        l: for (var W = 0, I = p.length, o = I >>> 1; W < o; ) {
          var T = 2 * (W + 1) - 1, A = p[T], _ = T + 1, Y = p[_];
          if (0 > ml(A, C))
            _ < I && 0 > ml(Y, A) ? (p[W] = Y, p[_] = C, W = _) : (p[W] = A, p[T] = C, W = T);
          else if (_ < I && 0 > ml(Y, C))
            p[W] = Y, p[_] = C, W = _;
          else break l;
        }
      }
      return j;
    }
    function ml(p, j) {
      var C = p.sortIndex - j.sortIndex;
      return C !== 0 ? C : p.id - j.id;
    }
    if (N.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var sl = performance;
      N.unstable_now = function() {
        return sl.now();
      };
    } else {
      var El = Date, Rl = El.now();
      N.unstable_now = function() {
        return El.now() - Rl;
      };
    }
    var U = [], E = [], $ = 1, H = null, el = 3, gl = !1, Zl = !1, jl = !1, jt = !1, Al = typeof setTimeout == "function" ? setTimeout : null, Dt = typeof clearTimeout == "function" ? clearTimeout : null, zl = typeof setImmediate < "u" ? setImmediate : null;
    function kl(p) {
      for (var j = F(E); j !== null; ) {
        if (j.callback === null) y(E);
        else if (j.startTime <= p)
          y(E), j.sortIndex = j.expirationTime, yl(U, j);
        else break;
        j = F(E);
      }
    }
    function ht(p) {
      if (jl = !1, kl(p), !Zl)
        if (F(U) !== null)
          Zl = !0, wl || (wl = !0, O());
        else {
          var j = F(E);
          j !== null && pl(ht, j.startTime - p);
        }
    }
    var wl = !1, Z = -1, Vl = 5, Kl = -1;
    function Ht() {
      return jt ? !0 : !(N.unstable_now() - Kl < Vl);
    }
    function z() {
      if (jt = !1, wl) {
        var p = N.unstable_now();
        Kl = p;
        var j = !0;
        try {
          l: {
            Zl = !1, jl && (jl = !1, Dt(Z), Z = -1), gl = !0;
            var C = el;
            try {
              t: {
                for (kl(p), H = F(U); H !== null && !(H.expirationTime > p && Ht()); ) {
                  var W = H.callback;
                  if (typeof W == "function") {
                    H.callback = null, el = H.priorityLevel;
                    var I = W(
                      H.expirationTime <= p
                    );
                    if (p = N.unstable_now(), typeof I == "function") {
                      H.callback = I, kl(p), j = !0;
                      break t;
                    }
                    H === F(U) && y(U), kl(p);
                  } else y(U);
                  H = F(U);
                }
                if (H !== null) j = !0;
                else {
                  var o = F(E);
                  o !== null && pl(
                    ht,
                    o.startTime - p
                  ), j = !1;
                }
              }
              break l;
            } finally {
              H = null, el = C, gl = !1;
            }
            j = void 0;
          }
        } finally {
          j ? O() : wl = !1;
        }
      }
    }
    var O;
    if (typeof zl == "function")
      O = function() {
        zl(z);
      };
    else if (typeof MessageChannel < "u") {
      var ol = new MessageChannel(), Nl = ol.port2;
      ol.port1.onmessage = z, O = function() {
        Nl.postMessage(null);
      };
    } else
      O = function() {
        Al(z, 0);
      };
    function pl(p, j) {
      Z = Al(function() {
        p(N.unstable_now());
      }, j);
    }
    N.unstable_IdlePriority = 5, N.unstable_ImmediatePriority = 1, N.unstable_LowPriority = 4, N.unstable_NormalPriority = 3, N.unstable_Profiling = null, N.unstable_UserBlockingPriority = 2, N.unstable_cancelCallback = function(p) {
      p.callback = null;
    }, N.unstable_forceFrameRate = function(p) {
      0 > p || 125 < p ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : Vl = 0 < p ? Math.floor(1e3 / p) : 5;
    }, N.unstable_getCurrentPriorityLevel = function() {
      return el;
    }, N.unstable_next = function(p) {
      switch (el) {
        case 1:
        case 2:
        case 3:
          var j = 3;
          break;
        default:
          j = el;
      }
      var C = el;
      el = j;
      try {
        return p();
      } finally {
        el = C;
      }
    }, N.unstable_requestPaint = function() {
      jt = !0;
    }, N.unstable_runWithPriority = function(p, j) {
      switch (p) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          p = 3;
      }
      var C = el;
      el = p;
      try {
        return j();
      } finally {
        el = C;
      }
    }, N.unstable_scheduleCallback = function(p, j, C) {
      var W = N.unstable_now();
      switch (typeof C == "object" && C !== null ? (C = C.delay, C = typeof C == "number" && 0 < C ? W + C : W) : C = W, p) {
        case 1:
          var I = -1;
          break;
        case 2:
          I = 250;
          break;
        case 5:
          I = 1073741823;
          break;
        case 4:
          I = 1e4;
          break;
        default:
          I = 5e3;
      }
      return I = C + I, p = {
        id: $++,
        callback: j,
        priorityLevel: p,
        startTime: C,
        expirationTime: I,
        sortIndex: -1
      }, C > W ? (p.sortIndex = C, yl(E, p), F(U) === null && p === F(E) && (jl ? (Dt(Z), Z = -1) : jl = !0, pl(ht, C - W))) : (p.sortIndex = I, yl(U, p), Zl || gl || (Zl = !0, wl || (wl = !0, O()))), p;
    }, N.unstable_shouldYield = Ht, N.unstable_wrapCallback = function(p) {
      var j = el;
      return function() {
        var C = el;
        el = j;
        try {
          return p.apply(this, arguments);
        } finally {
          el = C;
        }
      };
    };
  })(hf)), hf;
}
var Tr;
function uv() {
  return Tr || (Tr = 1, rf.exports = nv()), rf.exports;
}
var mf = { exports: {} }, G = {};
var Er;
function iv() {
  if (Er) return G;
  Er = 1;
  var N = /* @__PURE__ */ Symbol.for("react.transitional.element"), yl = /* @__PURE__ */ Symbol.for("react.portal"), F = /* @__PURE__ */ Symbol.for("react.fragment"), y = /* @__PURE__ */ Symbol.for("react.strict_mode"), ml = /* @__PURE__ */ Symbol.for("react.profiler"), sl = /* @__PURE__ */ Symbol.for("react.consumer"), El = /* @__PURE__ */ Symbol.for("react.context"), Rl = /* @__PURE__ */ Symbol.for("react.forward_ref"), U = /* @__PURE__ */ Symbol.for("react.suspense"), E = /* @__PURE__ */ Symbol.for("react.memo"), $ = /* @__PURE__ */ Symbol.for("react.lazy"), H = /* @__PURE__ */ Symbol.for("react.activity"), el = Symbol.iterator;
  function gl(o) {
    return o === null || typeof o != "object" ? null : (o = el && o[el] || o["@@iterator"], typeof o == "function" ? o : null);
  }
  var Zl = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, jl = Object.assign, jt = {};
  function Al(o, T, A) {
    this.props = o, this.context = T, this.refs = jt, this.updater = A || Zl;
  }
  Al.prototype.isReactComponent = {}, Al.prototype.setState = function(o, T) {
    if (typeof o != "object" && typeof o != "function" && o != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, o, T, "setState");
  }, Al.prototype.forceUpdate = function(o) {
    this.updater.enqueueForceUpdate(this, o, "forceUpdate");
  };
  function Dt() {
  }
  Dt.prototype = Al.prototype;
  function zl(o, T, A) {
    this.props = o, this.context = T, this.refs = jt, this.updater = A || Zl;
  }
  var kl = zl.prototype = new Dt();
  kl.constructor = zl, jl(kl, Al.prototype), kl.isPureReactComponent = !0;
  var ht = Array.isArray;
  function wl() {
  }
  var Z = { H: null, A: null, T: null, S: null }, Vl = Object.prototype.hasOwnProperty;
  function Kl(o, T, A) {
    var _ = A.ref;
    return {
      $$typeof: N,
      type: o,
      key: T,
      ref: _ !== void 0 ? _ : null,
      props: A
    };
  }
  function Ht(o, T) {
    return Kl(o.type, T, o.props);
  }
  function z(o) {
    return typeof o == "object" && o !== null && o.$$typeof === N;
  }
  function O(o) {
    var T = { "=": "=0", ":": "=2" };
    return "$" + o.replace(/[=:]/g, function(A) {
      return T[A];
    });
  }
  var ol = /\/+/g;
  function Nl(o, T) {
    return typeof o == "object" && o !== null && o.key != null ? O("" + o.key) : T.toString(36);
  }
  function pl(o) {
    switch (o.status) {
      case "fulfilled":
        return o.value;
      case "rejected":
        throw o.reason;
      default:
        switch (typeof o.status == "string" ? o.then(wl, wl) : (o.status = "pending", o.then(
          function(T) {
            o.status === "pending" && (o.status = "fulfilled", o.value = T);
          },
          function(T) {
            o.status === "pending" && (o.status = "rejected", o.reason = T);
          }
        )), o.status) {
          case "fulfilled":
            return o.value;
          case "rejected":
            throw o.reason;
        }
    }
    throw o;
  }
  function p(o, T, A, _, Y) {
    var L = typeof o;
    (L === "undefined" || L === "boolean") && (o = null);
    var B = !1;
    if (o === null) B = !0;
    else
      switch (L) {
        case "bigint":
        case "string":
        case "number":
          B = !0;
          break;
        case "object":
          switch (o.$$typeof) {
            case N:
            case yl:
              B = !0;
              break;
            case $:
              return B = o._init, p(
                B(o._payload),
                T,
                A,
                _,
                Y
              );
          }
      }
    if (B)
      return Y = Y(o), B = _ === "" ? "." + Nl(o, 0) : _, ht(Y) ? (A = "", B != null && (A = B.replace(ol, "$&/") + "/"), p(Y, T, A, "", function(At) {
        return At;
      })) : Y != null && (z(Y) && (Y = Ht(
        Y,
        A + (Y.key == null || o && o.key === Y.key ? "" : ("" + Y.key).replace(
          ol,
          "$&/"
        ) + "/") + B
      )), T.push(Y)), 1;
    B = 0;
    var Ul = _ === "" ? "." : _ + ":";
    if (ht(o))
      for (var dl = 0; dl < o.length; dl++)
        _ = o[dl], L = Ul + Nl(_, dl), B += p(
          _,
          T,
          A,
          L,
          Y
        );
    else if (dl = gl(o), typeof dl == "function")
      for (o = dl.call(o), dl = 0; !(_ = o.next()).done; )
        _ = _.value, L = Ul + Nl(_, dl++), B += p(
          _,
          T,
          A,
          L,
          Y
        );
    else if (L === "object") {
      if (typeof o.then == "function")
        return p(
          pl(o),
          T,
          A,
          _,
          Y
        );
      throw T = String(o), Error(
        "Objects are not valid as a React child (found: " + (T === "[object Object]" ? "object with keys {" + Object.keys(o).join(", ") + "}" : T) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return B;
  }
  function j(o, T, A) {
    if (o == null) return o;
    var _ = [], Y = 0;
    return p(o, _, "", "", function(L) {
      return T.call(A, L, Y++);
    }), _;
  }
  function C(o) {
    if (o._status === -1) {
      var T = o._result;
      T = T(), T.then(
        function(A) {
          (o._status === 0 || o._status === -1) && (o._status = 1, o._result = A);
        },
        function(A) {
          (o._status === 0 || o._status === -1) && (o._status = 2, o._result = A);
        }
      ), o._status === -1 && (o._status = 0, o._result = T);
    }
    if (o._status === 1) return o._result.default;
    throw o._result;
  }
  var W = typeof reportError == "function" ? reportError : function(o) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var T = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof o == "object" && o !== null && typeof o.message == "string" ? String(o.message) : String(o),
        error: o
      });
      if (!window.dispatchEvent(T)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", o);
      return;
    }
    console.error(o);
  }, I = {
    map: j,
    forEach: function(o, T, A) {
      j(
        o,
        function() {
          T.apply(this, arguments);
        },
        A
      );
    },
    count: function(o) {
      var T = 0;
      return j(o, function() {
        T++;
      }), T;
    },
    toArray: function(o) {
      return j(o, function(T) {
        return T;
      }) || [];
    },
    only: function(o) {
      if (!z(o))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return o;
    }
  };
  return G.Activity = H, G.Children = I, G.Component = Al, G.Fragment = F, G.Profiler = ml, G.PureComponent = zl, G.StrictMode = y, G.Suspense = U, G.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Z, G.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(o) {
      return Z.H.useMemoCache(o);
    }
  }, G.cache = function(o) {
    return function() {
      return o.apply(null, arguments);
    };
  }, G.cacheSignal = function() {
    return null;
  }, G.cloneElement = function(o, T, A) {
    if (o == null)
      throw Error(
        "The argument must be a React element, but you passed " + o + "."
      );
    var _ = jl({}, o.props), Y = o.key;
    if (T != null)
      for (L in T.key !== void 0 && (Y = "" + T.key), T)
        !Vl.call(T, L) || L === "key" || L === "__self" || L === "__source" || L === "ref" && T.ref === void 0 || (_[L] = T[L]);
    var L = arguments.length - 2;
    if (L === 1) _.children = A;
    else if (1 < L) {
      for (var B = Array(L), Ul = 0; Ul < L; Ul++)
        B[Ul] = arguments[Ul + 2];
      _.children = B;
    }
    return Kl(o.type, Y, _);
  }, G.createContext = function(o) {
    return o = {
      $$typeof: El,
      _currentValue: o,
      _currentValue2: o,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, o.Provider = o, o.Consumer = {
      $$typeof: sl,
      _context: o
    }, o;
  }, G.createElement = function(o, T, A) {
    var _, Y = {}, L = null;
    if (T != null)
      for (_ in T.key !== void 0 && (L = "" + T.key), T)
        Vl.call(T, _) && _ !== "key" && _ !== "__self" && _ !== "__source" && (Y[_] = T[_]);
    var B = arguments.length - 2;
    if (B === 1) Y.children = A;
    else if (1 < B) {
      for (var Ul = Array(B), dl = 0; dl < B; dl++)
        Ul[dl] = arguments[dl + 2];
      Y.children = Ul;
    }
    if (o && o.defaultProps)
      for (_ in B = o.defaultProps, B)
        Y[_] === void 0 && (Y[_] = B[_]);
    return Kl(o, L, Y);
  }, G.createRef = function() {
    return { current: null };
  }, G.forwardRef = function(o) {
    return { $$typeof: Rl, render: o };
  }, G.isValidElement = z, G.lazy = function(o) {
    return {
      $$typeof: $,
      _payload: { _status: -1, _result: o },
      _init: C
    };
  }, G.memo = function(o, T) {
    return {
      $$typeof: E,
      type: o,
      compare: T === void 0 ? null : T
    };
  }, G.startTransition = function(o) {
    var T = Z.T, A = {};
    Z.T = A;
    try {
      var _ = o(), Y = Z.S;
      Y !== null && Y(A, _), typeof _ == "object" && _ !== null && typeof _.then == "function" && _.then(wl, W);
    } catch (L) {
      W(L);
    } finally {
      T !== null && A.types !== null && (T.types = A.types), Z.T = T;
    }
  }, G.unstable_useCacheRefresh = function() {
    return Z.H.useCacheRefresh();
  }, G.use = function(o) {
    return Z.H.use(o);
  }, G.useActionState = function(o, T, A) {
    return Z.H.useActionState(o, T, A);
  }, G.useCallback = function(o, T) {
    return Z.H.useCallback(o, T);
  }, G.useContext = function(o) {
    return Z.H.useContext(o);
  }, G.useDebugValue = function() {
  }, G.useDeferredValue = function(o, T) {
    return Z.H.useDeferredValue(o, T);
  }, G.useEffect = function(o, T) {
    return Z.H.useEffect(o, T);
  }, G.useEffectEvent = function(o) {
    return Z.H.useEffectEvent(o);
  }, G.useId = function() {
    return Z.H.useId();
  }, G.useImperativeHandle = function(o, T, A) {
    return Z.H.useImperativeHandle(o, T, A);
  }, G.useInsertionEffect = function(o, T) {
    return Z.H.useInsertionEffect(o, T);
  }, G.useLayoutEffect = function(o, T) {
    return Z.H.useLayoutEffect(o, T);
  }, G.useMemo = function(o, T) {
    return Z.H.useMemo(o, T);
  }, G.useOptimistic = function(o, T) {
    return Z.H.useOptimistic(o, T);
  }, G.useReducer = function(o, T, A) {
    return Z.H.useReducer(o, T, A);
  }, G.useRef = function(o) {
    return Z.H.useRef(o);
  }, G.useState = function(o) {
    return Z.H.useState(o);
  }, G.useSyncExternalStore = function(o, T, A) {
    return Z.H.useSyncExternalStore(
      o,
      T,
      A
    );
  }, G.useTransition = function() {
    return Z.H.useTransition();
  }, G.version = "19.2.7", G;
}
var jr;
function yf() {
  return jr || (jr = 1, mf.exports = iv()), mf.exports;
}
var vf = { exports: {} }, Jl = {};
var Ar;
function cv() {
  if (Ar) return Jl;
  Ar = 1;
  var N = yf();
  function yl(U) {
    var E = "https://react.dev/errors/" + U;
    if (1 < arguments.length) {
      E += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var $ = 2; $ < arguments.length; $++)
        E += "&args[]=" + encodeURIComponent(arguments[$]);
    }
    return "Minified React error #" + U + "; visit " + E + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function F() {
  }
  var y = {
    d: {
      f: F,
      r: function() {
        throw Error(yl(522));
      },
      D: F,
      C: F,
      L: F,
      m: F,
      X: F,
      S: F,
      M: F
    },
    p: 0,
    findDOMNode: null
  }, ml = /* @__PURE__ */ Symbol.for("react.portal");
  function sl(U, E, $) {
    var H = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: ml,
      key: H == null ? null : "" + H,
      children: U,
      containerInfo: E,
      implementation: $
    };
  }
  var El = N.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function Rl(U, E) {
    if (U === "font") return "";
    if (typeof E == "string")
      return E === "use-credentials" ? E : "";
  }
  return Jl.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = y, Jl.createPortal = function(U, E) {
    var $ = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!E || E.nodeType !== 1 && E.nodeType !== 9 && E.nodeType !== 11)
      throw Error(yl(299));
    return sl(U, E, null, $);
  }, Jl.flushSync = function(U) {
    var E = El.T, $ = y.p;
    try {
      if (El.T = null, y.p = 2, U) return U();
    } finally {
      El.T = E, y.p = $, y.d.f();
    }
  }, Jl.preconnect = function(U, E) {
    typeof U == "string" && (E ? (E = E.crossOrigin, E = typeof E == "string" ? E === "use-credentials" ? E : "" : void 0) : E = null, y.d.C(U, E));
  }, Jl.prefetchDNS = function(U) {
    typeof U == "string" && y.d.D(U);
  }, Jl.preinit = function(U, E) {
    if (typeof U == "string" && E && typeof E.as == "string") {
      var $ = E.as, H = Rl($, E.crossOrigin), el = typeof E.integrity == "string" ? E.integrity : void 0, gl = typeof E.fetchPriority == "string" ? E.fetchPriority : void 0;
      $ === "style" ? y.d.S(
        U,
        typeof E.precedence == "string" ? E.precedence : void 0,
        {
          crossOrigin: H,
          integrity: el,
          fetchPriority: gl
        }
      ) : $ === "script" && y.d.X(U, {
        crossOrigin: H,
        integrity: el,
        fetchPriority: gl,
        nonce: typeof E.nonce == "string" ? E.nonce : void 0
      });
    }
  }, Jl.preinitModule = function(U, E) {
    if (typeof U == "string")
      if (typeof E == "object" && E !== null) {
        if (E.as == null || E.as === "script") {
          var $ = Rl(
            E.as,
            E.crossOrigin
          );
          y.d.M(U, {
            crossOrigin: $,
            integrity: typeof E.integrity == "string" ? E.integrity : void 0,
            nonce: typeof E.nonce == "string" ? E.nonce : void 0
          });
        }
      } else E == null && y.d.M(U);
  }, Jl.preload = function(U, E) {
    if (typeof U == "string" && typeof E == "object" && E !== null && typeof E.as == "string") {
      var $ = E.as, H = Rl($, E.crossOrigin);
      y.d.L(U, $, {
        crossOrigin: H,
        integrity: typeof E.integrity == "string" ? E.integrity : void 0,
        nonce: typeof E.nonce == "string" ? E.nonce : void 0,
        type: typeof E.type == "string" ? E.type : void 0,
        fetchPriority: typeof E.fetchPriority == "string" ? E.fetchPriority : void 0,
        referrerPolicy: typeof E.referrerPolicy == "string" ? E.referrerPolicy : void 0,
        imageSrcSet: typeof E.imageSrcSet == "string" ? E.imageSrcSet : void 0,
        imageSizes: typeof E.imageSizes == "string" ? E.imageSizes : void 0,
        media: typeof E.media == "string" ? E.media : void 0
      });
    }
  }, Jl.preloadModule = function(U, E) {
    if (typeof U == "string")
      if (E) {
        var $ = Rl(E.as, E.crossOrigin);
        y.d.m(U, {
          as: typeof E.as == "string" && E.as !== "script" ? E.as : void 0,
          crossOrigin: $,
          integrity: typeof E.integrity == "string" ? E.integrity : void 0
        });
      } else y.d.m(U);
  }, Jl.requestFormReset = function(U) {
    y.d.r(U);
  }, Jl.unstable_batchedUpdates = function(U, E) {
    return U(E);
  }, Jl.useFormState = function(U, E, $) {
    return El.H.useFormState(U, E, $);
  }, Jl.useFormStatus = function() {
    return El.H.useHostTransitionStatus();
  }, Jl.version = "19.2.7", Jl;
}
var zr;
function fv() {
  if (zr) return vf.exports;
  zr = 1;
  function N() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(N);
      } catch (yl) {
        console.error(yl);
      }
  }
  return N(), vf.exports = cv(), vf.exports;
}
var Nr;
function sv() {
  if (Nr) return Nn;
  Nr = 1;
  var N = uv(), yl = yf(), F = fv();
  function y(l) {
    var t = "https://react.dev/errors/" + l;
    if (1 < arguments.length) {
      t += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var e = 2; e < arguments.length; e++)
        t += "&args[]=" + encodeURIComponent(arguments[e]);
    }
    return "Minified React error #" + l + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function ml(l) {
    return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
  }
  function sl(l) {
    var t = l, e = l;
    if (l.alternate) for (; t.return; ) t = t.return;
    else {
      l = t;
      do
        t = l, (t.flags & 4098) !== 0 && (e = t.return), l = t.return;
      while (l);
    }
    return t.tag === 3 ? e : null;
  }
  function El(l) {
    if (l.tag === 13) {
      var t = l.memoizedState;
      if (t === null && (l = l.alternate, l !== null && (t = l.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function Rl(l) {
    if (l.tag === 31) {
      var t = l.memoizedState;
      if (t === null && (l = l.alternate, l !== null && (t = l.memoizedState)), t !== null) return t.dehydrated;
    }
    return null;
  }
  function U(l) {
    if (sl(l) !== l)
      throw Error(y(188));
  }
  function E(l) {
    var t = l.alternate;
    if (!t) {
      if (t = sl(l), t === null) throw Error(y(188));
      return t !== l ? null : l;
    }
    for (var e = l, a = t; ; ) {
      var n = e.return;
      if (n === null) break;
      var u = n.alternate;
      if (u === null) {
        if (a = n.return, a !== null) {
          e = a;
          continue;
        }
        break;
      }
      if (n.child === u.child) {
        for (u = n.child; u; ) {
          if (u === e) return U(n), l;
          if (u === a) return U(n), t;
          u = u.sibling;
        }
        throw Error(y(188));
      }
      if (e.return !== a.return) e = n, a = u;
      else {
        for (var i = !1, f = n.child; f; ) {
          if (f === e) {
            i = !0, e = n, a = u;
            break;
          }
          if (f === a) {
            i = !0, a = n, e = u;
            break;
          }
          f = f.sibling;
        }
        if (!i) {
          for (f = u.child; f; ) {
            if (f === e) {
              i = !0, e = u, a = n;
              break;
            }
            if (f === a) {
              i = !0, a = u, e = n;
              break;
            }
            f = f.sibling;
          }
          if (!i) throw Error(y(189));
        }
      }
      if (e.alternate !== a) throw Error(y(190));
    }
    if (e.tag !== 3) throw Error(y(188));
    return e.stateNode.current === e ? l : t;
  }
  function $(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l;
    for (l = l.child; l !== null; ) {
      if (t = $(l), t !== null) return t;
      l = l.sibling;
    }
    return null;
  }
  var H = Object.assign, el = /* @__PURE__ */ Symbol.for("react.element"), gl = /* @__PURE__ */ Symbol.for("react.transitional.element"), Zl = /* @__PURE__ */ Symbol.for("react.portal"), jl = /* @__PURE__ */ Symbol.for("react.fragment"), jt = /* @__PURE__ */ Symbol.for("react.strict_mode"), Al = /* @__PURE__ */ Symbol.for("react.profiler"), Dt = /* @__PURE__ */ Symbol.for("react.consumer"), zl = /* @__PURE__ */ Symbol.for("react.context"), kl = /* @__PURE__ */ Symbol.for("react.forward_ref"), ht = /* @__PURE__ */ Symbol.for("react.suspense"), wl = /* @__PURE__ */ Symbol.for("react.suspense_list"), Z = /* @__PURE__ */ Symbol.for("react.memo"), Vl = /* @__PURE__ */ Symbol.for("react.lazy"), Kl = /* @__PURE__ */ Symbol.for("react.activity"), Ht = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel"), z = Symbol.iterator;
  function O(l) {
    return l === null || typeof l != "object" ? null : (l = z && l[z] || l["@@iterator"], typeof l == "function" ? l : null);
  }
  var ol = /* @__PURE__ */ Symbol.for("react.client.reference");
  function Nl(l) {
    if (l == null) return null;
    if (typeof l == "function")
      return l.$$typeof === ol ? null : l.displayName || l.name || null;
    if (typeof l == "string") return l;
    switch (l) {
      case jl:
        return "Fragment";
      case Al:
        return "Profiler";
      case jt:
        return "StrictMode";
      case ht:
        return "Suspense";
      case wl:
        return "SuspenseList";
      case Kl:
        return "Activity";
    }
    if (typeof l == "object")
      switch (l.$$typeof) {
        case Zl:
          return "Portal";
        case zl:
          return l.displayName || "Context";
        case Dt:
          return (l._context.displayName || "Context") + ".Consumer";
        case kl:
          var t = l.render;
          return l = l.displayName, l || (l = t.displayName || t.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case Z:
          return t = l.displayName || null, t !== null ? t : Nl(l.type) || "Memo";
        case Vl:
          t = l._payload, l = l._init;
          try {
            return Nl(l(t));
          } catch {
          }
      }
    return null;
  }
  var pl = Array.isArray, p = yl.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, j = F.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, C = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, W = [], I = -1;
  function o(l) {
    return { current: l };
  }
  function T(l) {
    0 > I || (l.current = W[I], W[I] = null, I--);
  }
  function A(l, t) {
    I++, W[I] = l.current, l.current = t;
  }
  var _ = o(null), Y = o(null), L = o(null), B = o(null);
  function Ul(l, t) {
    switch (A(L, t), A(Y, l), A(_, null), t.nodeType) {
      case 9:
      case 11:
        l = (l = t.documentElement) && (l = l.namespaceURI) ? Ld(l) : 0;
        break;
      default:
        if (l = t.tagName, t = t.namespaceURI)
          t = Ld(t), l = Zd(t, l);
        else
          switch (l) {
            case "svg":
              l = 1;
              break;
            case "math":
              l = 2;
              break;
            default:
              l = 0;
          }
    }
    T(_), A(_, l);
  }
  function dl() {
    T(_), T(Y), T(L);
  }
  function At(l) {
    l.memoizedState !== null && A(B, l);
    var t = _.current, e = Zd(t, l.type);
    t !== e && (A(Y, l), A(_, e));
  }
  function we(l) {
    Y.current === l && (T(_), T(Y)), B.current === l && (T(B), Tn._currentValue = C);
  }
  var Ua, gf;
  function Ae(l) {
    if (Ua === void 0)
      try {
        throw Error();
      } catch (e) {
        var t = e.stack.trim().match(/\n( *(at )?)/);
        Ua = t && t[1] || "", gf = -1 < e.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Ua + l + gf;
  }
  var Ku = !1;
  function Ju(l, t) {
    if (!l || Ku) return "";
    Ku = !0;
    var e = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var a = {
        DetermineComponentFrameRoot: function() {
          try {
            if (t) {
              var x = function() {
                throw Error();
              };
              if (Object.defineProperty(x.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(x, []);
                } catch (g) {
                  var v = g;
                }
                Reflect.construct(l, [], x);
              } else {
                try {
                  x.call();
                } catch (g) {
                  v = g;
                }
                l.call(x.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (g) {
                v = g;
              }
              (x = l()) && typeof x.catch == "function" && x.catch(function() {
              });
            }
          } catch (g) {
            if (g && v && typeof g.stack == "string")
              return [g.stack, v.stack];
          }
          return [null, null];
        }
      };
      a.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var n = Object.getOwnPropertyDescriptor(
        a.DetermineComponentFrameRoot,
        "name"
      );
      n && n.configurable && Object.defineProperty(
        a.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var u = a.DetermineComponentFrameRoot(), i = u[0], f = u[1];
      if (i && f) {
        var s = i.split(`
`), m = f.split(`
`);
        for (n = a = 0; a < s.length && !s[a].includes("DetermineComponentFrameRoot"); )
          a++;
        for (; n < m.length && !m[n].includes(
          "DetermineComponentFrameRoot"
        ); )
          n++;
        if (a === s.length || n === m.length)
          for (a = s.length - 1, n = m.length - 1; 1 <= a && 0 <= n && s[a] !== m[n]; )
            n--;
        for (; 1 <= a && 0 <= n; a--, n--)
          if (s[a] !== m[n]) {
            if (a !== 1 || n !== 1)
              do
                if (a--, n--, 0 > n || s[a] !== m[n]) {
                  var S = `
` + s[a].replace(" at new ", " at ");
                  return l.displayName && S.includes("<anonymous>") && (S = S.replace("<anonymous>", l.displayName)), S;
                }
              while (1 <= a && 0 <= n);
            break;
          }
      }
    } finally {
      Ku = !1, Error.prepareStackTrace = e;
    }
    return (e = l ? l.displayName || l.name : "") ? Ae(e) : "";
  }
  function Cr(l, t) {
    switch (l.tag) {
      case 26:
      case 27:
      case 5:
        return Ae(l.type);
      case 16:
        return Ae("Lazy");
      case 13:
        return l.child !== t && t !== null ? Ae("Suspense Fallback") : Ae("Suspense");
      case 19:
        return Ae("SuspenseList");
      case 0:
      case 15:
        return Ju(l.type, !1);
      case 11:
        return Ju(l.type.render, !1);
      case 1:
        return Ju(l.type, !0);
      case 31:
        return Ae("Activity");
      default:
        return "";
    }
  }
  function pf(l) {
    try {
      var t = "", e = null;
      do
        t += Cr(l, e), e = l, l = l.return;
      while (l);
      return t;
    } catch (a) {
      return `
Error generating stack: ` + a.message + `
` + a.stack;
    }
  }
  var Wu = Object.prototype.hasOwnProperty, ku = N.unstable_scheduleCallback, $u = N.unstable_cancelCallback, Rr = N.unstable_shouldYield, Hr = N.unstable_requestPaint, at = N.unstable_now, qr = N.unstable_getCurrentPriorityLevel, Sf = N.unstable_ImmediatePriority, bf = N.unstable_UserBlockingPriority, _n = N.unstable_NormalPriority, Br = N.unstable_LowPriority, xf = N.unstable_IdlePriority, Yr = N.log, Gr = N.unstable_setDisableYieldValue, Ca = null, nt = null;
  function le(l) {
    if (typeof Yr == "function" && Gr(l), nt && typeof nt.setStrictMode == "function")
      try {
        nt.setStrictMode(Ca, l);
      } catch {
      }
  }
  var ut = Math.clz32 ? Math.clz32 : Lr, Xr = Math.log, Qr = Math.LN2;
  function Lr(l) {
    return l >>>= 0, l === 0 ? 32 : 31 - (Xr(l) / Qr | 0) | 0;
  }
  var Dn = 256, Mn = 262144, Un = 4194304;
  function ze(l) {
    var t = l & 42;
    if (t !== 0) return t;
    switch (l & -l) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return l & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return l & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return l & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return l;
    }
  }
  function Cn(l, t, e) {
    var a = l.pendingLanes;
    if (a === 0) return 0;
    var n = 0, u = l.suspendedLanes, i = l.pingedLanes;
    l = l.warmLanes;
    var f = a & 134217727;
    return f !== 0 ? (a = f & ~u, a !== 0 ? n = ze(a) : (i &= f, i !== 0 ? n = ze(i) : e || (e = f & ~l, e !== 0 && (n = ze(e))))) : (f = a & ~u, f !== 0 ? n = ze(f) : i !== 0 ? n = ze(i) : e || (e = a & ~l, e !== 0 && (n = ze(e)))), n === 0 ? 0 : t !== 0 && t !== n && (t & u) === 0 && (u = n & -n, e = t & -t, u >= e || u === 32 && (e & 4194048) !== 0) ? t : n;
  }
  function Ra(l, t) {
    return (l.pendingLanes & ~(l.suspendedLanes & ~l.pingedLanes) & t) === 0;
  }
  function Zr(l, t) {
    switch (l) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return t + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Tf() {
    var l = Un;
    return Un <<= 1, (Un & 62914560) === 0 && (Un = 4194304), l;
  }
  function Fu(l) {
    for (var t = [], e = 0; 31 > e; e++) t.push(l);
    return t;
  }
  function Ha(l, t) {
    l.pendingLanes |= t, t !== 268435456 && (l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0);
  }
  function wr(l, t, e, a, n, u) {
    var i = l.pendingLanes;
    l.pendingLanes = e, l.suspendedLanes = 0, l.pingedLanes = 0, l.warmLanes = 0, l.expiredLanes &= e, l.entangledLanes &= e, l.errorRecoveryDisabledLanes &= e, l.shellSuspendCounter = 0;
    var f = l.entanglements, s = l.expirationTimes, m = l.hiddenUpdates;
    for (e = i & ~e; 0 < e; ) {
      var S = 31 - ut(e), x = 1 << S;
      f[S] = 0, s[S] = -1;
      var v = m[S];
      if (v !== null)
        for (m[S] = null, S = 0; S < v.length; S++) {
          var g = v[S];
          g !== null && (g.lane &= -536870913);
        }
      e &= ~x;
    }
    a !== 0 && Ef(l, a, 0), u !== 0 && n === 0 && l.tag !== 0 && (l.suspendedLanes |= u & ~(i & ~t));
  }
  function Ef(l, t, e) {
    l.pendingLanes |= t, l.suspendedLanes &= ~t;
    var a = 31 - ut(t);
    l.entangledLanes |= t, l.entanglements[a] = l.entanglements[a] | 1073741824 | e & 261930;
  }
  function jf(l, t) {
    var e = l.entangledLanes |= t;
    for (l = l.entanglements; e; ) {
      var a = 31 - ut(e), n = 1 << a;
      n & t | l[a] & t && (l[a] |= t), e &= ~n;
    }
  }
  function Af(l, t) {
    var e = t & -t;
    return e = (e & 42) !== 0 ? 1 : Iu(e), (e & (l.suspendedLanes | t)) !== 0 ? 0 : e;
  }
  function Iu(l) {
    switch (l) {
      case 2:
        l = 1;
        break;
      case 8:
        l = 4;
        break;
      case 32:
        l = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        l = 128;
        break;
      case 268435456:
        l = 134217728;
        break;
      default:
        l = 0;
    }
    return l;
  }
  function Pu(l) {
    return l &= -l, 2 < l ? 8 < l ? (l & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function zf() {
    var l = j.p;
    return l !== 0 ? l : (l = window.event, l === void 0 ? 32 : rr(l.type));
  }
  function Nf(l, t) {
    var e = j.p;
    try {
      return j.p = l, t();
    } finally {
      j.p = e;
    }
  }
  var te = Math.random().toString(36).slice(2), Bl = "__reactFiber$" + te, $l = "__reactProps$" + te, Ve = "__reactContainer$" + te, li = "__reactEvents$" + te, Vr = "__reactListeners$" + te, Kr = "__reactHandles$" + te, Of = "__reactResources$" + te, qa = "__reactMarker$" + te;
  function ti(l) {
    delete l[Bl], delete l[$l], delete l[li], delete l[Vr], delete l[Kr];
  }
  function Ke(l) {
    var t = l[Bl];
    if (t) return t;
    for (var e = l.parentNode; e; ) {
      if (t = e[Ve] || e[Bl]) {
        if (e = t.alternate, t.child !== null || e !== null && e.child !== null)
          for (l = $d(l); l !== null; ) {
            if (e = l[Bl]) return e;
            l = $d(l);
          }
        return t;
      }
      l = e, e = l.parentNode;
    }
    return null;
  }
  function Je(l) {
    if (l = l[Bl] || l[Ve]) {
      var t = l.tag;
      if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3)
        return l;
    }
    return null;
  }
  function Ba(l) {
    var t = l.tag;
    if (t === 5 || t === 26 || t === 27 || t === 6) return l.stateNode;
    throw Error(y(33));
  }
  function We(l) {
    var t = l[Of];
    return t || (t = l[Of] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), t;
  }
  function Hl(l) {
    l[qa] = !0;
  }
  var _f = /* @__PURE__ */ new Set(), Df = {};
  function Ne(l, t) {
    ke(l, t), ke(l + "Capture", t);
  }
  function ke(l, t) {
    for (Df[l] = t, l = 0; l < t.length; l++)
      _f.add(t[l]);
  }
  var Jr = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), Mf = {}, Uf = {};
  function Wr(l) {
    return Wu.call(Uf, l) ? !0 : Wu.call(Mf, l) ? !1 : Jr.test(l) ? Uf[l] = !0 : (Mf[l] = !0, !1);
  }
  function Rn(l, t, e) {
    if (Wr(t))
      if (e === null) l.removeAttribute(t);
      else {
        switch (typeof e) {
          case "undefined":
          case "function":
          case "symbol":
            l.removeAttribute(t);
            return;
          case "boolean":
            var a = t.toLowerCase().slice(0, 5);
            if (a !== "data-" && a !== "aria-") {
              l.removeAttribute(t);
              return;
            }
        }
        l.setAttribute(t, "" + e);
      }
  }
  function Hn(l, t, e) {
    if (e === null) l.removeAttribute(t);
    else {
      switch (typeof e) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(t);
          return;
      }
      l.setAttribute(t, "" + e);
    }
  }
  function qt(l, t, e, a) {
    if (a === null) l.removeAttribute(e);
    else {
      switch (typeof a) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          l.removeAttribute(e);
          return;
      }
      l.setAttributeNS(t, e, "" + a);
    }
  }
  function mt(l) {
    switch (typeof l) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return l;
      case "object":
        return l;
      default:
        return "";
    }
  }
  function Cf(l) {
    var t = l.type;
    return (l = l.nodeName) && l.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
  }
  function kr(l, t, e) {
    var a = Object.getOwnPropertyDescriptor(
      l.constructor.prototype,
      t
    );
    if (!l.hasOwnProperty(t) && typeof a < "u" && typeof a.get == "function" && typeof a.set == "function") {
      var n = a.get, u = a.set;
      return Object.defineProperty(l, t, {
        configurable: !0,
        get: function() {
          return n.call(this);
        },
        set: function(i) {
          e = "" + i, u.call(this, i);
        }
      }), Object.defineProperty(l, t, {
        enumerable: a.enumerable
      }), {
        getValue: function() {
          return e;
        },
        setValue: function(i) {
          e = "" + i;
        },
        stopTracking: function() {
          l._valueTracker = null, delete l[t];
        }
      };
    }
  }
  function ei(l) {
    if (!l._valueTracker) {
      var t = Cf(l) ? "checked" : "value";
      l._valueTracker = kr(
        l,
        t,
        "" + l[t]
      );
    }
  }
  function Rf(l) {
    if (!l) return !1;
    var t = l._valueTracker;
    if (!t) return !0;
    var e = t.getValue(), a = "";
    return l && (a = Cf(l) ? l.checked ? "true" : "false" : l.value), l = a, l !== e ? (t.setValue(l), !0) : !1;
  }
  function qn(l) {
    if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
    try {
      return l.activeElement || l.body;
    } catch {
      return l.body;
    }
  }
  var $r = /[\n"\\]/g;
  function vt(l) {
    return l.replace(
      $r,
      function(t) {
        return "\\" + t.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function ai(l, t, e, a, n, u, i, f) {
    l.name = "", i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" ? l.type = i : l.removeAttribute("type"), t != null ? i === "number" ? (t === 0 && l.value === "" || l.value != t) && (l.value = "" + mt(t)) : l.value !== "" + mt(t) && (l.value = "" + mt(t)) : i !== "submit" && i !== "reset" || l.removeAttribute("value"), t != null ? ni(l, i, mt(t)) : e != null ? ni(l, i, mt(e)) : a != null && l.removeAttribute("value"), n == null && u != null && (l.defaultChecked = !!u), n != null && (l.checked = n && typeof n != "function" && typeof n != "symbol"), f != null && typeof f != "function" && typeof f != "symbol" && typeof f != "boolean" ? l.name = "" + mt(f) : l.removeAttribute("name");
  }
  function Hf(l, t, e, a, n, u, i, f) {
    if (u != null && typeof u != "function" && typeof u != "symbol" && typeof u != "boolean" && (l.type = u), t != null || e != null) {
      if (!(u !== "submit" && u !== "reset" || t != null)) {
        ei(l);
        return;
      }
      e = e != null ? "" + mt(e) : "", t = t != null ? "" + mt(t) : e, f || t === l.value || (l.value = t), l.defaultValue = t;
    }
    a = a ?? n, a = typeof a != "function" && typeof a != "symbol" && !!a, l.checked = f ? l.checked : !!a, l.defaultChecked = !!a, i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" && (l.name = i), ei(l);
  }
  function ni(l, t, e) {
    t === "number" && qn(l.ownerDocument) === l || l.defaultValue === "" + e || (l.defaultValue = "" + e);
  }
  function $e(l, t, e, a) {
    if (l = l.options, t) {
      t = {};
      for (var n = 0; n < e.length; n++)
        t["$" + e[n]] = !0;
      for (e = 0; e < l.length; e++)
        n = t.hasOwnProperty("$" + l[e].value), l[e].selected !== n && (l[e].selected = n), n && a && (l[e].defaultSelected = !0);
    } else {
      for (e = "" + mt(e), t = null, n = 0; n < l.length; n++) {
        if (l[n].value === e) {
          l[n].selected = !0, a && (l[n].defaultSelected = !0);
          return;
        }
        t !== null || l[n].disabled || (t = l[n]);
      }
      t !== null && (t.selected = !0);
    }
  }
  function qf(l, t, e) {
    if (t != null && (t = "" + mt(t), t !== l.value && (l.value = t), e == null)) {
      l.defaultValue !== t && (l.defaultValue = t);
      return;
    }
    l.defaultValue = e != null ? "" + mt(e) : "";
  }
  function Bf(l, t, e, a) {
    if (t == null) {
      if (a != null) {
        if (e != null) throw Error(y(92));
        if (pl(a)) {
          if (1 < a.length) throw Error(y(93));
          a = a[0];
        }
        e = a;
      }
      e == null && (e = ""), t = e;
    }
    e = mt(t), l.defaultValue = e, a = l.textContent, a === e && a !== "" && a !== null && (l.value = a), ei(l);
  }
  function Fe(l, t) {
    if (t) {
      var e = l.firstChild;
      if (e && e === l.lastChild && e.nodeType === 3) {
        e.nodeValue = t;
        return;
      }
    }
    l.textContent = t;
  }
  var Fr = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function Yf(l, t, e) {
    var a = t.indexOf("--") === 0;
    e == null || typeof e == "boolean" || e === "" ? a ? l.setProperty(t, "") : t === "float" ? l.cssFloat = "" : l[t] = "" : a ? l.setProperty(t, e) : typeof e != "number" || e === 0 || Fr.has(t) ? t === "float" ? l.cssFloat = e : l[t] = ("" + e).trim() : l[t] = e + "px";
  }
  function Gf(l, t, e) {
    if (t != null && typeof t != "object")
      throw Error(y(62));
    if (l = l.style, e != null) {
      for (var a in e)
        !e.hasOwnProperty(a) || t != null && t.hasOwnProperty(a) || (a.indexOf("--") === 0 ? l.setProperty(a, "") : a === "float" ? l.cssFloat = "" : l[a] = "");
      for (var n in t)
        a = t[n], t.hasOwnProperty(n) && e[n] !== a && Yf(l, n, a);
    } else
      for (var u in t)
        t.hasOwnProperty(u) && Yf(l, u, t[u]);
  }
  function ui(l) {
    if (l.indexOf("-") === -1) return !1;
    switch (l) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ir = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Pr = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Bn(l) {
    return Pr.test("" + l) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : l;
  }
  function Bt() {
  }
  var ii = null;
  function ci(l) {
    return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
  }
  var Ie = null, Pe = null;
  function Xf(l) {
    var t = Je(l);
    if (t && (l = t.stateNode)) {
      var e = l[$l] || null;
      l: switch (l = t.stateNode, t.type) {
        case "input":
          if (ai(
            l,
            e.value,
            e.defaultValue,
            e.defaultValue,
            e.checked,
            e.defaultChecked,
            e.type,
            e.name
          ), t = e.name, e.type === "radio" && t != null) {
            for (e = l; e.parentNode; ) e = e.parentNode;
            for (e = e.querySelectorAll(
              'input[name="' + vt(
                "" + t
              ) + '"][type="radio"]'
            ), t = 0; t < e.length; t++) {
              var a = e[t];
              if (a !== l && a.form === l.form) {
                var n = a[$l] || null;
                if (!n) throw Error(y(90));
                ai(
                  a,
                  n.value,
                  n.defaultValue,
                  n.defaultValue,
                  n.checked,
                  n.defaultChecked,
                  n.type,
                  n.name
                );
              }
            }
            for (t = 0; t < e.length; t++)
              a = e[t], a.form === l.form && Rf(a);
          }
          break l;
        case "textarea":
          qf(l, e.value, e.defaultValue);
          break l;
        case "select":
          t = e.value, t != null && $e(l, !!e.multiple, t, !1);
      }
    }
  }
  var fi = !1;
  function Qf(l, t, e) {
    if (fi) return l(t, e);
    fi = !0;
    try {
      var a = l(t);
      return a;
    } finally {
      if (fi = !1, (Ie !== null || Pe !== null) && (ju(), Ie && (t = Ie, l = Pe, Pe = Ie = null, Xf(t), l)))
        for (t = 0; t < l.length; t++) Xf(l[t]);
    }
  }
  function Ya(l, t) {
    var e = l.stateNode;
    if (e === null) return null;
    var a = e[$l] || null;
    if (a === null) return null;
    e = a[t];
    l: switch (t) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (a = !a.disabled) || (l = l.type, a = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !a;
        break l;
      default:
        l = !1;
    }
    if (l) return null;
    if (e && typeof e != "function")
      throw Error(
        y(231, t, typeof e)
      );
    return e;
  }
  var Yt = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), si = !1;
  if (Yt)
    try {
      var Ga = {};
      Object.defineProperty(Ga, "passive", {
        get: function() {
          si = !0;
        }
      }), window.addEventListener("test", Ga, Ga), window.removeEventListener("test", Ga, Ga);
    } catch {
      si = !1;
    }
  var ee = null, oi = null, Yn = null;
  function Lf() {
    if (Yn) return Yn;
    var l, t = oi, e = t.length, a, n = "value" in ee ? ee.value : ee.textContent, u = n.length;
    for (l = 0; l < e && t[l] === n[l]; l++) ;
    var i = e - l;
    for (a = 1; a <= i && t[e - a] === n[u - a]; a++) ;
    return Yn = n.slice(l, 1 < a ? 1 - a : void 0);
  }
  function Gn(l) {
    var t = l.keyCode;
    return "charCode" in l ? (l = l.charCode, l === 0 && t === 13 && (l = 13)) : l = t, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
  }
  function Xn() {
    return !0;
  }
  function Zf() {
    return !1;
  }
  function Fl(l) {
    function t(e, a, n, u, i) {
      this._reactName = e, this._targetInst = n, this.type = a, this.nativeEvent = u, this.target = i, this.currentTarget = null;
      for (var f in l)
        l.hasOwnProperty(f) && (e = l[f], this[f] = e ? e(u) : u[f]);
      return this.isDefaultPrevented = (u.defaultPrevented != null ? u.defaultPrevented : u.returnValue === !1) ? Xn : Zf, this.isPropagationStopped = Zf, this;
    }
    return H(t.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var e = this.nativeEvent;
        e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = Xn);
      },
      stopPropagation: function() {
        var e = this.nativeEvent;
        e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = Xn);
      },
      persist: function() {
      },
      isPersistent: Xn
    }), t;
  }
  var Oe = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(l) {
      return l.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Qn = Fl(Oe), Xa = H({}, Oe, { view: 0, detail: 0 }), lh = Fl(Xa), di, ri, Qa, Ln = H({}, Xa, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: mi,
    button: 0,
    buttons: 0,
    relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    },
    movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== Qa && (Qa && l.type === "mousemove" ? (di = l.screenX - Qa.screenX, ri = l.screenY - Qa.screenY) : ri = di = 0, Qa = l), di);
    },
    movementY: function(l) {
      return "movementY" in l ? l.movementY : ri;
    }
  }), wf = Fl(Ln), th = H({}, Ln, { dataTransfer: 0 }), eh = Fl(th), ah = H({}, Xa, { relatedTarget: 0 }), hi = Fl(ah), nh = H({}, Oe, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), uh = Fl(nh), ih = H({}, Oe, {
    clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    }
  }), ch = Fl(ih), fh = H({}, Oe, { data: 0 }), Vf = Fl(fh), sh = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, oh = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, dh = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function rh(l) {
    var t = this.nativeEvent;
    return t.getModifierState ? t.getModifierState(l) : (l = dh[l]) ? !!t[l] : !1;
  }
  function mi() {
    return rh;
  }
  var hh = H({}, Xa, {
    key: function(l) {
      if (l.key) {
        var t = sh[l.key] || l.key;
        if (t !== "Unidentified") return t;
      }
      return l.type === "keypress" ? (l = Gn(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? oh[l.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: mi,
    charCode: function(l) {
      return l.type === "keypress" ? Gn(l) : 0;
    },
    keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    },
    which: function(l) {
      return l.type === "keypress" ? Gn(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }
  }), mh = Fl(hh), vh = H({}, Ln, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), Kf = Fl(vh), yh = H({}, Xa, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: mi
  }), gh = Fl(yh), ph = H({}, Oe, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Sh = Fl(ph), bh = H({}, Ln, {
    deltaX: function(l) {
      return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
    },
    deltaY: function(l) {
      return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), xh = Fl(bh), Th = H({}, Oe, {
    newState: 0,
    oldState: 0
  }), Eh = Fl(Th), jh = [9, 13, 27, 32], vi = Yt && "CompositionEvent" in window, La = null;
  Yt && "documentMode" in document && (La = document.documentMode);
  var Ah = Yt && "TextEvent" in window && !La, Jf = Yt && (!vi || La && 8 < La && 11 >= La), Wf = " ", kf = !1;
  function $f(l, t) {
    switch (l) {
      case "keyup":
        return jh.indexOf(t.keyCode) !== -1;
      case "keydown":
        return t.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function Ff(l) {
    return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
  }
  var la = !1;
  function zh(l, t) {
    switch (l) {
      case "compositionend":
        return Ff(t);
      case "keypress":
        return t.which !== 32 ? null : (kf = !0, Wf);
      case "textInput":
        return l = t.data, l === Wf && kf ? null : l;
      default:
        return null;
    }
  }
  function Nh(l, t) {
    if (la)
      return l === "compositionend" || !vi && $f(l, t) ? (l = Lf(), Yn = oi = ee = null, la = !1, l) : null;
    switch (l) {
      case "paste":
        return null;
      case "keypress":
        if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
          if (t.char && 1 < t.char.length)
            return t.char;
          if (t.which) return String.fromCharCode(t.which);
        }
        return null;
      case "compositionend":
        return Jf && t.locale !== "ko" ? null : t.data;
      default:
        return null;
    }
  }
  var Oh = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function If(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t === "input" ? !!Oh[l.type] : t === "textarea";
  }
  function Pf(l, t, e, a) {
    Ie ? Pe ? Pe.push(a) : Pe = [a] : Ie = a, t = Mu(t, "onChange"), 0 < t.length && (e = new Qn(
      "onChange",
      "change",
      null,
      e,
      a
    ), l.push({ event: e, listeners: t }));
  }
  var Za = null, wa = null;
  function _h(l) {
    qd(l, 0);
  }
  function Zn(l) {
    var t = Ba(l);
    if (Rf(t)) return l;
  }
  function ls(l, t) {
    if (l === "change") return t;
  }
  var ts = !1;
  if (Yt) {
    var yi;
    if (Yt) {
      var gi = "oninput" in document;
      if (!gi) {
        var es = document.createElement("div");
        es.setAttribute("oninput", "return;"), gi = typeof es.oninput == "function";
      }
      yi = gi;
    } else yi = !1;
    ts = yi && (!document.documentMode || 9 < document.documentMode);
  }
  function as() {
    Za && (Za.detachEvent("onpropertychange", ns), wa = Za = null);
  }
  function ns(l) {
    if (l.propertyName === "value" && Zn(wa)) {
      var t = [];
      Pf(
        t,
        wa,
        l,
        ci(l)
      ), Qf(_h, t);
    }
  }
  function Dh(l, t, e) {
    l === "focusin" ? (as(), Za = t, wa = e, Za.attachEvent("onpropertychange", ns)) : l === "focusout" && as();
  }
  function Mh(l) {
    if (l === "selectionchange" || l === "keyup" || l === "keydown")
      return Zn(wa);
  }
  function Uh(l, t) {
    if (l === "click") return Zn(t);
  }
  function Ch(l, t) {
    if (l === "input" || l === "change")
      return Zn(t);
  }
  function Rh(l, t) {
    return l === t && (l !== 0 || 1 / l === 1 / t) || l !== l && t !== t;
  }
  var it = typeof Object.is == "function" ? Object.is : Rh;
  function Va(l, t) {
    if (it(l, t)) return !0;
    if (typeof l != "object" || l === null || typeof t != "object" || t === null)
      return !1;
    var e = Object.keys(l), a = Object.keys(t);
    if (e.length !== a.length) return !1;
    for (a = 0; a < e.length; a++) {
      var n = e[a];
      if (!Wu.call(t, n) || !it(l[n], t[n]))
        return !1;
    }
    return !0;
  }
  function us(l) {
    for (; l && l.firstChild; ) l = l.firstChild;
    return l;
  }
  function is(l, t) {
    var e = us(l);
    l = 0;
    for (var a; e; ) {
      if (e.nodeType === 3) {
        if (a = l + e.textContent.length, l <= t && a >= t)
          return { node: e, offset: t - l };
        l = a;
      }
      l: {
        for (; e; ) {
          if (e.nextSibling) {
            e = e.nextSibling;
            break l;
          }
          e = e.parentNode;
        }
        e = void 0;
      }
      e = us(e);
    }
  }
  function cs(l, t) {
    return l && t ? l === t ? !0 : l && l.nodeType === 3 ? !1 : t && t.nodeType === 3 ? cs(l, t.parentNode) : "contains" in l ? l.contains(t) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(t) & 16) : !1 : !1;
  }
  function fs(l) {
    l = l != null && l.ownerDocument != null && l.ownerDocument.defaultView != null ? l.ownerDocument.defaultView : window;
    for (var t = qn(l.document); t instanceof l.HTMLIFrameElement; ) {
      try {
        var e = typeof t.contentWindow.location.href == "string";
      } catch {
        e = !1;
      }
      if (e) l = t.contentWindow;
      else break;
      t = qn(l.document);
    }
    return t;
  }
  function pi(l) {
    var t = l && l.nodeName && l.nodeName.toLowerCase();
    return t && (t === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || t === "textarea" || l.contentEditable === "true");
  }
  var Hh = Yt && "documentMode" in document && 11 >= document.documentMode, ta = null, Si = null, Ka = null, bi = !1;
  function ss(l, t, e) {
    var a = e.window === e ? e.document : e.nodeType === 9 ? e : e.ownerDocument;
    bi || ta == null || ta !== qn(a) || (a = ta, "selectionStart" in a && pi(a) ? a = { start: a.selectionStart, end: a.selectionEnd } : (a = (a.ownerDocument && a.ownerDocument.defaultView || window).getSelection(), a = {
      anchorNode: a.anchorNode,
      anchorOffset: a.anchorOffset,
      focusNode: a.focusNode,
      focusOffset: a.focusOffset
    }), Ka && Va(Ka, a) || (Ka = a, a = Mu(Si, "onSelect"), 0 < a.length && (t = new Qn(
      "onSelect",
      "select",
      null,
      t,
      e
    ), l.push({ event: t, listeners: a }), t.target = ta)));
  }
  function _e(l, t) {
    var e = {};
    return e[l.toLowerCase()] = t.toLowerCase(), e["Webkit" + l] = "webkit" + t, e["Moz" + l] = "moz" + t, e;
  }
  var ea = {
    animationend: _e("Animation", "AnimationEnd"),
    animationiteration: _e("Animation", "AnimationIteration"),
    animationstart: _e("Animation", "AnimationStart"),
    transitionrun: _e("Transition", "TransitionRun"),
    transitionstart: _e("Transition", "TransitionStart"),
    transitioncancel: _e("Transition", "TransitionCancel"),
    transitionend: _e("Transition", "TransitionEnd")
  }, xi = {}, os = {};
  Yt && (os = document.createElement("div").style, "AnimationEvent" in window || (delete ea.animationend.animation, delete ea.animationiteration.animation, delete ea.animationstart.animation), "TransitionEvent" in window || delete ea.transitionend.transition);
  function De(l) {
    if (xi[l]) return xi[l];
    if (!ea[l]) return l;
    var t = ea[l], e;
    for (e in t)
      if (t.hasOwnProperty(e) && e in os)
        return xi[l] = t[e];
    return l;
  }
  var ds = De("animationend"), rs = De("animationiteration"), hs = De("animationstart"), qh = De("transitionrun"), Bh = De("transitionstart"), Yh = De("transitioncancel"), ms = De("transitionend"), vs = /* @__PURE__ */ new Map(), Ti = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Ti.push("scrollEnd");
  function zt(l, t) {
    vs.set(l, t), Ne(t, [l]);
  }
  var wn = typeof reportError == "function" ? reportError : function(l) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var t = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof l == "object" && l !== null && typeof l.message == "string" ? String(l.message) : String(l),
        error: l
      });
      if (!window.dispatchEvent(t)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", l);
      return;
    }
    console.error(l);
  }, yt = [], aa = 0, Ei = 0;
  function Vn() {
    for (var l = aa, t = Ei = aa = 0; t < l; ) {
      var e = yt[t];
      yt[t++] = null;
      var a = yt[t];
      yt[t++] = null;
      var n = yt[t];
      yt[t++] = null;
      var u = yt[t];
      if (yt[t++] = null, a !== null && n !== null) {
        var i = a.pending;
        i === null ? n.next = n : (n.next = i.next, i.next = n), a.pending = n;
      }
      u !== 0 && ys(e, n, u);
    }
  }
  function Kn(l, t, e, a) {
    yt[aa++] = l, yt[aa++] = t, yt[aa++] = e, yt[aa++] = a, Ei |= a, l.lanes |= a, l = l.alternate, l !== null && (l.lanes |= a);
  }
  function ji(l, t, e, a) {
    return Kn(l, t, e, a), Jn(l);
  }
  function Me(l, t) {
    return Kn(l, null, null, t), Jn(l);
  }
  function ys(l, t, e) {
    l.lanes |= e;
    var a = l.alternate;
    a !== null && (a.lanes |= e);
    for (var n = !1, u = l.return; u !== null; )
      u.childLanes |= e, a = u.alternate, a !== null && (a.childLanes |= e), u.tag === 22 && (l = u.stateNode, l === null || l._visibility & 1 || (n = !0)), l = u, u = u.return;
    return l.tag === 3 ? (u = l.stateNode, n && t !== null && (n = 31 - ut(e), l = u.hiddenUpdates, a = l[n], a === null ? l[n] = [t] : a.push(t), t.lane = e | 536870912), u) : null;
  }
  function Jn(l) {
    if (50 < vn)
      throw vn = 0, Cc = null, Error(y(185));
    for (var t = l.return; t !== null; )
      l = t, t = l.return;
    return l.tag === 3 ? l.stateNode : null;
  }
  var na = {};
  function Gh(l, t, e, a) {
    this.tag = l, this.key = e, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = a, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function ct(l, t, e, a) {
    return new Gh(l, t, e, a);
  }
  function Ai(l) {
    return l = l.prototype, !(!l || !l.isReactComponent);
  }
  function Gt(l, t) {
    var e = l.alternate;
    return e === null ? (e = ct(
      l.tag,
      t,
      l.key,
      l.mode
    ), e.elementType = l.elementType, e.type = l.type, e.stateNode = l.stateNode, e.alternate = l, l.alternate = e) : (e.pendingProps = t, e.type = l.type, e.flags = 0, e.subtreeFlags = 0, e.deletions = null), e.flags = l.flags & 65011712, e.childLanes = l.childLanes, e.lanes = l.lanes, e.child = l.child, e.memoizedProps = l.memoizedProps, e.memoizedState = l.memoizedState, e.updateQueue = l.updateQueue, t = l.dependencies, e.dependencies = t === null ? null : { lanes: t.lanes, firstContext: t.firstContext }, e.sibling = l.sibling, e.index = l.index, e.ref = l.ref, e.refCleanup = l.refCleanup, e;
  }
  function gs(l, t) {
    l.flags &= 65011714;
    var e = l.alternate;
    return e === null ? (l.childLanes = 0, l.lanes = t, l.child = null, l.subtreeFlags = 0, l.memoizedProps = null, l.memoizedState = null, l.updateQueue = null, l.dependencies = null, l.stateNode = null) : (l.childLanes = e.childLanes, l.lanes = e.lanes, l.child = e.child, l.subtreeFlags = 0, l.deletions = null, l.memoizedProps = e.memoizedProps, l.memoizedState = e.memoizedState, l.updateQueue = e.updateQueue, l.type = e.type, t = e.dependencies, l.dependencies = t === null ? null : {
      lanes: t.lanes,
      firstContext: t.firstContext
    }), l;
  }
  function Wn(l, t, e, a, n, u) {
    var i = 0;
    if (a = l, typeof l == "function") Ai(l) && (i = 1);
    else if (typeof l == "string")
      i = wm(
        l,
        e,
        _.current
      ) ? 26 : l === "html" || l === "head" || l === "body" ? 27 : 5;
    else
      l: switch (l) {
        case Kl:
          return l = ct(31, e, t, n), l.elementType = Kl, l.lanes = u, l;
        case jl:
          return Ue(e.children, n, u, t);
        case jt:
          i = 8, n |= 24;
          break;
        case Al:
          return l = ct(12, e, t, n | 2), l.elementType = Al, l.lanes = u, l;
        case ht:
          return l = ct(13, e, t, n), l.elementType = ht, l.lanes = u, l;
        case wl:
          return l = ct(19, e, t, n), l.elementType = wl, l.lanes = u, l;
        default:
          if (typeof l == "object" && l !== null)
            switch (l.$$typeof) {
              case zl:
                i = 10;
                break l;
              case Dt:
                i = 9;
                break l;
              case kl:
                i = 11;
                break l;
              case Z:
                i = 14;
                break l;
              case Vl:
                i = 16, a = null;
                break l;
            }
          i = 29, e = Error(
            y(130, l === null ? "null" : typeof l, "")
          ), a = null;
      }
    return t = ct(i, e, t, n), t.elementType = l, t.type = a, t.lanes = u, t;
  }
  function Ue(l, t, e, a) {
    return l = ct(7, l, a, t), l.lanes = e, l;
  }
  function zi(l, t, e) {
    return l = ct(6, l, null, t), l.lanes = e, l;
  }
  function ps(l) {
    var t = ct(18, null, null, 0);
    return t.stateNode = l, t;
  }
  function Ni(l, t, e) {
    return t = ct(
      4,
      l.children !== null ? l.children : [],
      l.key,
      t
    ), t.lanes = e, t.stateNode = {
      containerInfo: l.containerInfo,
      pendingChildren: null,
      implementation: l.implementation
    }, t;
  }
  var Ss = /* @__PURE__ */ new WeakMap();
  function gt(l, t) {
    if (typeof l == "object" && l !== null) {
      var e = Ss.get(l);
      return e !== void 0 ? e : (t = {
        value: l,
        source: t,
        stack: pf(t)
      }, Ss.set(l, t), t);
    }
    return {
      value: l,
      source: t,
      stack: pf(t)
    };
  }
  var ua = [], ia = 0, kn = null, Ja = 0, pt = [], St = 0, ae = null, Mt = 1, Ut = "";
  function Xt(l, t) {
    ua[ia++] = Ja, ua[ia++] = kn, kn = l, Ja = t;
  }
  function bs(l, t, e) {
    pt[St++] = Mt, pt[St++] = Ut, pt[St++] = ae, ae = l;
    var a = Mt;
    l = Ut;
    var n = 32 - ut(a) - 1;
    a &= ~(1 << n), e += 1;
    var u = 32 - ut(t) + n;
    if (30 < u) {
      var i = n - n % 5;
      u = (a & (1 << i) - 1).toString(32), a >>= i, n -= i, Mt = 1 << 32 - ut(t) + n | e << n | a, Ut = u + l;
    } else
      Mt = 1 << u | e << n | a, Ut = l;
  }
  function Oi(l) {
    l.return !== null && (Xt(l, 1), bs(l, 1, 0));
  }
  function _i(l) {
    for (; l === kn; )
      kn = ua[--ia], ua[ia] = null, Ja = ua[--ia], ua[ia] = null;
    for (; l === ae; )
      ae = pt[--St], pt[St] = null, Ut = pt[--St], pt[St] = null, Mt = pt[--St], pt[St] = null;
  }
  function xs(l, t) {
    pt[St++] = Mt, pt[St++] = Ut, pt[St++] = ae, Mt = t.id, Ut = t.overflow, ae = l;
  }
  var Yl = null, rl = null, k = !1, ne = null, bt = !1, Di = Error(y(519));
  function ue(l) {
    var t = Error(
      y(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw Wa(gt(t, l)), Di;
  }
  function Ts(l) {
    var t = l.stateNode, e = l.type, a = l.memoizedProps;
    switch (t[Bl] = l, t[$l] = a, e) {
      case "dialog":
        V("cancel", t), V("close", t);
        break;
      case "iframe":
      case "object":
      case "embed":
        V("load", t);
        break;
      case "video":
      case "audio":
        for (e = 0; e < gn.length; e++)
          V(gn[e], t);
        break;
      case "source":
        V("error", t);
        break;
      case "img":
      case "image":
      case "link":
        V("error", t), V("load", t);
        break;
      case "details":
        V("toggle", t);
        break;
      case "input":
        V("invalid", t), Hf(
          t,
          a.value,
          a.defaultValue,
          a.checked,
          a.defaultChecked,
          a.type,
          a.name,
          !0
        );
        break;
      case "select":
        V("invalid", t);
        break;
      case "textarea":
        V("invalid", t), Bf(t, a.value, a.defaultValue, a.children);
    }
    e = a.children, typeof e != "string" && typeof e != "number" && typeof e != "bigint" || t.textContent === "" + e || a.suppressHydrationWarning === !0 || Xd(t.textContent, e) ? (a.popover != null && (V("beforetoggle", t), V("toggle", t)), a.onScroll != null && V("scroll", t), a.onScrollEnd != null && V("scrollend", t), a.onClick != null && (t.onclick = Bt), t = !0) : t = !1, t || ue(l, !0);
  }
  function Es(l) {
    for (Yl = l.return; Yl; )
      switch (Yl.tag) {
        case 5:
        case 31:
        case 13:
          bt = !1;
          return;
        case 27:
        case 3:
          bt = !0;
          return;
        default:
          Yl = Yl.return;
      }
  }
  function ca(l) {
    if (l !== Yl) return !1;
    if (!k) return Es(l), k = !0, !1;
    var t = l.tag, e;
    if ((e = t !== 3 && t !== 27) && ((e = t === 5) && (e = l.type, e = !(e !== "form" && e !== "button") || Wc(l.type, l.memoizedProps)), e = !e), e && rl && ue(l), Es(l), t === 13) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(y(317));
      rl = kd(l);
    } else if (t === 31) {
      if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(y(317));
      rl = kd(l);
    } else
      t === 27 ? (t = rl, Se(l.type) ? (l = Pc, Pc = null, rl = l) : rl = t) : rl = Yl ? Tt(l.stateNode.nextSibling) : null;
    return !0;
  }
  function Ce() {
    rl = Yl = null, k = !1;
  }
  function Mi() {
    var l = ne;
    return l !== null && (tt === null ? tt = l : tt.push.apply(
      tt,
      l
    ), ne = null), l;
  }
  function Wa(l) {
    ne === null ? ne = [l] : ne.push(l);
  }
  var Ui = o(null), Re = null, Qt = null;
  function ie(l, t, e) {
    A(Ui, t._currentValue), t._currentValue = e;
  }
  function Lt(l) {
    l._currentValue = Ui.current, T(Ui);
  }
  function Ci(l, t, e) {
    for (; l !== null; ) {
      var a = l.alternate;
      if ((l.childLanes & t) !== t ? (l.childLanes |= t, a !== null && (a.childLanes |= t)) : a !== null && (a.childLanes & t) !== t && (a.childLanes |= t), l === e) break;
      l = l.return;
    }
  }
  function Ri(l, t, e, a) {
    var n = l.child;
    for (n !== null && (n.return = l); n !== null; ) {
      var u = n.dependencies;
      if (u !== null) {
        var i = n.child;
        u = u.firstContext;
        l: for (; u !== null; ) {
          var f = u;
          u = n;
          for (var s = 0; s < t.length; s++)
            if (f.context === t[s]) {
              u.lanes |= e, f = u.alternate, f !== null && (f.lanes |= e), Ci(
                u.return,
                e,
                l
              ), a || (i = null);
              break l;
            }
          u = f.next;
        }
      } else if (n.tag === 18) {
        if (i = n.return, i === null) throw Error(y(341));
        i.lanes |= e, u = i.alternate, u !== null && (u.lanes |= e), Ci(i, e, l), i = null;
      } else i = n.child;
      if (i !== null) i.return = n;
      else
        for (i = n; i !== null; ) {
          if (i === l) {
            i = null;
            break;
          }
          if (n = i.sibling, n !== null) {
            n.return = i.return, i = n;
            break;
          }
          i = i.return;
        }
      n = i;
    }
  }
  function fa(l, t, e, a) {
    l = null;
    for (var n = t, u = !1; n !== null; ) {
      if (!u) {
        if ((n.flags & 524288) !== 0) u = !0;
        else if ((n.flags & 262144) !== 0) break;
      }
      if (n.tag === 10) {
        var i = n.alternate;
        if (i === null) throw Error(y(387));
        if (i = i.memoizedProps, i !== null) {
          var f = n.type;
          it(n.pendingProps.value, i.value) || (l !== null ? l.push(f) : l = [f]);
        }
      } else if (n === B.current) {
        if (i = n.alternate, i === null) throw Error(y(387));
        i.memoizedState.memoizedState !== n.memoizedState.memoizedState && (l !== null ? l.push(Tn) : l = [Tn]);
      }
      n = n.return;
    }
    l !== null && Ri(
      t,
      l,
      e,
      a
    ), t.flags |= 262144;
  }
  function $n(l) {
    for (l = l.firstContext; l !== null; ) {
      if (!it(
        l.context._currentValue,
        l.memoizedValue
      ))
        return !0;
      l = l.next;
    }
    return !1;
  }
  function He(l) {
    Re = l, Qt = null, l = l.dependencies, l !== null && (l.firstContext = null);
  }
  function Gl(l) {
    return js(Re, l);
  }
  function Fn(l, t) {
    return Re === null && He(l), js(l, t);
  }
  function js(l, t) {
    var e = t._currentValue;
    if (t = { context: t, memoizedValue: e, next: null }, Qt === null) {
      if (l === null) throw Error(y(308));
      Qt = t, l.dependencies = { lanes: 0, firstContext: t }, l.flags |= 524288;
    } else Qt = Qt.next = t;
    return e;
  }
  var Xh = typeof AbortController < "u" ? AbortController : function() {
    var l = [], t = this.signal = {
      aborted: !1,
      addEventListener: function(e, a) {
        l.push(a);
      }
    };
    this.abort = function() {
      t.aborted = !0, l.forEach(function(e) {
        return e();
      });
    };
  }, Qh = N.unstable_scheduleCallback, Lh = N.unstable_NormalPriority, Ol = {
    $$typeof: zl,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Hi() {
    return {
      controller: new Xh(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function ka(l) {
    l.refCount--, l.refCount === 0 && Qh(Lh, function() {
      l.controller.abort();
    });
  }
  var $a = null, qi = 0, sa = 0, oa = null;
  function Zh(l, t) {
    if ($a === null) {
      var e = $a = [];
      qi = 0, sa = Gc(), oa = {
        status: "pending",
        value: void 0,
        then: function(a) {
          e.push(a);
        }
      };
    }
    return qi++, t.then(As, As), t;
  }
  function As() {
    if (--qi === 0 && $a !== null) {
      oa !== null && (oa.status = "fulfilled");
      var l = $a;
      $a = null, sa = 0, oa = null;
      for (var t = 0; t < l.length; t++) (0, l[t])();
    }
  }
  function wh(l, t) {
    var e = [], a = {
      status: "pending",
      value: null,
      reason: null,
      then: function(n) {
        e.push(n);
      }
    };
    return l.then(
      function() {
        a.status = "fulfilled", a.value = t;
        for (var n = 0; n < e.length; n++) (0, e[n])(t);
      },
      function(n) {
        for (a.status = "rejected", a.reason = n, n = 0; n < e.length; n++)
          (0, e[n])(void 0);
      }
    ), a;
  }
  var zs = p.S;
  p.S = function(l, t) {
    od = at(), typeof t == "object" && t !== null && typeof t.then == "function" && Zh(l, t), zs !== null && zs(l, t);
  };
  var qe = o(null);
  function Bi() {
    var l = qe.current;
    return l !== null ? l : fl.pooledCache;
  }
  function In(l, t) {
    t === null ? A(qe, qe.current) : A(qe, t.pool);
  }
  function Ns() {
    var l = Bi();
    return l === null ? null : { parent: Ol._currentValue, pool: l };
  }
  var da = Error(y(460)), Yi = Error(y(474)), Pn = Error(y(542)), lu = { then: function() {
  } };
  function Os(l) {
    return l = l.status, l === "fulfilled" || l === "rejected";
  }
  function _s(l, t, e) {
    switch (e = l[e], e === void 0 ? l.push(t) : e !== t && (t.then(Bt, Bt), t = e), t.status) {
      case "fulfilled":
        return t.value;
      case "rejected":
        throw l = t.reason, Ms(l), l;
      default:
        if (typeof t.status == "string") t.then(Bt, Bt);
        else {
          if (l = fl, l !== null && 100 < l.shellSuspendCounter)
            throw Error(y(482));
          l = t, l.status = "pending", l.then(
            function(a) {
              if (t.status === "pending") {
                var n = t;
                n.status = "fulfilled", n.value = a;
              }
            },
            function(a) {
              if (t.status === "pending") {
                var n = t;
                n.status = "rejected", n.reason = a;
              }
            }
          );
        }
        switch (t.status) {
          case "fulfilled":
            return t.value;
          case "rejected":
            throw l = t.reason, Ms(l), l;
        }
        throw Ye = t, da;
    }
  }
  function Be(l) {
    try {
      var t = l._init;
      return t(l._payload);
    } catch (e) {
      throw e !== null && typeof e == "object" && typeof e.then == "function" ? (Ye = e, da) : e;
    }
  }
  var Ye = null;
  function Ds() {
    if (Ye === null) throw Error(y(459));
    var l = Ye;
    return Ye = null, l;
  }
  function Ms(l) {
    if (l === da || l === Pn)
      throw Error(y(483));
  }
  var ra = null, Fa = 0;
  function tu(l) {
    var t = Fa;
    return Fa += 1, ra === null && (ra = []), _s(ra, l, t);
  }
  function Ia(l, t) {
    t = t.props.ref, l.ref = t !== void 0 ? t : null;
  }
  function eu(l, t) {
    throw t.$$typeof === el ? Error(y(525)) : (l = Object.prototype.toString.call(t), Error(
      y(
        31,
        l === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : l
      )
    ));
  }
  function Us(l) {
    function t(r, d) {
      if (l) {
        var h = r.deletions;
        h === null ? (r.deletions = [d], r.flags |= 16) : h.push(d);
      }
    }
    function e(r, d) {
      if (!l) return null;
      for (; d !== null; )
        t(r, d), d = d.sibling;
      return null;
    }
    function a(r) {
      for (var d = /* @__PURE__ */ new Map(); r !== null; )
        r.key !== null ? d.set(r.key, r) : d.set(r.index, r), r = r.sibling;
      return d;
    }
    function n(r, d) {
      return r = Gt(r, d), r.index = 0, r.sibling = null, r;
    }
    function u(r, d, h) {
      return r.index = h, l ? (h = r.alternate, h !== null ? (h = h.index, h < d ? (r.flags |= 67108866, d) : h) : (r.flags |= 67108866, d)) : (r.flags |= 1048576, d);
    }
    function i(r) {
      return l && r.alternate === null && (r.flags |= 67108866), r;
    }
    function f(r, d, h, b) {
      return d === null || d.tag !== 6 ? (d = zi(h, r.mode, b), d.return = r, d) : (d = n(d, h), d.return = r, d);
    }
    function s(r, d, h, b) {
      var R = h.type;
      return R === jl ? S(
        r,
        d,
        h.props.children,
        b,
        h.key
      ) : d !== null && (d.elementType === R || typeof R == "object" && R !== null && R.$$typeof === Vl && Be(R) === d.type) ? (d = n(d, h.props), Ia(d, h), d.return = r, d) : (d = Wn(
        h.type,
        h.key,
        h.props,
        null,
        r.mode,
        b
      ), Ia(d, h), d.return = r, d);
    }
    function m(r, d, h, b) {
      return d === null || d.tag !== 4 || d.stateNode.containerInfo !== h.containerInfo || d.stateNode.implementation !== h.implementation ? (d = Ni(h, r.mode, b), d.return = r, d) : (d = n(d, h.children || []), d.return = r, d);
    }
    function S(r, d, h, b, R) {
      return d === null || d.tag !== 7 ? (d = Ue(
        h,
        r.mode,
        b,
        R
      ), d.return = r, d) : (d = n(d, h), d.return = r, d);
    }
    function x(r, d, h) {
      if (typeof d == "string" && d !== "" || typeof d == "number" || typeof d == "bigint")
        return d = zi(
          "" + d,
          r.mode,
          h
        ), d.return = r, d;
      if (typeof d == "object" && d !== null) {
        switch (d.$$typeof) {
          case gl:
            return h = Wn(
              d.type,
              d.key,
              d.props,
              null,
              r.mode,
              h
            ), Ia(h, d), h.return = r, h;
          case Zl:
            return d = Ni(
              d,
              r.mode,
              h
            ), d.return = r, d;
          case Vl:
            return d = Be(d), x(r, d, h);
        }
        if (pl(d) || O(d))
          return d = Ue(
            d,
            r.mode,
            h,
            null
          ), d.return = r, d;
        if (typeof d.then == "function")
          return x(r, tu(d), h);
        if (d.$$typeof === zl)
          return x(
            r,
            Fn(r, d),
            h
          );
        eu(r, d);
      }
      return null;
    }
    function v(r, d, h, b) {
      var R = d !== null ? d.key : null;
      if (typeof h == "string" && h !== "" || typeof h == "number" || typeof h == "bigint")
        return R !== null ? null : f(r, d, "" + h, b);
      if (typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case gl:
            return h.key === R ? s(r, d, h, b) : null;
          case Zl:
            return h.key === R ? m(r, d, h, b) : null;
          case Vl:
            return h = Be(h), v(r, d, h, b);
        }
        if (pl(h) || O(h))
          return R !== null ? null : S(r, d, h, b, null);
        if (typeof h.then == "function")
          return v(
            r,
            d,
            tu(h),
            b
          );
        if (h.$$typeof === zl)
          return v(
            r,
            d,
            Fn(r, h),
            b
          );
        eu(r, h);
      }
      return null;
    }
    function g(r, d, h, b, R) {
      if (typeof b == "string" && b !== "" || typeof b == "number" || typeof b == "bigint")
        return r = r.get(h) || null, f(d, r, "" + b, R);
      if (typeof b == "object" && b !== null) {
        switch (b.$$typeof) {
          case gl:
            return r = r.get(
              b.key === null ? h : b.key
            ) || null, s(d, r, b, R);
          case Zl:
            return r = r.get(
              b.key === null ? h : b.key
            ) || null, m(d, r, b, R);
          case Vl:
            return b = Be(b), g(
              r,
              d,
              h,
              b,
              R
            );
        }
        if (pl(b) || O(b))
          return r = r.get(h) || null, S(d, r, b, R, null);
        if (typeof b.then == "function")
          return g(
            r,
            d,
            h,
            tu(b),
            R
          );
        if (b.$$typeof === zl)
          return g(
            r,
            d,
            h,
            Fn(d, b),
            R
          );
        eu(d, b);
      }
      return null;
    }
    function D(r, d, h, b) {
      for (var R = null, P = null, M = d, Q = d = 0, J = null; M !== null && Q < h.length; Q++) {
        M.index > Q ? (J = M, M = null) : J = M.sibling;
        var ll = v(
          r,
          M,
          h[Q],
          b
        );
        if (ll === null) {
          M === null && (M = J);
          break;
        }
        l && M && ll.alternate === null && t(r, M), d = u(ll, d, Q), P === null ? R = ll : P.sibling = ll, P = ll, M = J;
      }
      if (Q === h.length)
        return e(r, M), k && Xt(r, Q), R;
      if (M === null) {
        for (; Q < h.length; Q++)
          M = x(r, h[Q], b), M !== null && (d = u(
            M,
            d,
            Q
          ), P === null ? R = M : P.sibling = M, P = M);
        return k && Xt(r, Q), R;
      }
      for (M = a(M); Q < h.length; Q++)
        J = g(
          M,
          r,
          Q,
          h[Q],
          b
        ), J !== null && (l && J.alternate !== null && M.delete(
          J.key === null ? Q : J.key
        ), d = u(
          J,
          d,
          Q
        ), P === null ? R = J : P.sibling = J, P = J);
      return l && M.forEach(function(je) {
        return t(r, je);
      }), k && Xt(r, Q), R;
    }
    function q(r, d, h, b) {
      if (h == null) throw Error(y(151));
      for (var R = null, P = null, M = d, Q = d = 0, J = null, ll = h.next(); M !== null && !ll.done; Q++, ll = h.next()) {
        M.index > Q ? (J = M, M = null) : J = M.sibling;
        var je = v(r, M, ll.value, b);
        if (je === null) {
          M === null && (M = J);
          break;
        }
        l && M && je.alternate === null && t(r, M), d = u(je, d, Q), P === null ? R = je : P.sibling = je, P = je, M = J;
      }
      if (ll.done)
        return e(r, M), k && Xt(r, Q), R;
      if (M === null) {
        for (; !ll.done; Q++, ll = h.next())
          ll = x(r, ll.value, b), ll !== null && (d = u(ll, d, Q), P === null ? R = ll : P.sibling = ll, P = ll);
        return k && Xt(r, Q), R;
      }
      for (M = a(M); !ll.done; Q++, ll = h.next())
        ll = g(M, r, Q, ll.value, b), ll !== null && (l && ll.alternate !== null && M.delete(ll.key === null ? Q : ll.key), d = u(ll, d, Q), P === null ? R = ll : P.sibling = ll, P = ll);
      return l && M.forEach(function(tv) {
        return t(r, tv);
      }), k && Xt(r, Q), R;
    }
    function cl(r, d, h, b) {
      if (typeof h == "object" && h !== null && h.type === jl && h.key === null && (h = h.props.children), typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case gl:
            l: {
              for (var R = h.key; d !== null; ) {
                if (d.key === R) {
                  if (R = h.type, R === jl) {
                    if (d.tag === 7) {
                      e(
                        r,
                        d.sibling
                      ), b = n(
                        d,
                        h.props.children
                      ), b.return = r, r = b;
                      break l;
                    }
                  } else if (d.elementType === R || typeof R == "object" && R !== null && R.$$typeof === Vl && Be(R) === d.type) {
                    e(
                      r,
                      d.sibling
                    ), b = n(d, h.props), Ia(b, h), b.return = r, r = b;
                    break l;
                  }
                  e(r, d);
                  break;
                } else t(r, d);
                d = d.sibling;
              }
              h.type === jl ? (b = Ue(
                h.props.children,
                r.mode,
                b,
                h.key
              ), b.return = r, r = b) : (b = Wn(
                h.type,
                h.key,
                h.props,
                null,
                r.mode,
                b
              ), Ia(b, h), b.return = r, r = b);
            }
            return i(r);
          case Zl:
            l: {
              for (R = h.key; d !== null; ) {
                if (d.key === R)
                  if (d.tag === 4 && d.stateNode.containerInfo === h.containerInfo && d.stateNode.implementation === h.implementation) {
                    e(
                      r,
                      d.sibling
                    ), b = n(d, h.children || []), b.return = r, r = b;
                    break l;
                  } else {
                    e(r, d);
                    break;
                  }
                else t(r, d);
                d = d.sibling;
              }
              b = Ni(h, r.mode, b), b.return = r, r = b;
            }
            return i(r);
          case Vl:
            return h = Be(h), cl(
              r,
              d,
              h,
              b
            );
        }
        if (pl(h))
          return D(
            r,
            d,
            h,
            b
          );
        if (O(h)) {
          if (R = O(h), typeof R != "function") throw Error(y(150));
          return h = R.call(h), q(
            r,
            d,
            h,
            b
          );
        }
        if (typeof h.then == "function")
          return cl(
            r,
            d,
            tu(h),
            b
          );
        if (h.$$typeof === zl)
          return cl(
            r,
            d,
            Fn(r, h),
            b
          );
        eu(r, h);
      }
      return typeof h == "string" && h !== "" || typeof h == "number" || typeof h == "bigint" ? (h = "" + h, d !== null && d.tag === 6 ? (e(r, d.sibling), b = n(d, h), b.return = r, r = b) : (e(r, d), b = zi(h, r.mode, b), b.return = r, r = b), i(r)) : e(r, d);
    }
    return function(r, d, h, b) {
      try {
        Fa = 0;
        var R = cl(
          r,
          d,
          h,
          b
        );
        return ra = null, R;
      } catch (M) {
        if (M === da || M === Pn) throw M;
        var P = ct(29, M, null, r.mode);
        return P.lanes = b, P.return = r, P;
      }
    };
  }
  var Ge = Us(!0), Cs = Us(!1), ce = !1;
  function Gi(l) {
    l.updateQueue = {
      baseState: l.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Xi(l, t) {
    l = l.updateQueue, t.updateQueue === l && (t.updateQueue = {
      baseState: l.baseState,
      firstBaseUpdate: l.firstBaseUpdate,
      lastBaseUpdate: l.lastBaseUpdate,
      shared: l.shared,
      callbacks: null
    });
  }
  function fe(l) {
    return { lane: l, tag: 0, payload: null, callback: null, next: null };
  }
  function se(l, t, e) {
    var a = l.updateQueue;
    if (a === null) return null;
    if (a = a.shared, (tl & 2) !== 0) {
      var n = a.pending;
      return n === null ? t.next = t : (t.next = n.next, n.next = t), a.pending = t, t = Jn(l), ys(l, null, e), t;
    }
    return Kn(l, a, t, e), Jn(l);
  }
  function Pa(l, t, e) {
    if (t = t.updateQueue, t !== null && (t = t.shared, (e & 4194048) !== 0)) {
      var a = t.lanes;
      a &= l.pendingLanes, e |= a, t.lanes = e, jf(l, e);
    }
  }
  function Qi(l, t) {
    var e = l.updateQueue, a = l.alternate;
    if (a !== null && (a = a.updateQueue, e === a)) {
      var n = null, u = null;
      if (e = e.firstBaseUpdate, e !== null) {
        do {
          var i = {
            lane: e.lane,
            tag: e.tag,
            payload: e.payload,
            callback: null,
            next: null
          };
          u === null ? n = u = i : u = u.next = i, e = e.next;
        } while (e !== null);
        u === null ? n = u = t : u = u.next = t;
      } else n = u = t;
      e = {
        baseState: a.baseState,
        firstBaseUpdate: n,
        lastBaseUpdate: u,
        shared: a.shared,
        callbacks: a.callbacks
      }, l.updateQueue = e;
      return;
    }
    l = e.lastBaseUpdate, l === null ? e.firstBaseUpdate = t : l.next = t, e.lastBaseUpdate = t;
  }
  var Li = !1;
  function ln() {
    if (Li) {
      var l = oa;
      if (l !== null) throw l;
    }
  }
  function tn(l, t, e, a) {
    Li = !1;
    var n = l.updateQueue;
    ce = !1;
    var u = n.firstBaseUpdate, i = n.lastBaseUpdate, f = n.shared.pending;
    if (f !== null) {
      n.shared.pending = null;
      var s = f, m = s.next;
      s.next = null, i === null ? u = m : i.next = m, i = s;
      var S = l.alternate;
      S !== null && (S = S.updateQueue, f = S.lastBaseUpdate, f !== i && (f === null ? S.firstBaseUpdate = m : f.next = m, S.lastBaseUpdate = s));
    }
    if (u !== null) {
      var x = n.baseState;
      i = 0, S = m = s = null, f = u;
      do {
        var v = f.lane & -536870913, g = v !== f.lane;
        if (g ? (K & v) === v : (a & v) === v) {
          v !== 0 && v === sa && (Li = !0), S !== null && (S = S.next = {
            lane: 0,
            tag: f.tag,
            payload: f.payload,
            callback: null,
            next: null
          });
          l: {
            var D = l, q = f;
            v = t;
            var cl = e;
            switch (q.tag) {
              case 1:
                if (D = q.payload, typeof D == "function") {
                  x = D.call(cl, x, v);
                  break l;
                }
                x = D;
                break l;
              case 3:
                D.flags = D.flags & -65537 | 128;
              case 0:
                if (D = q.payload, v = typeof D == "function" ? D.call(cl, x, v) : D, v == null) break l;
                x = H({}, x, v);
                break l;
              case 2:
                ce = !0;
            }
          }
          v = f.callback, v !== null && (l.flags |= 64, g && (l.flags |= 8192), g = n.callbacks, g === null ? n.callbacks = [v] : g.push(v));
        } else
          g = {
            lane: v,
            tag: f.tag,
            payload: f.payload,
            callback: f.callback,
            next: null
          }, S === null ? (m = S = g, s = x) : S = S.next = g, i |= v;
        if (f = f.next, f === null) {
          if (f = n.shared.pending, f === null)
            break;
          g = f, f = g.next, g.next = null, n.lastBaseUpdate = g, n.shared.pending = null;
        }
      } while (!0);
      S === null && (s = x), n.baseState = s, n.firstBaseUpdate = m, n.lastBaseUpdate = S, u === null && (n.shared.lanes = 0), me |= i, l.lanes = i, l.memoizedState = x;
    }
  }
  function Rs(l, t) {
    if (typeof l != "function")
      throw Error(y(191, l));
    l.call(t);
  }
  function Hs(l, t) {
    var e = l.callbacks;
    if (e !== null)
      for (l.callbacks = null, l = 0; l < e.length; l++)
        Rs(e[l], t);
  }
  var ha = o(null), au = o(0);
  function qs(l, t) {
    l = Ft, A(au, l), A(ha, t), Ft = l | t.baseLanes;
  }
  function Zi() {
    A(au, Ft), A(ha, ha.current);
  }
  function wi() {
    Ft = au.current, T(ha), T(au);
  }
  var ft = o(null), xt = null;
  function oe(l) {
    var t = l.alternate;
    A(xl, xl.current & 1), A(ft, l), xt === null && (t === null || ha.current !== null || t.memoizedState !== null) && (xt = l);
  }
  function Vi(l) {
    A(xl, xl.current), A(ft, l), xt === null && (xt = l);
  }
  function Bs(l) {
    l.tag === 22 ? (A(xl, xl.current), A(ft, l), xt === null && (xt = l)) : de();
  }
  function de() {
    A(xl, xl.current), A(ft, ft.current);
  }
  function st(l) {
    T(ft), xt === l && (xt = null), T(xl);
  }
  var xl = o(0);
  function nu(l) {
    for (var t = l; t !== null; ) {
      if (t.tag === 13) {
        var e = t.memoizedState;
        if (e !== null && (e = e.dehydrated, e === null || Fc(e) || Ic(e)))
          return t;
      } else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
        if ((t.flags & 128) !== 0) return t;
      } else if (t.child !== null) {
        t.child.return = t, t = t.child;
        continue;
      }
      if (t === l) break;
      for (; t.sibling === null; ) {
        if (t.return === null || t.return === l) return null;
        t = t.return;
      }
      t.sibling.return = t.return, t = t.sibling;
    }
    return null;
  }
  var Zt = 0, X = null, ul = null, _l = null, uu = !1, ma = !1, Xe = !1, iu = 0, en = 0, va = null, Vh = 0;
  function Sl() {
    throw Error(y(321));
  }
  function Ki(l, t) {
    if (t === null) return !1;
    for (var e = 0; e < t.length && e < l.length; e++)
      if (!it(l[e], t[e])) return !1;
    return !0;
  }
  function Ji(l, t, e, a, n, u) {
    return Zt = u, X = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, p.H = l === null || l.memoizedState === null ? xo : fc, Xe = !1, u = e(a, n), Xe = !1, ma && (u = Gs(
      t,
      e,
      a,
      n
    )), Ys(l), u;
  }
  function Ys(l) {
    p.H = un;
    var t = ul !== null && ul.next !== null;
    if (Zt = 0, _l = ul = X = null, uu = !1, en = 0, va = null, t) throw Error(y(300));
    l === null || Dl || (l = l.dependencies, l !== null && $n(l) && (Dl = !0));
  }
  function Gs(l, t, e, a) {
    X = l;
    var n = 0;
    do {
      if (ma && (va = null), en = 0, ma = !1, 25 <= n) throw Error(y(301));
      if (n += 1, _l = ul = null, l.updateQueue != null) {
        var u = l.updateQueue;
        u.lastEffect = null, u.events = null, u.stores = null, u.memoCache != null && (u.memoCache.index = 0);
      }
      p.H = To, u = t(e, a);
    } while (ma);
    return u;
  }
  function Kh() {
    var l = p.H, t = l.useState()[0];
    return t = typeof t.then == "function" ? an(t) : t, l = l.useState()[0], (ul !== null ? ul.memoizedState : null) !== l && (X.flags |= 1024), t;
  }
  function Wi() {
    var l = iu !== 0;
    return iu = 0, l;
  }
  function ki(l, t, e) {
    t.updateQueue = l.updateQueue, t.flags &= -2053, l.lanes &= ~e;
  }
  function $i(l) {
    if (uu) {
      for (l = l.memoizedState; l !== null; ) {
        var t = l.queue;
        t !== null && (t.pending = null), l = l.next;
      }
      uu = !1;
    }
    Zt = 0, _l = ul = X = null, ma = !1, en = iu = 0, va = null;
  }
  function Wl() {
    var l = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return _l === null ? X.memoizedState = _l = l : _l = _l.next = l, _l;
  }
  function Tl() {
    if (ul === null) {
      var l = X.alternate;
      l = l !== null ? l.memoizedState : null;
    } else l = ul.next;
    var t = _l === null ? X.memoizedState : _l.next;
    if (t !== null)
      _l = t, ul = l;
    else {
      if (l === null)
        throw X.alternate === null ? Error(y(467)) : Error(y(310));
      ul = l, l = {
        memoizedState: ul.memoizedState,
        baseState: ul.baseState,
        baseQueue: ul.baseQueue,
        queue: ul.queue,
        next: null
      }, _l === null ? X.memoizedState = _l = l : _l = _l.next = l;
    }
    return _l;
  }
  function cu() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function an(l) {
    var t = en;
    return en += 1, va === null && (va = []), l = _s(va, l, t), t = X, (_l === null ? t.memoizedState : _l.next) === null && (t = t.alternate, p.H = t === null || t.memoizedState === null ? xo : fc), l;
  }
  function fu(l) {
    if (l !== null && typeof l == "object") {
      if (typeof l.then == "function") return an(l);
      if (l.$$typeof === zl) return Gl(l);
    }
    throw Error(y(438, String(l)));
  }
  function Fi(l) {
    var t = null, e = X.updateQueue;
    if (e !== null && (t = e.memoCache), t == null) {
      var a = X.alternate;
      a !== null && (a = a.updateQueue, a !== null && (a = a.memoCache, a != null && (t = {
        data: a.data.map(function(n) {
          return n.slice();
        }),
        index: 0
      })));
    }
    if (t == null && (t = { data: [], index: 0 }), e === null && (e = cu(), X.updateQueue = e), e.memoCache = t, e = t.data[t.index], e === void 0)
      for (e = t.data[t.index] = Array(l), a = 0; a < l; a++)
        e[a] = Ht;
    return t.index++, e;
  }
  function wt(l, t) {
    return typeof t == "function" ? t(l) : t;
  }
  function su(l) {
    var t = Tl();
    return Ii(t, ul, l);
  }
  function Ii(l, t, e) {
    var a = l.queue;
    if (a === null) throw Error(y(311));
    a.lastRenderedReducer = e;
    var n = l.baseQueue, u = a.pending;
    if (u !== null) {
      if (n !== null) {
        var i = n.next;
        n.next = u.next, u.next = i;
      }
      t.baseQueue = n = u, a.pending = null;
    }
    if (u = l.baseState, n === null) l.memoizedState = u;
    else {
      t = n.next;
      var f = i = null, s = null, m = t, S = !1;
      do {
        var x = m.lane & -536870913;
        if (x !== m.lane ? (K & x) === x : (Zt & x) === x) {
          var v = m.revertLane;
          if (v === 0)
            s !== null && (s = s.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: m.action,
              hasEagerState: m.hasEagerState,
              eagerState: m.eagerState,
              next: null
            }), x === sa && (S = !0);
          else if ((Zt & v) === v) {
            m = m.next, v === sa && (S = !0);
            continue;
          } else
            x = {
              lane: 0,
              revertLane: m.revertLane,
              gesture: null,
              action: m.action,
              hasEagerState: m.hasEagerState,
              eagerState: m.eagerState,
              next: null
            }, s === null ? (f = s = x, i = u) : s = s.next = x, X.lanes |= v, me |= v;
          x = m.action, Xe && e(u, x), u = m.hasEagerState ? m.eagerState : e(u, x);
        } else
          v = {
            lane: x,
            revertLane: m.revertLane,
            gesture: m.gesture,
            action: m.action,
            hasEagerState: m.hasEagerState,
            eagerState: m.eagerState,
            next: null
          }, s === null ? (f = s = v, i = u) : s = s.next = v, X.lanes |= x, me |= x;
        m = m.next;
      } while (m !== null && m !== t);
      if (s === null ? i = u : s.next = f, !it(u, l.memoizedState) && (Dl = !0, S && (e = oa, e !== null)))
        throw e;
      l.memoizedState = u, l.baseState = i, l.baseQueue = s, a.lastRenderedState = u;
    }
    return n === null && (a.lanes = 0), [l.memoizedState, a.dispatch];
  }
  function Pi(l) {
    var t = Tl(), e = t.queue;
    if (e === null) throw Error(y(311));
    e.lastRenderedReducer = l;
    var a = e.dispatch, n = e.pending, u = t.memoizedState;
    if (n !== null) {
      e.pending = null;
      var i = n = n.next;
      do
        u = l(u, i.action), i = i.next;
      while (i !== n);
      it(u, t.memoizedState) || (Dl = !0), t.memoizedState = u, t.baseQueue === null && (t.baseState = u), e.lastRenderedState = u;
    }
    return [u, a];
  }
  function Xs(l, t, e) {
    var a = X, n = Tl(), u = k;
    if (u) {
      if (e === void 0) throw Error(y(407));
      e = e();
    } else e = t();
    var i = !it(
      (ul || n).memoizedState,
      e
    );
    if (i && (n.memoizedState = e, Dl = !0), n = n.queue, ec(Zs.bind(null, a, n, l), [
      l
    ]), n.getSnapshot !== t || i || _l !== null && _l.memoizedState.tag & 1) {
      if (a.flags |= 2048, ya(
        9,
        { destroy: void 0 },
        Ls.bind(
          null,
          a,
          n,
          e,
          t
        ),
        null
      ), fl === null) throw Error(y(349));
      u || (Zt & 127) !== 0 || Qs(a, t, e);
    }
    return e;
  }
  function Qs(l, t, e) {
    l.flags |= 16384, l = { getSnapshot: t, value: e }, t = X.updateQueue, t === null ? (t = cu(), X.updateQueue = t, t.stores = [l]) : (e = t.stores, e === null ? t.stores = [l] : e.push(l));
  }
  function Ls(l, t, e, a) {
    t.value = e, t.getSnapshot = a, ws(t) && Vs(l);
  }
  function Zs(l, t, e) {
    return e(function() {
      ws(t) && Vs(l);
    });
  }
  function ws(l) {
    var t = l.getSnapshot;
    l = l.value;
    try {
      var e = t();
      return !it(l, e);
    } catch {
      return !0;
    }
  }
  function Vs(l) {
    var t = Me(l, 2);
    t !== null && et(t, l, 2);
  }
  function lc(l) {
    var t = Wl();
    if (typeof l == "function") {
      var e = l;
      if (l = e(), Xe) {
        le(!0);
        try {
          e();
        } finally {
          le(!1);
        }
      }
    }
    return t.memoizedState = t.baseState = l, t.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: wt,
      lastRenderedState: l
    }, t;
  }
  function Ks(l, t, e, a) {
    return l.baseState = e, Ii(
      l,
      ul,
      typeof a == "function" ? a : wt
    );
  }
  function Jh(l, t, e, a, n) {
    if (ru(l)) throw Error(y(485));
    if (l = t.action, l !== null) {
      var u = {
        payload: n,
        action: l,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(i) {
          u.listeners.push(i);
        }
      };
      p.T !== null ? e(!0) : u.isTransition = !1, a(u), e = t.pending, e === null ? (u.next = t.pending = u, Js(t, u)) : (u.next = e.next, t.pending = e.next = u);
    }
  }
  function Js(l, t) {
    var e = t.action, a = t.payload, n = l.state;
    if (t.isTransition) {
      var u = p.T, i = {};
      p.T = i;
      try {
        var f = e(n, a), s = p.S;
        s !== null && s(i, f), Ws(l, t, f);
      } catch (m) {
        tc(l, t, m);
      } finally {
        u !== null && i.types !== null && (u.types = i.types), p.T = u;
      }
    } else
      try {
        u = e(n, a), Ws(l, t, u);
      } catch (m) {
        tc(l, t, m);
      }
  }
  function Ws(l, t, e) {
    e !== null && typeof e == "object" && typeof e.then == "function" ? e.then(
      function(a) {
        ks(l, t, a);
      },
      function(a) {
        return tc(l, t, a);
      }
    ) : ks(l, t, e);
  }
  function ks(l, t, e) {
    t.status = "fulfilled", t.value = e, $s(t), l.state = e, t = l.pending, t !== null && (e = t.next, e === t ? l.pending = null : (e = e.next, t.next = e, Js(l, e)));
  }
  function tc(l, t, e) {
    var a = l.pending;
    if (l.pending = null, a !== null) {
      a = a.next;
      do
        t.status = "rejected", t.reason = e, $s(t), t = t.next;
      while (t !== a);
    }
    l.action = null;
  }
  function $s(l) {
    l = l.listeners;
    for (var t = 0; t < l.length; t++) (0, l[t])();
  }
  function Fs(l, t) {
    return t;
  }
  function Is(l, t) {
    if (k) {
      var e = fl.formState;
      if (e !== null) {
        l: {
          var a = X;
          if (k) {
            if (rl) {
              t: {
                for (var n = rl, u = bt; n.nodeType !== 8; ) {
                  if (!u) {
                    n = null;
                    break t;
                  }
                  if (n = Tt(
                    n.nextSibling
                  ), n === null) {
                    n = null;
                    break t;
                  }
                }
                u = n.data, n = u === "F!" || u === "F" ? n : null;
              }
              if (n) {
                rl = Tt(
                  n.nextSibling
                ), a = n.data === "F!";
                break l;
              }
            }
            ue(a);
          }
          a = !1;
        }
        a && (t = e[0]);
      }
    }
    return e = Wl(), e.memoizedState = e.baseState = t, a = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Fs,
      lastRenderedState: t
    }, e.queue = a, e = po.bind(
      null,
      X,
      a
    ), a.dispatch = e, a = lc(!1), u = cc.bind(
      null,
      X,
      !1,
      a.queue
    ), a = Wl(), n = {
      state: t,
      dispatch: null,
      action: l,
      pending: null
    }, a.queue = n, e = Jh.bind(
      null,
      X,
      n,
      u,
      e
    ), n.dispatch = e, a.memoizedState = l, [t, e, !1];
  }
  function Ps(l) {
    var t = Tl();
    return lo(t, ul, l);
  }
  function lo(l, t, e) {
    if (t = Ii(
      l,
      t,
      Fs
    )[0], l = su(wt)[0], typeof t == "object" && t !== null && typeof t.then == "function")
      try {
        var a = an(t);
      } catch (i) {
        throw i === da ? Pn : i;
      }
    else a = t;
    t = Tl();
    var n = t.queue, u = n.dispatch;
    return e !== t.memoizedState && (X.flags |= 2048, ya(
      9,
      { destroy: void 0 },
      Wh.bind(null, n, e),
      null
    )), [a, u, l];
  }
  function Wh(l, t) {
    l.action = t;
  }
  function to(l) {
    var t = Tl(), e = ul;
    if (e !== null)
      return lo(t, e, l);
    Tl(), t = t.memoizedState, e = Tl();
    var a = e.queue.dispatch;
    return e.memoizedState = l, [t, a, !1];
  }
  function ya(l, t, e, a) {
    return l = { tag: l, create: e, deps: a, inst: t, next: null }, t = X.updateQueue, t === null && (t = cu(), X.updateQueue = t), e = t.lastEffect, e === null ? t.lastEffect = l.next = l : (a = e.next, e.next = l, l.next = a, t.lastEffect = l), l;
  }
  function eo() {
    return Tl().memoizedState;
  }
  function ou(l, t, e, a) {
    var n = Wl();
    X.flags |= l, n.memoizedState = ya(
      1 | t,
      { destroy: void 0 },
      e,
      a === void 0 ? null : a
    );
  }
  function du(l, t, e, a) {
    var n = Tl();
    a = a === void 0 ? null : a;
    var u = n.memoizedState.inst;
    ul !== null && a !== null && Ki(a, ul.memoizedState.deps) ? n.memoizedState = ya(t, u, e, a) : (X.flags |= l, n.memoizedState = ya(
      1 | t,
      u,
      e,
      a
    ));
  }
  function ao(l, t) {
    ou(8390656, 8, l, t);
  }
  function ec(l, t) {
    du(2048, 8, l, t);
  }
  function kh(l) {
    X.flags |= 4;
    var t = X.updateQueue;
    if (t === null)
      t = cu(), X.updateQueue = t, t.events = [l];
    else {
      var e = t.events;
      e === null ? t.events = [l] : e.push(l);
    }
  }
  function no(l) {
    var t = Tl().memoizedState;
    return kh({ ref: t, nextImpl: l }), function() {
      if ((tl & 2) !== 0) throw Error(y(440));
      return t.impl.apply(void 0, arguments);
    };
  }
  function uo(l, t) {
    return du(4, 2, l, t);
  }
  function io(l, t) {
    return du(4, 4, l, t);
  }
  function co(l, t) {
    if (typeof t == "function") {
      l = l();
      var e = t(l);
      return function() {
        typeof e == "function" ? e() : t(null);
      };
    }
    if (t != null)
      return l = l(), t.current = l, function() {
        t.current = null;
      };
  }
  function fo(l, t, e) {
    e = e != null ? e.concat([l]) : null, du(4, 4, co.bind(null, t, l), e);
  }
  function ac() {
  }
  function so(l, t) {
    var e = Tl();
    t = t === void 0 ? null : t;
    var a = e.memoizedState;
    return t !== null && Ki(t, a[1]) ? a[0] : (e.memoizedState = [l, t], l);
  }
  function oo(l, t) {
    var e = Tl();
    t = t === void 0 ? null : t;
    var a = e.memoizedState;
    if (t !== null && Ki(t, a[1]))
      return a[0];
    if (a = l(), Xe) {
      le(!0);
      try {
        l();
      } finally {
        le(!1);
      }
    }
    return e.memoizedState = [a, t], a;
  }
  function nc(l, t, e) {
    return e === void 0 || (Zt & 1073741824) !== 0 && (K & 261930) === 0 ? l.memoizedState = t : (l.memoizedState = e, l = rd(), X.lanes |= l, me |= l, e);
  }
  function ro(l, t, e, a) {
    return it(e, t) ? e : ha.current !== null ? (l = nc(l, e, a), it(l, t) || (Dl = !0), l) : (Zt & 42) === 0 || (Zt & 1073741824) !== 0 && (K & 261930) === 0 ? (Dl = !0, l.memoizedState = e) : (l = rd(), X.lanes |= l, me |= l, t);
  }
  function ho(l, t, e, a, n) {
    var u = j.p;
    j.p = u !== 0 && 8 > u ? u : 8;
    var i = p.T, f = {};
    p.T = f, cc(l, !1, t, e);
    try {
      var s = n(), m = p.S;
      if (m !== null && m(f, s), s !== null && typeof s == "object" && typeof s.then == "function") {
        var S = wh(
          s,
          a
        );
        nn(
          l,
          t,
          S,
          rt(l)
        );
      } else
        nn(
          l,
          t,
          a,
          rt(l)
        );
    } catch (x) {
      nn(
        l,
        t,
        { then: function() {
        }, status: "rejected", reason: x },
        rt()
      );
    } finally {
      j.p = u, i !== null && f.types !== null && (i.types = f.types), p.T = i;
    }
  }
  function $h() {
  }
  function uc(l, t, e, a) {
    if (l.tag !== 5) throw Error(y(476));
    var n = mo(l).queue;
    ho(
      l,
      n,
      t,
      C,
      e === null ? $h : function() {
        return vo(l), e(a);
      }
    );
  }
  function mo(l) {
    var t = l.memoizedState;
    if (t !== null) return t;
    t = {
      memoizedState: C,
      baseState: C,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: wt,
        lastRenderedState: C
      },
      next: null
    };
    var e = {};
    return t.next = {
      memoizedState: e,
      baseState: e,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: wt,
        lastRenderedState: e
      },
      next: null
    }, l.memoizedState = t, l = l.alternate, l !== null && (l.memoizedState = t), t;
  }
  function vo(l) {
    var t = mo(l);
    t.next === null && (t = l.alternate.memoizedState), nn(
      l,
      t.next.queue,
      {},
      rt()
    );
  }
  function ic() {
    return Gl(Tn);
  }
  function yo() {
    return Tl().memoizedState;
  }
  function go() {
    return Tl().memoizedState;
  }
  function Fh(l) {
    for (var t = l.return; t !== null; ) {
      switch (t.tag) {
        case 24:
        case 3:
          var e = rt();
          l = fe(e);
          var a = se(t, l, e);
          a !== null && (et(a, t, e), Pa(a, t, e)), t = { cache: Hi() }, l.payload = t;
          return;
      }
      t = t.return;
    }
  }
  function Ih(l, t, e) {
    var a = rt();
    e = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, ru(l) ? So(t, e) : (e = ji(l, t, e, a), e !== null && (et(e, l, a), bo(e, t, a)));
  }
  function po(l, t, e) {
    var a = rt();
    nn(l, t, e, a);
  }
  function nn(l, t, e, a) {
    var n = {
      lane: a,
      revertLane: 0,
      gesture: null,
      action: e,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (ru(l)) So(t, n);
    else {
      var u = l.alternate;
      if (l.lanes === 0 && (u === null || u.lanes === 0) && (u = t.lastRenderedReducer, u !== null))
        try {
          var i = t.lastRenderedState, f = u(i, e);
          if (n.hasEagerState = !0, n.eagerState = f, it(f, i))
            return Kn(l, t, n, 0), fl === null && Vn(), !1;
        } catch {
        }
      if (e = ji(l, t, n, a), e !== null)
        return et(e, l, a), bo(e, t, a), !0;
    }
    return !1;
  }
  function cc(l, t, e, a) {
    if (a = {
      lane: 2,
      revertLane: Gc(),
      gesture: null,
      action: a,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, ru(l)) {
      if (t) throw Error(y(479));
    } else
      t = ji(
        l,
        e,
        a,
        2
      ), t !== null && et(t, l, 2);
  }
  function ru(l) {
    var t = l.alternate;
    return l === X || t !== null && t === X;
  }
  function So(l, t) {
    ma = uu = !0;
    var e = l.pending;
    e === null ? t.next = t : (t.next = e.next, e.next = t), l.pending = t;
  }
  function bo(l, t, e) {
    if ((e & 4194048) !== 0) {
      var a = t.lanes;
      a &= l.pendingLanes, e |= a, t.lanes = e, jf(l, e);
    }
  }
  var un = {
    readContext: Gl,
    use: fu,
    useCallback: Sl,
    useContext: Sl,
    useEffect: Sl,
    useImperativeHandle: Sl,
    useLayoutEffect: Sl,
    useInsertionEffect: Sl,
    useMemo: Sl,
    useReducer: Sl,
    useRef: Sl,
    useState: Sl,
    useDebugValue: Sl,
    useDeferredValue: Sl,
    useTransition: Sl,
    useSyncExternalStore: Sl,
    useId: Sl,
    useHostTransitionStatus: Sl,
    useFormState: Sl,
    useActionState: Sl,
    useOptimistic: Sl,
    useMemoCache: Sl,
    useCacheRefresh: Sl
  };
  un.useEffectEvent = Sl;
  var xo = {
    readContext: Gl,
    use: fu,
    useCallback: function(l, t) {
      return Wl().memoizedState = [
        l,
        t === void 0 ? null : t
      ], l;
    },
    useContext: Gl,
    useEffect: ao,
    useImperativeHandle: function(l, t, e) {
      e = e != null ? e.concat([l]) : null, ou(
        4194308,
        4,
        co.bind(null, t, l),
        e
      );
    },
    useLayoutEffect: function(l, t) {
      return ou(4194308, 4, l, t);
    },
    useInsertionEffect: function(l, t) {
      ou(4, 2, l, t);
    },
    useMemo: function(l, t) {
      var e = Wl();
      t = t === void 0 ? null : t;
      var a = l();
      if (Xe) {
        le(!0);
        try {
          l();
        } finally {
          le(!1);
        }
      }
      return e.memoizedState = [a, t], a;
    },
    useReducer: function(l, t, e) {
      var a = Wl();
      if (e !== void 0) {
        var n = e(t);
        if (Xe) {
          le(!0);
          try {
            e(t);
          } finally {
            le(!1);
          }
        }
      } else n = t;
      return a.memoizedState = a.baseState = n, l = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: l,
        lastRenderedState: n
      }, a.queue = l, l = l.dispatch = Ih.bind(
        null,
        X,
        l
      ), [a.memoizedState, l];
    },
    useRef: function(l) {
      var t = Wl();
      return l = { current: l }, t.memoizedState = l;
    },
    useState: function(l) {
      l = lc(l);
      var t = l.queue, e = po.bind(null, X, t);
      return t.dispatch = e, [l.memoizedState, e];
    },
    useDebugValue: ac,
    useDeferredValue: function(l, t) {
      var e = Wl();
      return nc(e, l, t);
    },
    useTransition: function() {
      var l = lc(!1);
      return l = ho.bind(
        null,
        X,
        l.queue,
        !0,
        !1
      ), Wl().memoizedState = l, [!1, l];
    },
    useSyncExternalStore: function(l, t, e) {
      var a = X, n = Wl();
      if (k) {
        if (e === void 0)
          throw Error(y(407));
        e = e();
      } else {
        if (e = t(), fl === null)
          throw Error(y(349));
        (K & 127) !== 0 || Qs(a, t, e);
      }
      n.memoizedState = e;
      var u = { value: e, getSnapshot: t };
      return n.queue = u, ao(Zs.bind(null, a, u, l), [
        l
      ]), a.flags |= 2048, ya(
        9,
        { destroy: void 0 },
        Ls.bind(
          null,
          a,
          u,
          e,
          t
        ),
        null
      ), e;
    },
    useId: function() {
      var l = Wl(), t = fl.identifierPrefix;
      if (k) {
        var e = Ut, a = Mt;
        e = (a & ~(1 << 32 - ut(a) - 1)).toString(32) + e, t = "_" + t + "R_" + e, e = iu++, 0 < e && (t += "H" + e.toString(32)), t += "_";
      } else
        e = Vh++, t = "_" + t + "r_" + e.toString(32) + "_";
      return l.memoizedState = t;
    },
    useHostTransitionStatus: ic,
    useFormState: Is,
    useActionState: Is,
    useOptimistic: function(l) {
      var t = Wl();
      t.memoizedState = t.baseState = l;
      var e = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return t.queue = e, t = cc.bind(
        null,
        X,
        !0,
        e
      ), e.dispatch = t, [l, t];
    },
    useMemoCache: Fi,
    useCacheRefresh: function() {
      return Wl().memoizedState = Fh.bind(
        null,
        X
      );
    },
    useEffectEvent: function(l) {
      var t = Wl(), e = { impl: l };
      return t.memoizedState = e, function() {
        if ((tl & 2) !== 0)
          throw Error(y(440));
        return e.impl.apply(void 0, arguments);
      };
    }
  }, fc = {
    readContext: Gl,
    use: fu,
    useCallback: so,
    useContext: Gl,
    useEffect: ec,
    useImperativeHandle: fo,
    useInsertionEffect: uo,
    useLayoutEffect: io,
    useMemo: oo,
    useReducer: su,
    useRef: eo,
    useState: function() {
      return su(wt);
    },
    useDebugValue: ac,
    useDeferredValue: function(l, t) {
      var e = Tl();
      return ro(
        e,
        ul.memoizedState,
        l,
        t
      );
    },
    useTransition: function() {
      var l = su(wt)[0], t = Tl().memoizedState;
      return [
        typeof l == "boolean" ? l : an(l),
        t
      ];
    },
    useSyncExternalStore: Xs,
    useId: yo,
    useHostTransitionStatus: ic,
    useFormState: Ps,
    useActionState: Ps,
    useOptimistic: function(l, t) {
      var e = Tl();
      return Ks(e, ul, l, t);
    },
    useMemoCache: Fi,
    useCacheRefresh: go
  };
  fc.useEffectEvent = no;
  var To = {
    readContext: Gl,
    use: fu,
    useCallback: so,
    useContext: Gl,
    useEffect: ec,
    useImperativeHandle: fo,
    useInsertionEffect: uo,
    useLayoutEffect: io,
    useMemo: oo,
    useReducer: Pi,
    useRef: eo,
    useState: function() {
      return Pi(wt);
    },
    useDebugValue: ac,
    useDeferredValue: function(l, t) {
      var e = Tl();
      return ul === null ? nc(e, l, t) : ro(
        e,
        ul.memoizedState,
        l,
        t
      );
    },
    useTransition: function() {
      var l = Pi(wt)[0], t = Tl().memoizedState;
      return [
        typeof l == "boolean" ? l : an(l),
        t
      ];
    },
    useSyncExternalStore: Xs,
    useId: yo,
    useHostTransitionStatus: ic,
    useFormState: to,
    useActionState: to,
    useOptimistic: function(l, t) {
      var e = Tl();
      return ul !== null ? Ks(e, ul, l, t) : (e.baseState = l, [l, e.queue.dispatch]);
    },
    useMemoCache: Fi,
    useCacheRefresh: go
  };
  To.useEffectEvent = no;
  function sc(l, t, e, a) {
    t = l.memoizedState, e = e(a, t), e = e == null ? t : H({}, t, e), l.memoizedState = e, l.lanes === 0 && (l.updateQueue.baseState = e);
  }
  var oc = {
    enqueueSetState: function(l, t, e) {
      l = l._reactInternals;
      var a = rt(), n = fe(a);
      n.payload = t, e != null && (n.callback = e), t = se(l, n, a), t !== null && (et(t, l, a), Pa(t, l, a));
    },
    enqueueReplaceState: function(l, t, e) {
      l = l._reactInternals;
      var a = rt(), n = fe(a);
      n.tag = 1, n.payload = t, e != null && (n.callback = e), t = se(l, n, a), t !== null && (et(t, l, a), Pa(t, l, a));
    },
    enqueueForceUpdate: function(l, t) {
      l = l._reactInternals;
      var e = rt(), a = fe(e);
      a.tag = 2, t != null && (a.callback = t), t = se(l, a, e), t !== null && (et(t, l, e), Pa(t, l, e));
    }
  };
  function Eo(l, t, e, a, n, u, i) {
    return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(a, u, i) : t.prototype && t.prototype.isPureReactComponent ? !Va(e, a) || !Va(n, u) : !0;
  }
  function jo(l, t, e, a) {
    l = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(e, a), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(e, a), t.state !== l && oc.enqueueReplaceState(t, t.state, null);
  }
  function Qe(l, t) {
    var e = t;
    if ("ref" in t) {
      e = {};
      for (var a in t)
        a !== "ref" && (e[a] = t[a]);
    }
    if (l = l.defaultProps) {
      e === t && (e = H({}, e));
      for (var n in l)
        e[n] === void 0 && (e[n] = l[n]);
    }
    return e;
  }
  function Ao(l) {
    wn(l);
  }
  function zo(l) {
    console.error(l);
  }
  function No(l) {
    wn(l);
  }
  function hu(l, t) {
    try {
      var e = l.onUncaughtError;
      e(t.value, { componentStack: t.stack });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function Oo(l, t, e) {
    try {
      var a = l.onCaughtError;
      a(e.value, {
        componentStack: e.stack,
        errorBoundary: t.tag === 1 ? t.stateNode : null
      });
    } catch (n) {
      setTimeout(function() {
        throw n;
      });
    }
  }
  function dc(l, t, e) {
    return e = fe(e), e.tag = 3, e.payload = { element: null }, e.callback = function() {
      hu(l, t);
    }, e;
  }
  function _o(l) {
    return l = fe(l), l.tag = 3, l;
  }
  function Do(l, t, e, a) {
    var n = e.type.getDerivedStateFromError;
    if (typeof n == "function") {
      var u = a.value;
      l.payload = function() {
        return n(u);
      }, l.callback = function() {
        Oo(t, e, a);
      };
    }
    var i = e.stateNode;
    i !== null && typeof i.componentDidCatch == "function" && (l.callback = function() {
      Oo(t, e, a), typeof n != "function" && (ve === null ? ve = /* @__PURE__ */ new Set([this]) : ve.add(this));
      var f = a.stack;
      this.componentDidCatch(a.value, {
        componentStack: f !== null ? f : ""
      });
    });
  }
  function Ph(l, t, e, a, n) {
    if (e.flags |= 32768, a !== null && typeof a == "object" && typeof a.then == "function") {
      if (t = e.alternate, t !== null && fa(
        t,
        e,
        n,
        !0
      ), e = ft.current, e !== null) {
        switch (e.tag) {
          case 31:
          case 13:
            return xt === null ? Au() : e.alternate === null && bl === 0 && (bl = 3), e.flags &= -257, e.flags |= 65536, e.lanes = n, a === lu ? e.flags |= 16384 : (t = e.updateQueue, t === null ? e.updateQueue = /* @__PURE__ */ new Set([a]) : t.add(a), qc(l, a, n)), !1;
          case 22:
            return e.flags |= 65536, a === lu ? e.flags |= 16384 : (t = e.updateQueue, t === null ? (t = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([a])
            }, e.updateQueue = t) : (e = t.retryQueue, e === null ? t.retryQueue = /* @__PURE__ */ new Set([a]) : e.add(a)), qc(l, a, n)), !1;
        }
        throw Error(y(435, e.tag));
      }
      return qc(l, a, n), Au(), !1;
    }
    if (k)
      return t = ft.current, t !== null ? ((t.flags & 65536) === 0 && (t.flags |= 256), t.flags |= 65536, t.lanes = n, a !== Di && (l = Error(y(422), { cause: a }), Wa(gt(l, e)))) : (a !== Di && (t = Error(y(423), {
        cause: a
      }), Wa(
        gt(t, e)
      )), l = l.current.alternate, l.flags |= 65536, n &= -n, l.lanes |= n, a = gt(a, e), n = dc(
        l.stateNode,
        a,
        n
      ), Qi(l, n), bl !== 4 && (bl = 2)), !1;
    var u = Error(y(520), { cause: a });
    if (u = gt(u, e), mn === null ? mn = [u] : mn.push(u), bl !== 4 && (bl = 2), t === null) return !0;
    a = gt(a, e), e = t;
    do {
      switch (e.tag) {
        case 3:
          return e.flags |= 65536, l = n & -n, e.lanes |= l, l = dc(e.stateNode, a, l), Qi(e, l), !1;
        case 1:
          if (t = e.type, u = e.stateNode, (e.flags & 128) === 0 && (typeof t.getDerivedStateFromError == "function" || u !== null && typeof u.componentDidCatch == "function" && (ve === null || !ve.has(u))))
            return e.flags |= 65536, n &= -n, e.lanes |= n, n = _o(n), Do(
              n,
              l,
              e,
              a
            ), Qi(e, n), !1;
      }
      e = e.return;
    } while (e !== null);
    return !1;
  }
  var rc = Error(y(461)), Dl = !1;
  function Xl(l, t, e, a) {
    t.child = l === null ? Cs(t, null, e, a) : Ge(
      t,
      l.child,
      e,
      a
    );
  }
  function Mo(l, t, e, a, n) {
    e = e.render;
    var u = t.ref;
    if ("ref" in a) {
      var i = {};
      for (var f in a)
        f !== "ref" && (i[f] = a[f]);
    } else i = a;
    return He(t), a = Ji(
      l,
      t,
      e,
      i,
      u,
      n
    ), f = Wi(), l !== null && !Dl ? (ki(l, t, n), Vt(l, t, n)) : (k && f && Oi(t), t.flags |= 1, Xl(l, t, a, n), t.child);
  }
  function Uo(l, t, e, a, n) {
    if (l === null) {
      var u = e.type;
      return typeof u == "function" && !Ai(u) && u.defaultProps === void 0 && e.compare === null ? (t.tag = 15, t.type = u, Co(
        l,
        t,
        u,
        a,
        n
      )) : (l = Wn(
        e.type,
        null,
        a,
        t,
        t.mode,
        n
      ), l.ref = t.ref, l.return = t, t.child = l);
    }
    if (u = l.child, !bc(l, n)) {
      var i = u.memoizedProps;
      if (e = e.compare, e = e !== null ? e : Va, e(i, a) && l.ref === t.ref)
        return Vt(l, t, n);
    }
    return t.flags |= 1, l = Gt(u, a), l.ref = t.ref, l.return = t, t.child = l;
  }
  function Co(l, t, e, a, n) {
    if (l !== null) {
      var u = l.memoizedProps;
      if (Va(u, a) && l.ref === t.ref)
        if (Dl = !1, t.pendingProps = a = u, bc(l, n))
          (l.flags & 131072) !== 0 && (Dl = !0);
        else
          return t.lanes = l.lanes, Vt(l, t, n);
    }
    return hc(
      l,
      t,
      e,
      a,
      n
    );
  }
  function Ro(l, t, e, a) {
    var n = a.children, u = l !== null ? l.memoizedState : null;
    if (l === null && t.stateNode === null && (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), a.mode === "hidden") {
      if ((t.flags & 128) !== 0) {
        if (u = u !== null ? u.baseLanes | e : e, l !== null) {
          for (a = t.child = l.child, n = 0; a !== null; )
            n = n | a.lanes | a.childLanes, a = a.sibling;
          a = n & ~u;
        } else a = 0, t.child = null;
        return Ho(
          l,
          t,
          u,
          e,
          a
        );
      }
      if ((e & 536870912) !== 0)
        t.memoizedState = { baseLanes: 0, cachePool: null }, l !== null && In(
          t,
          u !== null ? u.cachePool : null
        ), u !== null ? qs(t, u) : Zi(), Bs(t);
      else
        return a = t.lanes = 536870912, Ho(
          l,
          t,
          u !== null ? u.baseLanes | e : e,
          e,
          a
        );
    } else
      u !== null ? (In(t, u.cachePool), qs(t, u), de(), t.memoizedState = null) : (l !== null && In(t, null), Zi(), de());
    return Xl(l, t, n, e), t.child;
  }
  function cn(l, t) {
    return l !== null && l.tag === 22 || t.stateNode !== null || (t.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), t.sibling;
  }
  function Ho(l, t, e, a, n) {
    var u = Bi();
    return u = u === null ? null : { parent: Ol._currentValue, pool: u }, t.memoizedState = {
      baseLanes: e,
      cachePool: u
    }, l !== null && In(t, null), Zi(), Bs(t), l !== null && fa(l, t, a, !0), t.childLanes = n, null;
  }
  function mu(l, t) {
    return t = yu(
      { mode: t.mode, children: t.children },
      l.mode
    ), t.ref = l.ref, l.child = t, t.return = l, t;
  }
  function qo(l, t, e) {
    return Ge(t, l.child, null, e), l = mu(t, t.pendingProps), l.flags |= 2, st(t), t.memoizedState = null, l;
  }
  function lm(l, t, e) {
    var a = t.pendingProps, n = (t.flags & 128) !== 0;
    if (t.flags &= -129, l === null) {
      if (k) {
        if (a.mode === "hidden")
          return l = mu(t, a), t.lanes = 536870912, cn(null, l);
        if (Vi(t), (l = rl) ? (l = Wd(
          l,
          bt
        ), l = l !== null && l.data === "&" ? l : null, l !== null && (t.memoizedState = {
          dehydrated: l,
          treeContext: ae !== null ? { id: Mt, overflow: Ut } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = ps(l), e.return = t, t.child = e, Yl = t, rl = null)) : l = null, l === null) throw ue(t);
        return t.lanes = 536870912, null;
      }
      return mu(t, a);
    }
    var u = l.memoizedState;
    if (u !== null) {
      var i = u.dehydrated;
      if (Vi(t), n)
        if (t.flags & 256)
          t.flags &= -257, t = qo(
            l,
            t,
            e
          );
        else if (t.memoizedState !== null)
          t.child = l.child, t.flags |= 128, t = null;
        else throw Error(y(558));
      else if (Dl || fa(l, t, e, !1), n = (e & l.childLanes) !== 0, Dl || n) {
        if (a = fl, a !== null && (i = Af(a, e), i !== 0 && i !== u.retryLane))
          throw u.retryLane = i, Me(l, i), et(a, l, i), rc;
        Au(), t = qo(
          l,
          t,
          e
        );
      } else
        l = u.treeContext, rl = Tt(i.nextSibling), Yl = t, k = !0, ne = null, bt = !1, l !== null && xs(t, l), t = mu(t, a), t.flags |= 4096;
      return t;
    }
    return l = Gt(l.child, {
      mode: a.mode,
      children: a.children
    }), l.ref = t.ref, t.child = l, l.return = t, l;
  }
  function vu(l, t) {
    var e = t.ref;
    if (e === null)
      l !== null && l.ref !== null && (t.flags |= 4194816);
    else {
      if (typeof e != "function" && typeof e != "object")
        throw Error(y(284));
      (l === null || l.ref !== e) && (t.flags |= 4194816);
    }
  }
  function hc(l, t, e, a, n) {
    return He(t), e = Ji(
      l,
      t,
      e,
      a,
      void 0,
      n
    ), a = Wi(), l !== null && !Dl ? (ki(l, t, n), Vt(l, t, n)) : (k && a && Oi(t), t.flags |= 1, Xl(l, t, e, n), t.child);
  }
  function Bo(l, t, e, a, n, u) {
    return He(t), t.updateQueue = null, e = Gs(
      t,
      a,
      e,
      n
    ), Ys(l), a = Wi(), l !== null && !Dl ? (ki(l, t, u), Vt(l, t, u)) : (k && a && Oi(t), t.flags |= 1, Xl(l, t, e, u), t.child);
  }
  function Yo(l, t, e, a, n) {
    if (He(t), t.stateNode === null) {
      var u = na, i = e.contextType;
      typeof i == "object" && i !== null && (u = Gl(i)), u = new e(a, u), t.memoizedState = u.state !== null && u.state !== void 0 ? u.state : null, u.updater = oc, t.stateNode = u, u._reactInternals = t, u = t.stateNode, u.props = a, u.state = t.memoizedState, u.refs = {}, Gi(t), i = e.contextType, u.context = typeof i == "object" && i !== null ? Gl(i) : na, u.state = t.memoizedState, i = e.getDerivedStateFromProps, typeof i == "function" && (sc(
        t,
        e,
        i,
        a
      ), u.state = t.memoizedState), typeof e.getDerivedStateFromProps == "function" || typeof u.getSnapshotBeforeUpdate == "function" || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (i = u.state, typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount(), i !== u.state && oc.enqueueReplaceState(u, u.state, null), tn(t, a, u, n), ln(), u.state = t.memoizedState), typeof u.componentDidMount == "function" && (t.flags |= 4194308), a = !0;
    } else if (l === null) {
      u = t.stateNode;
      var f = t.memoizedProps, s = Qe(e, f);
      u.props = s;
      var m = u.context, S = e.contextType;
      i = na, typeof S == "object" && S !== null && (i = Gl(S));
      var x = e.getDerivedStateFromProps;
      S = typeof x == "function" || typeof u.getSnapshotBeforeUpdate == "function", f = t.pendingProps !== f, S || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (f || m !== i) && jo(
        t,
        u,
        a,
        i
      ), ce = !1;
      var v = t.memoizedState;
      u.state = v, tn(t, a, u, n), ln(), m = t.memoizedState, f || v !== m || ce ? (typeof x == "function" && (sc(
        t,
        e,
        x,
        a
      ), m = t.memoizedState), (s = ce || Eo(
        t,
        e,
        s,
        a,
        v,
        m,
        i
      )) ? (S || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount()), typeof u.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof u.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = a, t.memoizedState = m), u.props = a, u.state = m, u.context = i, a = s) : (typeof u.componentDidMount == "function" && (t.flags |= 4194308), a = !1);
    } else {
      u = t.stateNode, Xi(l, t), i = t.memoizedProps, S = Qe(e, i), u.props = S, x = t.pendingProps, v = u.context, m = e.contextType, s = na, typeof m == "object" && m !== null && (s = Gl(m)), f = e.getDerivedStateFromProps, (m = typeof f == "function" || typeof u.getSnapshotBeforeUpdate == "function") || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (i !== x || v !== s) && jo(
        t,
        u,
        a,
        s
      ), ce = !1, v = t.memoizedState, u.state = v, tn(t, a, u, n), ln();
      var g = t.memoizedState;
      i !== x || v !== g || ce || l !== null && l.dependencies !== null && $n(l.dependencies) ? (typeof f == "function" && (sc(
        t,
        e,
        f,
        a
      ), g = t.memoizedState), (S = ce || Eo(
        t,
        e,
        S,
        a,
        v,
        g,
        s
      ) || l !== null && l.dependencies !== null && $n(l.dependencies)) ? (m || typeof u.UNSAFE_componentWillUpdate != "function" && typeof u.componentWillUpdate != "function" || (typeof u.componentWillUpdate == "function" && u.componentWillUpdate(a, g, s), typeof u.UNSAFE_componentWillUpdate == "function" && u.UNSAFE_componentWillUpdate(
        a,
        g,
        s
      )), typeof u.componentDidUpdate == "function" && (t.flags |= 4), typeof u.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof u.componentDidUpdate != "function" || i === l.memoizedProps && v === l.memoizedState || (t.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || i === l.memoizedProps && v === l.memoizedState || (t.flags |= 1024), t.memoizedProps = a, t.memoizedState = g), u.props = a, u.state = g, u.context = s, a = S) : (typeof u.componentDidUpdate != "function" || i === l.memoizedProps && v === l.memoizedState || (t.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || i === l.memoizedProps && v === l.memoizedState || (t.flags |= 1024), a = !1);
    }
    return u = a, vu(l, t), a = (t.flags & 128) !== 0, u || a ? (u = t.stateNode, e = a && typeof e.getDerivedStateFromError != "function" ? null : u.render(), t.flags |= 1, l !== null && a ? (t.child = Ge(
      t,
      l.child,
      null,
      n
    ), t.child = Ge(
      t,
      null,
      e,
      n
    )) : Xl(l, t, e, n), t.memoizedState = u.state, l = t.child) : l = Vt(
      l,
      t,
      n
    ), l;
  }
  function Go(l, t, e, a) {
    return Ce(), t.flags |= 256, Xl(l, t, e, a), t.child;
  }
  var mc = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function vc(l) {
    return { baseLanes: l, cachePool: Ns() };
  }
  function yc(l, t, e) {
    return l = l !== null ? l.childLanes & ~e : 0, t && (l |= dt), l;
  }
  function Xo(l, t, e) {
    var a = t.pendingProps, n = !1, u = (t.flags & 128) !== 0, i;
    if ((i = u) || (i = l !== null && l.memoizedState === null ? !1 : (xl.current & 2) !== 0), i && (n = !0, t.flags &= -129), i = (t.flags & 32) !== 0, t.flags &= -33, l === null) {
      if (k) {
        if (n ? oe(t) : de(), (l = rl) ? (l = Wd(
          l,
          bt
        ), l = l !== null && l.data !== "&" ? l : null, l !== null && (t.memoizedState = {
          dehydrated: l,
          treeContext: ae !== null ? { id: Mt, overflow: Ut } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, e = ps(l), e.return = t, t.child = e, Yl = t, rl = null)) : l = null, l === null) throw ue(t);
        return Ic(l) ? t.lanes = 32 : t.lanes = 536870912, null;
      }
      var f = a.children;
      return a = a.fallback, n ? (de(), n = t.mode, f = yu(
        { mode: "hidden", children: f },
        n
      ), a = Ue(
        a,
        n,
        e,
        null
      ), f.return = t, a.return = t, f.sibling = a, t.child = f, a = t.child, a.memoizedState = vc(e), a.childLanes = yc(
        l,
        i,
        e
      ), t.memoizedState = mc, cn(null, a)) : (oe(t), gc(t, f));
    }
    var s = l.memoizedState;
    if (s !== null && (f = s.dehydrated, f !== null)) {
      if (u)
        t.flags & 256 ? (oe(t), t.flags &= -257, t = pc(
          l,
          t,
          e
        )) : t.memoizedState !== null ? (de(), t.child = l.child, t.flags |= 128, t = null) : (de(), f = a.fallback, n = t.mode, a = yu(
          { mode: "visible", children: a.children },
          n
        ), f = Ue(
          f,
          n,
          e,
          null
        ), f.flags |= 2, a.return = t, f.return = t, a.sibling = f, t.child = a, Ge(
          t,
          l.child,
          null,
          e
        ), a = t.child, a.memoizedState = vc(e), a.childLanes = yc(
          l,
          i,
          e
        ), t.memoizedState = mc, t = cn(null, a));
      else if (oe(t), Ic(f)) {
        if (i = f.nextSibling && f.nextSibling.dataset, i) var m = i.dgst;
        i = m, a = Error(y(419)), a.stack = "", a.digest = i, Wa({ value: a, source: null, stack: null }), t = pc(
          l,
          t,
          e
        );
      } else if (Dl || fa(l, t, e, !1), i = (e & l.childLanes) !== 0, Dl || i) {
        if (i = fl, i !== null && (a = Af(i, e), a !== 0 && a !== s.retryLane))
          throw s.retryLane = a, Me(l, a), et(i, l, a), rc;
        Fc(f) || Au(), t = pc(
          l,
          t,
          e
        );
      } else
        Fc(f) ? (t.flags |= 192, t.child = l.child, t = null) : (l = s.treeContext, rl = Tt(
          f.nextSibling
        ), Yl = t, k = !0, ne = null, bt = !1, l !== null && xs(t, l), t = gc(
          t,
          a.children
        ), t.flags |= 4096);
      return t;
    }
    return n ? (de(), f = a.fallback, n = t.mode, s = l.child, m = s.sibling, a = Gt(s, {
      mode: "hidden",
      children: a.children
    }), a.subtreeFlags = s.subtreeFlags & 65011712, m !== null ? f = Gt(
      m,
      f
    ) : (f = Ue(
      f,
      n,
      e,
      null
    ), f.flags |= 2), f.return = t, a.return = t, a.sibling = f, t.child = a, cn(null, a), a = t.child, f = l.child.memoizedState, f === null ? f = vc(e) : (n = f.cachePool, n !== null ? (s = Ol._currentValue, n = n.parent !== s ? { parent: s, pool: s } : n) : n = Ns(), f = {
      baseLanes: f.baseLanes | e,
      cachePool: n
    }), a.memoizedState = f, a.childLanes = yc(
      l,
      i,
      e
    ), t.memoizedState = mc, cn(l.child, a)) : (oe(t), e = l.child, l = e.sibling, e = Gt(e, {
      mode: "visible",
      children: a.children
    }), e.return = t, e.sibling = null, l !== null && (i = t.deletions, i === null ? (t.deletions = [l], t.flags |= 16) : i.push(l)), t.child = e, t.memoizedState = null, e);
  }
  function gc(l, t) {
    return t = yu(
      { mode: "visible", children: t },
      l.mode
    ), t.return = l, l.child = t;
  }
  function yu(l, t) {
    return l = ct(22, l, null, t), l.lanes = 0, l;
  }
  function pc(l, t, e) {
    return Ge(t, l.child, null, e), l = gc(
      t,
      t.pendingProps.children
    ), l.flags |= 2, t.memoizedState = null, l;
  }
  function Qo(l, t, e) {
    l.lanes |= t;
    var a = l.alternate;
    a !== null && (a.lanes |= t), Ci(l.return, t, e);
  }
  function Sc(l, t, e, a, n, u) {
    var i = l.memoizedState;
    i === null ? l.memoizedState = {
      isBackwards: t,
      rendering: null,
      renderingStartTime: 0,
      last: a,
      tail: e,
      tailMode: n,
      treeForkCount: u
    } : (i.isBackwards = t, i.rendering = null, i.renderingStartTime = 0, i.last = a, i.tail = e, i.tailMode = n, i.treeForkCount = u);
  }
  function Lo(l, t, e) {
    var a = t.pendingProps, n = a.revealOrder, u = a.tail;
    a = a.children;
    var i = xl.current, f = (i & 2) !== 0;
    if (f ? (i = i & 1 | 2, t.flags |= 128) : i &= 1, A(xl, i), Xl(l, t, a, e), a = k ? Ja : 0, !f && l !== null && (l.flags & 128) !== 0)
      l: for (l = t.child; l !== null; ) {
        if (l.tag === 13)
          l.memoizedState !== null && Qo(l, e, t);
        else if (l.tag === 19)
          Qo(l, e, t);
        else if (l.child !== null) {
          l.child.return = l, l = l.child;
          continue;
        }
        if (l === t) break l;
        for (; l.sibling === null; ) {
          if (l.return === null || l.return === t)
            break l;
          l = l.return;
        }
        l.sibling.return = l.return, l = l.sibling;
      }
    switch (n) {
      case "forwards":
        for (e = t.child, n = null; e !== null; )
          l = e.alternate, l !== null && nu(l) === null && (n = e), e = e.sibling;
        e = n, e === null ? (n = t.child, t.child = null) : (n = e.sibling, e.sibling = null), Sc(
          t,
          !1,
          n,
          e,
          u,
          a
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        for (e = null, n = t.child, t.child = null; n !== null; ) {
          if (l = n.alternate, l !== null && nu(l) === null) {
            t.child = n;
            break;
          }
          l = n.sibling, n.sibling = e, e = n, n = l;
        }
        Sc(
          t,
          !0,
          e,
          null,
          u,
          a
        );
        break;
      case "together":
        Sc(
          t,
          !1,
          null,
          null,
          void 0,
          a
        );
        break;
      default:
        t.memoizedState = null;
    }
    return t.child;
  }
  function Vt(l, t, e) {
    if (l !== null && (t.dependencies = l.dependencies), me |= t.lanes, (e & t.childLanes) === 0)
      if (l !== null) {
        if (fa(
          l,
          t,
          e,
          !1
        ), (e & t.childLanes) === 0)
          return null;
      } else return null;
    if (l !== null && t.child !== l.child)
      throw Error(y(153));
    if (t.child !== null) {
      for (l = t.child, e = Gt(l, l.pendingProps), t.child = e, e.return = t; l.sibling !== null; )
        l = l.sibling, e = e.sibling = Gt(l, l.pendingProps), e.return = t;
      e.sibling = null;
    }
    return t.child;
  }
  function bc(l, t) {
    return (l.lanes & t) !== 0 ? !0 : (l = l.dependencies, !!(l !== null && $n(l)));
  }
  function tm(l, t, e) {
    switch (t.tag) {
      case 3:
        Ul(t, t.stateNode.containerInfo), ie(t, Ol, l.memoizedState.cache), Ce();
        break;
      case 27:
      case 5:
        At(t);
        break;
      case 4:
        Ul(t, t.stateNode.containerInfo);
        break;
      case 10:
        ie(
          t,
          t.type,
          t.memoizedProps.value
        );
        break;
      case 31:
        if (t.memoizedState !== null)
          return t.flags |= 128, Vi(t), null;
        break;
      case 13:
        var a = t.memoizedState;
        if (a !== null)
          return a.dehydrated !== null ? (oe(t), t.flags |= 128, null) : (e & t.child.childLanes) !== 0 ? Xo(l, t, e) : (oe(t), l = Vt(
            l,
            t,
            e
          ), l !== null ? l.sibling : null);
        oe(t);
        break;
      case 19:
        var n = (l.flags & 128) !== 0;
        if (a = (e & t.childLanes) !== 0, a || (fa(
          l,
          t,
          e,
          !1
        ), a = (e & t.childLanes) !== 0), n) {
          if (a)
            return Lo(
              l,
              t,
              e
            );
          t.flags |= 128;
        }
        if (n = t.memoizedState, n !== null && (n.rendering = null, n.tail = null, n.lastEffect = null), A(xl, xl.current), a) break;
        return null;
      case 22:
        return t.lanes = 0, Ro(
          l,
          t,
          e,
          t.pendingProps
        );
      case 24:
        ie(t, Ol, l.memoizedState.cache);
    }
    return Vt(l, t, e);
  }
  function Zo(l, t, e) {
    if (l !== null)
      if (l.memoizedProps !== t.pendingProps)
        Dl = !0;
      else {
        if (!bc(l, e) && (t.flags & 128) === 0)
          return Dl = !1, tm(
            l,
            t,
            e
          );
        Dl = (l.flags & 131072) !== 0;
      }
    else
      Dl = !1, k && (t.flags & 1048576) !== 0 && bs(t, Ja, t.index);
    switch (t.lanes = 0, t.tag) {
      case 16:
        l: {
          var a = t.pendingProps;
          if (l = Be(t.elementType), t.type = l, typeof l == "function")
            Ai(l) ? (a = Qe(l, a), t.tag = 1, t = Yo(
              null,
              t,
              l,
              a,
              e
            )) : (t.tag = 0, t = hc(
              null,
              t,
              l,
              a,
              e
            ));
          else {
            if (l != null) {
              var n = l.$$typeof;
              if (n === kl) {
                t.tag = 11, t = Mo(
                  null,
                  t,
                  l,
                  a,
                  e
                );
                break l;
              } else if (n === Z) {
                t.tag = 14, t = Uo(
                  null,
                  t,
                  l,
                  a,
                  e
                );
                break l;
              }
            }
            throw t = Nl(l) || l, Error(y(306, t, ""));
          }
        }
        return t;
      case 0:
        return hc(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 1:
        return a = t.type, n = Qe(
          a,
          t.pendingProps
        ), Yo(
          l,
          t,
          a,
          n,
          e
        );
      case 3:
        l: {
          if (Ul(
            t,
            t.stateNode.containerInfo
          ), l === null) throw Error(y(387));
          a = t.pendingProps;
          var u = t.memoizedState;
          n = u.element, Xi(l, t), tn(t, a, null, e);
          var i = t.memoizedState;
          if (a = i.cache, ie(t, Ol, a), a !== u.cache && Ri(
            t,
            [Ol],
            e,
            !0
          ), ln(), a = i.element, u.isDehydrated)
            if (u = {
              element: a,
              isDehydrated: !1,
              cache: i.cache
            }, t.updateQueue.baseState = u, t.memoizedState = u, t.flags & 256) {
              t = Go(
                l,
                t,
                a,
                e
              );
              break l;
            } else if (a !== n) {
              n = gt(
                Error(y(424)),
                t
              ), Wa(n), t = Go(
                l,
                t,
                a,
                e
              );
              break l;
            } else
              for (l = t.stateNode.containerInfo, l.nodeType === 9 ? l = l.body : l = l.nodeName === "HTML" ? l.ownerDocument.body : l, rl = Tt(l.firstChild), Yl = t, k = !0, ne = null, bt = !0, e = Cs(
                t,
                null,
                a,
                e
              ), t.child = e; e; )
                e.flags = e.flags & -3 | 4096, e = e.sibling;
          else {
            if (Ce(), a === n) {
              t = Vt(
                l,
                t,
                e
              );
              break l;
            }
            Xl(l, t, a, e);
          }
          t = t.child;
        }
        return t;
      case 26:
        return vu(l, t), l === null ? (e = lr(
          t.type,
          null,
          t.pendingProps,
          null
        )) ? t.memoizedState = e : k || (e = t.type, l = t.pendingProps, a = Uu(
          L.current
        ).createElement(e), a[Bl] = t, a[$l] = l, Ql(a, e, l), Hl(a), t.stateNode = a) : t.memoizedState = lr(
          t.type,
          l.memoizedProps,
          t.pendingProps,
          l.memoizedState
        ), null;
      case 27:
        return At(t), l === null && k && (a = t.stateNode = Fd(
          t.type,
          t.pendingProps,
          L.current
        ), Yl = t, bt = !0, n = rl, Se(t.type) ? (Pc = n, rl = Tt(a.firstChild)) : rl = n), Xl(
          l,
          t,
          t.pendingProps.children,
          e
        ), vu(l, t), l === null && (t.flags |= 4194304), t.child;
      case 5:
        return l === null && k && ((n = a = rl) && (a = Mm(
          a,
          t.type,
          t.pendingProps,
          bt
        ), a !== null ? (t.stateNode = a, Yl = t, rl = Tt(a.firstChild), bt = !1, n = !0) : n = !1), n || ue(t)), At(t), n = t.type, u = t.pendingProps, i = l !== null ? l.memoizedProps : null, a = u.children, Wc(n, u) ? a = null : i !== null && Wc(n, i) && (t.flags |= 32), t.memoizedState !== null && (n = Ji(
          l,
          t,
          Kh,
          null,
          null,
          e
        ), Tn._currentValue = n), vu(l, t), Xl(l, t, a, e), t.child;
      case 6:
        return l === null && k && ((l = e = rl) && (e = Um(
          e,
          t.pendingProps,
          bt
        ), e !== null ? (t.stateNode = e, Yl = t, rl = null, l = !0) : l = !1), l || ue(t)), null;
      case 13:
        return Xo(l, t, e);
      case 4:
        return Ul(
          t,
          t.stateNode.containerInfo
        ), a = t.pendingProps, l === null ? t.child = Ge(
          t,
          null,
          a,
          e
        ) : Xl(l, t, a, e), t.child;
      case 11:
        return Mo(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 7:
        return Xl(
          l,
          t,
          t.pendingProps,
          e
        ), t.child;
      case 8:
        return Xl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 12:
        return Xl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 10:
        return a = t.pendingProps, ie(t, t.type, a.value), Xl(l, t, a.children, e), t.child;
      case 9:
        return n = t.type._context, a = t.pendingProps.children, He(t), n = Gl(n), a = a(n), t.flags |= 1, Xl(l, t, a, e), t.child;
      case 14:
        return Uo(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 15:
        return Co(
          l,
          t,
          t.type,
          t.pendingProps,
          e
        );
      case 19:
        return Lo(l, t, e);
      case 31:
        return lm(l, t, e);
      case 22:
        return Ro(
          l,
          t,
          e,
          t.pendingProps
        );
      case 24:
        return He(t), a = Gl(Ol), l === null ? (n = Bi(), n === null && (n = fl, u = Hi(), n.pooledCache = u, u.refCount++, u !== null && (n.pooledCacheLanes |= e), n = u), t.memoizedState = { parent: a, cache: n }, Gi(t), ie(t, Ol, n)) : ((l.lanes & e) !== 0 && (Xi(l, t), tn(t, null, null, e), ln()), n = l.memoizedState, u = t.memoizedState, n.parent !== a ? (n = { parent: a, cache: a }, t.memoizedState = n, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = n), ie(t, Ol, a)) : (a = u.cache, ie(t, Ol, a), a !== n.cache && Ri(
          t,
          [Ol],
          e,
          !0
        ))), Xl(
          l,
          t,
          t.pendingProps.children,
          e
        ), t.child;
      case 29:
        throw t.pendingProps;
    }
    throw Error(y(156, t.tag));
  }
  function Kt(l) {
    l.flags |= 4;
  }
  function xc(l, t, e, a, n) {
    if ((t = (l.mode & 32) !== 0) && (t = !1), t) {
      if (l.flags |= 16777216, (n & 335544128) === n)
        if (l.stateNode.complete) l.flags |= 8192;
        else if (yd()) l.flags |= 8192;
        else
          throw Ye = lu, Yi;
    } else l.flags &= -16777217;
  }
  function wo(l, t) {
    if (t.type !== "stylesheet" || (t.state.loading & 4) !== 0)
      l.flags &= -16777217;
    else if (l.flags |= 16777216, !ur(t))
      if (yd()) l.flags |= 8192;
      else
        throw Ye = lu, Yi;
  }
  function gu(l, t) {
    t !== null && (l.flags |= 4), l.flags & 16384 && (t = l.tag !== 22 ? Tf() : 536870912, l.lanes |= t, ba |= t);
  }
  function fn(l, t) {
    if (!k)
      switch (l.tailMode) {
        case "hidden":
          t = l.tail;
          for (var e = null; t !== null; )
            t.alternate !== null && (e = t), t = t.sibling;
          e === null ? l.tail = null : e.sibling = null;
          break;
        case "collapsed":
          e = l.tail;
          for (var a = null; e !== null; )
            e.alternate !== null && (a = e), e = e.sibling;
          a === null ? t || l.tail === null ? l.tail = null : l.tail.sibling = null : a.sibling = null;
      }
  }
  function hl(l) {
    var t = l.alternate !== null && l.alternate.child === l.child, e = 0, a = 0;
    if (t)
      for (var n = l.child; n !== null; )
        e |= n.lanes | n.childLanes, a |= n.subtreeFlags & 65011712, a |= n.flags & 65011712, n.return = l, n = n.sibling;
    else
      for (n = l.child; n !== null; )
        e |= n.lanes | n.childLanes, a |= n.subtreeFlags, a |= n.flags, n.return = l, n = n.sibling;
    return l.subtreeFlags |= a, l.childLanes = e, t;
  }
  function em(l, t, e) {
    var a = t.pendingProps;
    switch (_i(t), t.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return hl(t), null;
      case 1:
        return hl(t), null;
      case 3:
        return e = t.stateNode, a = null, l !== null && (a = l.memoizedState.cache), t.memoizedState.cache !== a && (t.flags |= 2048), Lt(Ol), dl(), e.pendingContext && (e.context = e.pendingContext, e.pendingContext = null), (l === null || l.child === null) && (ca(t) ? Kt(t) : l === null || l.memoizedState.isDehydrated && (t.flags & 256) === 0 || (t.flags |= 1024, Mi())), hl(t), null;
      case 26:
        var n = t.type, u = t.memoizedState;
        return l === null ? (Kt(t), u !== null ? (hl(t), wo(t, u)) : (hl(t), xc(
          t,
          n,
          null,
          a,
          e
        ))) : u ? u !== l.memoizedState ? (Kt(t), hl(t), wo(t, u)) : (hl(t), t.flags &= -16777217) : (l = l.memoizedProps, l !== a && Kt(t), hl(t), xc(
          t,
          n,
          l,
          a,
          e
        )), null;
      case 27:
        if (we(t), e = L.current, n = t.type, l !== null && t.stateNode != null)
          l.memoizedProps !== a && Kt(t);
        else {
          if (!a) {
            if (t.stateNode === null)
              throw Error(y(166));
            return hl(t), null;
          }
          l = _.current, ca(t) ? Ts(t) : (l = Fd(n, a, e), t.stateNode = l, Kt(t));
        }
        return hl(t), null;
      case 5:
        if (we(t), n = t.type, l !== null && t.stateNode != null)
          l.memoizedProps !== a && Kt(t);
        else {
          if (!a) {
            if (t.stateNode === null)
              throw Error(y(166));
            return hl(t), null;
          }
          if (u = _.current, ca(t))
            Ts(t);
          else {
            var i = Uu(
              L.current
            );
            switch (u) {
              case 1:
                u = i.createElementNS(
                  "http://www.w3.org/2000/svg",
                  n
                );
                break;
              case 2:
                u = i.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  n
                );
                break;
              default:
                switch (n) {
                  case "svg":
                    u = i.createElementNS(
                      "http://www.w3.org/2000/svg",
                      n
                    );
                    break;
                  case "math":
                    u = i.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      n
                    );
                    break;
                  case "script":
                    u = i.createElement("div"), u.innerHTML = "<script><\/script>", u = u.removeChild(
                      u.firstChild
                    );
                    break;
                  case "select":
                    u = typeof a.is == "string" ? i.createElement("select", {
                      is: a.is
                    }) : i.createElement("select"), a.multiple ? u.multiple = !0 : a.size && (u.size = a.size);
                    break;
                  default:
                    u = typeof a.is == "string" ? i.createElement(n, { is: a.is }) : i.createElement(n);
                }
            }
            u[Bl] = t, u[$l] = a;
            l: for (i = t.child; i !== null; ) {
              if (i.tag === 5 || i.tag === 6)
                u.appendChild(i.stateNode);
              else if (i.tag !== 4 && i.tag !== 27 && i.child !== null) {
                i.child.return = i, i = i.child;
                continue;
              }
              if (i === t) break l;
              for (; i.sibling === null; ) {
                if (i.return === null || i.return === t)
                  break l;
                i = i.return;
              }
              i.sibling.return = i.return, i = i.sibling;
            }
            t.stateNode = u;
            l: switch (Ql(u, n, a), n) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                a = !!a.autoFocus;
                break l;
              case "img":
                a = !0;
                break l;
              default:
                a = !1;
            }
            a && Kt(t);
          }
        }
        return hl(t), xc(
          t,
          t.type,
          l === null ? null : l.memoizedProps,
          t.pendingProps,
          e
        ), null;
      case 6:
        if (l && t.stateNode != null)
          l.memoizedProps !== a && Kt(t);
        else {
          if (typeof a != "string" && t.stateNode === null)
            throw Error(y(166));
          if (l = L.current, ca(t)) {
            if (l = t.stateNode, e = t.memoizedProps, a = null, n = Yl, n !== null)
              switch (n.tag) {
                case 27:
                case 5:
                  a = n.memoizedProps;
              }
            l[Bl] = t, l = !!(l.nodeValue === e || a !== null && a.suppressHydrationWarning === !0 || Xd(l.nodeValue, e)), l || ue(t, !0);
          } else
            l = Uu(l).createTextNode(
              a
            ), l[Bl] = t, t.stateNode = l;
        }
        return hl(t), null;
      case 31:
        if (e = t.memoizedState, l === null || l.memoizedState !== null) {
          if (a = ca(t), e !== null) {
            if (l === null) {
              if (!a) throw Error(y(318));
              if (l = t.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(y(557));
              l[Bl] = t;
            } else
              Ce(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            hl(t), l = !1;
          } else
            e = Mi(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = e), l = !0;
          if (!l)
            return t.flags & 256 ? (st(t), t) : (st(t), null);
          if ((t.flags & 128) !== 0)
            throw Error(y(558));
        }
        return hl(t), null;
      case 13:
        if (a = t.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
          if (n = ca(t), a !== null && a.dehydrated !== null) {
            if (l === null) {
              if (!n) throw Error(y(318));
              if (n = t.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(y(317));
              n[Bl] = t;
            } else
              Ce(), (t.flags & 128) === 0 && (t.memoizedState = null), t.flags |= 4;
            hl(t), n = !1;
          } else
            n = Mi(), l !== null && l.memoizedState !== null && (l.memoizedState.hydrationErrors = n), n = !0;
          if (!n)
            return t.flags & 256 ? (st(t), t) : (st(t), null);
        }
        return st(t), (t.flags & 128) !== 0 ? (t.lanes = e, t) : (e = a !== null, l = l !== null && l.memoizedState !== null, e && (a = t.child, n = null, a.alternate !== null && a.alternate.memoizedState !== null && a.alternate.memoizedState.cachePool !== null && (n = a.alternate.memoizedState.cachePool.pool), u = null, a.memoizedState !== null && a.memoizedState.cachePool !== null && (u = a.memoizedState.cachePool.pool), u !== n && (a.flags |= 2048)), e !== l && e && (t.child.flags |= 8192), gu(t, t.updateQueue), hl(t), null);
      case 4:
        return dl(), l === null && Zc(t.stateNode.containerInfo), hl(t), null;
      case 10:
        return Lt(t.type), hl(t), null;
      case 19:
        if (T(xl), a = t.memoizedState, a === null) return hl(t), null;
        if (n = (t.flags & 128) !== 0, u = a.rendering, u === null)
          if (n) fn(a, !1);
          else {
            if (bl !== 0 || l !== null && (l.flags & 128) !== 0)
              for (l = t.child; l !== null; ) {
                if (u = nu(l), u !== null) {
                  for (t.flags |= 128, fn(a, !1), l = u.updateQueue, t.updateQueue = l, gu(t, l), t.subtreeFlags = 0, l = e, e = t.child; e !== null; )
                    gs(e, l), e = e.sibling;
                  return A(
                    xl,
                    xl.current & 1 | 2
                  ), k && Xt(t, a.treeForkCount), t.child;
                }
                l = l.sibling;
              }
            a.tail !== null && at() > Tu && (t.flags |= 128, n = !0, fn(a, !1), t.lanes = 4194304);
          }
        else {
          if (!n)
            if (l = nu(u), l !== null) {
              if (t.flags |= 128, n = !0, l = l.updateQueue, t.updateQueue = l, gu(t, l), fn(a, !0), a.tail === null && a.tailMode === "hidden" && !u.alternate && !k)
                return hl(t), null;
            } else
              2 * at() - a.renderingStartTime > Tu && e !== 536870912 && (t.flags |= 128, n = !0, fn(a, !1), t.lanes = 4194304);
          a.isBackwards ? (u.sibling = t.child, t.child = u) : (l = a.last, l !== null ? l.sibling = u : t.child = u, a.last = u);
        }
        return a.tail !== null ? (l = a.tail, a.rendering = l, a.tail = l.sibling, a.renderingStartTime = at(), l.sibling = null, e = xl.current, A(
          xl,
          n ? e & 1 | 2 : e & 1
        ), k && Xt(t, a.treeForkCount), l) : (hl(t), null);
      case 22:
      case 23:
        return st(t), wi(), a = t.memoizedState !== null, l !== null ? l.memoizedState !== null !== a && (t.flags |= 8192) : a && (t.flags |= 8192), a ? (e & 536870912) !== 0 && (t.flags & 128) === 0 && (hl(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : hl(t), e = t.updateQueue, e !== null && gu(t, e.retryQueue), e = null, l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (e = l.memoizedState.cachePool.pool), a = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (a = t.memoizedState.cachePool.pool), a !== e && (t.flags |= 2048), l !== null && T(qe), null;
      case 24:
        return e = null, l !== null && (e = l.memoizedState.cache), t.memoizedState.cache !== e && (t.flags |= 2048), Lt(Ol), hl(t), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(y(156, t.tag));
  }
  function am(l, t) {
    switch (_i(t), t.tag) {
      case 1:
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 3:
        return Lt(Ol), dl(), l = t.flags, (l & 65536) !== 0 && (l & 128) === 0 ? (t.flags = l & -65537 | 128, t) : null;
      case 26:
      case 27:
      case 5:
        return we(t), null;
      case 31:
        if (t.memoizedState !== null) {
          if (st(t), t.alternate === null)
            throw Error(y(340));
          Ce();
        }
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 13:
        if (st(t), l = t.memoizedState, l !== null && l.dehydrated !== null) {
          if (t.alternate === null)
            throw Error(y(340));
          Ce();
        }
        return l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 19:
        return T(xl), null;
      case 4:
        return dl(), null;
      case 10:
        return Lt(t.type), null;
      case 22:
      case 23:
        return st(t), wi(), l !== null && T(qe), l = t.flags, l & 65536 ? (t.flags = l & -65537 | 128, t) : null;
      case 24:
        return Lt(Ol), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function Vo(l, t) {
    switch (_i(t), t.tag) {
      case 3:
        Lt(Ol), dl();
        break;
      case 26:
      case 27:
      case 5:
        we(t);
        break;
      case 4:
        dl();
        break;
      case 31:
        t.memoizedState !== null && st(t);
        break;
      case 13:
        st(t);
        break;
      case 19:
        T(xl);
        break;
      case 10:
        Lt(t.type);
        break;
      case 22:
      case 23:
        st(t), wi(), l !== null && T(qe);
        break;
      case 24:
        Lt(Ol);
    }
  }
  function sn(l, t) {
    try {
      var e = t.updateQueue, a = e !== null ? e.lastEffect : null;
      if (a !== null) {
        var n = a.next;
        e = n;
        do {
          if ((e.tag & l) === l) {
            a = void 0;
            var u = e.create, i = e.inst;
            a = u(), i.destroy = a;
          }
          e = e.next;
        } while (e !== n);
      }
    } catch (f) {
      nl(t, t.return, f);
    }
  }
  function re(l, t, e) {
    try {
      var a = t.updateQueue, n = a !== null ? a.lastEffect : null;
      if (n !== null) {
        var u = n.next;
        a = u;
        do {
          if ((a.tag & l) === l) {
            var i = a.inst, f = i.destroy;
            if (f !== void 0) {
              i.destroy = void 0, n = t;
              var s = e, m = f;
              try {
                m();
              } catch (S) {
                nl(
                  n,
                  s,
                  S
                );
              }
            }
          }
          a = a.next;
        } while (a !== u);
      }
    } catch (S) {
      nl(t, t.return, S);
    }
  }
  function Ko(l) {
    var t = l.updateQueue;
    if (t !== null) {
      var e = l.stateNode;
      try {
        Hs(t, e);
      } catch (a) {
        nl(l, l.return, a);
      }
    }
  }
  function Jo(l, t, e) {
    e.props = Qe(
      l.type,
      l.memoizedProps
    ), e.state = l.memoizedState;
    try {
      e.componentWillUnmount();
    } catch (a) {
      nl(l, t, a);
    }
  }
  function on(l, t) {
    try {
      var e = l.ref;
      if (e !== null) {
        switch (l.tag) {
          case 26:
          case 27:
          case 5:
            var a = l.stateNode;
            break;
          case 30:
            a = l.stateNode;
            break;
          default:
            a = l.stateNode;
        }
        typeof e == "function" ? l.refCleanup = e(a) : e.current = a;
      }
    } catch (n) {
      nl(l, t, n);
    }
  }
  function Ct(l, t) {
    var e = l.ref, a = l.refCleanup;
    if (e !== null)
      if (typeof a == "function")
        try {
          a();
        } catch (n) {
          nl(l, t, n);
        } finally {
          l.refCleanup = null, l = l.alternate, l != null && (l.refCleanup = null);
        }
      else if (typeof e == "function")
        try {
          e(null);
        } catch (n) {
          nl(l, t, n);
        }
      else e.current = null;
  }
  function Wo(l) {
    var t = l.type, e = l.memoizedProps, a = l.stateNode;
    try {
      l: switch (t) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          e.autoFocus && a.focus();
          break l;
        case "img":
          e.src ? a.src = e.src : e.srcSet && (a.srcset = e.srcSet);
      }
    } catch (n) {
      nl(l, l.return, n);
    }
  }
  function Tc(l, t, e) {
    try {
      var a = l.stateNode;
      Am(a, l.type, e, t), a[$l] = t;
    } catch (n) {
      nl(l, l.return, n);
    }
  }
  function ko(l) {
    return l.tag === 5 || l.tag === 3 || l.tag === 26 || l.tag === 27 && Se(l.type) || l.tag === 4;
  }
  function Ec(l) {
    l: for (; ; ) {
      for (; l.sibling === null; ) {
        if (l.return === null || ko(l.return)) return null;
        l = l.return;
      }
      for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
        if (l.tag === 27 && Se(l.type) || l.flags & 2 || l.child === null || l.tag === 4) continue l;
        l.child.return = l, l = l.child;
      }
      if (!(l.flags & 2)) return l.stateNode;
    }
  }
  function jc(l, t, e) {
    var a = l.tag;
    if (a === 5 || a === 6)
      l = l.stateNode, t ? (e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e).insertBefore(l, t) : (t = e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, t.appendChild(l), e = e._reactRootContainer, e != null || t.onclick !== null || (t.onclick = Bt));
    else if (a !== 4 && (a === 27 && Se(l.type) && (e = l.stateNode, t = null), l = l.child, l !== null))
      for (jc(l, t, e), l = l.sibling; l !== null; )
        jc(l, t, e), l = l.sibling;
  }
  function pu(l, t, e) {
    var a = l.tag;
    if (a === 5 || a === 6)
      l = l.stateNode, t ? e.insertBefore(l, t) : e.appendChild(l);
    else if (a !== 4 && (a === 27 && Se(l.type) && (e = l.stateNode), l = l.child, l !== null))
      for (pu(l, t, e), l = l.sibling; l !== null; )
        pu(l, t, e), l = l.sibling;
  }
  function $o(l) {
    var t = l.stateNode, e = l.memoizedProps;
    try {
      for (var a = l.type, n = t.attributes; n.length; )
        t.removeAttributeNode(n[0]);
      Ql(t, a, e), t[Bl] = l, t[$l] = e;
    } catch (u) {
      nl(l, l.return, u);
    }
  }
  var Jt = !1, Ml = !1, Ac = !1, Fo = typeof WeakSet == "function" ? WeakSet : Set, ql = null;
  function nm(l, t) {
    if (l = l.containerInfo, Kc = Gu, l = fs(l), pi(l)) {
      if ("selectionStart" in l)
        var e = {
          start: l.selectionStart,
          end: l.selectionEnd
        };
      else
        l: {
          e = (e = l.ownerDocument) && e.defaultView || window;
          var a = e.getSelection && e.getSelection();
          if (a && a.rangeCount !== 0) {
            e = a.anchorNode;
            var n = a.anchorOffset, u = a.focusNode;
            a = a.focusOffset;
            try {
              e.nodeType, u.nodeType;
            } catch {
              e = null;
              break l;
            }
            var i = 0, f = -1, s = -1, m = 0, S = 0, x = l, v = null;
            t: for (; ; ) {
              for (var g; x !== e || n !== 0 && x.nodeType !== 3 || (f = i + n), x !== u || a !== 0 && x.nodeType !== 3 || (s = i + a), x.nodeType === 3 && (i += x.nodeValue.length), (g = x.firstChild) !== null; )
                v = x, x = g;
              for (; ; ) {
                if (x === l) break t;
                if (v === e && ++m === n && (f = i), v === u && ++S === a && (s = i), (g = x.nextSibling) !== null) break;
                x = v, v = x.parentNode;
              }
              x = g;
            }
            e = f === -1 || s === -1 ? null : { start: f, end: s };
          } else e = null;
        }
      e = e || { start: 0, end: 0 };
    } else e = null;
    for (Jc = { focusedElem: l, selectionRange: e }, Gu = !1, ql = t; ql !== null; )
      if (t = ql, l = t.child, (t.subtreeFlags & 1028) !== 0 && l !== null)
        l.return = t, ql = l;
      else
        for (; ql !== null; ) {
          switch (t = ql, u = t.alternate, l = t.flags, t.tag) {
            case 0:
              if ((l & 4) !== 0 && (l = t.updateQueue, l = l !== null ? l.events : null, l !== null))
                for (e = 0; e < l.length; e++)
                  n = l[e], n.ref.impl = n.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if ((l & 1024) !== 0 && u !== null) {
                l = void 0, e = t, n = u.memoizedProps, u = u.memoizedState, a = e.stateNode;
                try {
                  var D = Qe(
                    e.type,
                    n
                  );
                  l = a.getSnapshotBeforeUpdate(
                    D,
                    u
                  ), a.__reactInternalSnapshotBeforeUpdate = l;
                } catch (q) {
                  nl(
                    e,
                    e.return,
                    q
                  );
                }
              }
              break;
            case 3:
              if ((l & 1024) !== 0) {
                if (l = t.stateNode.containerInfo, e = l.nodeType, e === 9)
                  $c(l);
                else if (e === 1)
                  switch (l.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      $c(l);
                      break;
                    default:
                      l.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if ((l & 1024) !== 0) throw Error(y(163));
          }
          if (l = t.sibling, l !== null) {
            l.return = t.return, ql = l;
            break;
          }
          ql = t.return;
        }
  }
  function Io(l, t, e) {
    var a = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        kt(l, e), a & 4 && sn(5, e);
        break;
      case 1:
        if (kt(l, e), a & 4)
          if (l = e.stateNode, t === null)
            try {
              l.componentDidMount();
            } catch (i) {
              nl(e, e.return, i);
            }
          else {
            var n = Qe(
              e.type,
              t.memoizedProps
            );
            t = t.memoizedState;
            try {
              l.componentDidUpdate(
                n,
                t,
                l.__reactInternalSnapshotBeforeUpdate
              );
            } catch (i) {
              nl(
                e,
                e.return,
                i
              );
            }
          }
        a & 64 && Ko(e), a & 512 && on(e, e.return);
        break;
      case 3:
        if (kt(l, e), a & 64 && (l = e.updateQueue, l !== null)) {
          if (t = null, e.child !== null)
            switch (e.child.tag) {
              case 27:
              case 5:
                t = e.child.stateNode;
                break;
              case 1:
                t = e.child.stateNode;
            }
          try {
            Hs(l, t);
          } catch (i) {
            nl(e, e.return, i);
          }
        }
        break;
      case 27:
        t === null && a & 4 && $o(e);
      case 26:
      case 5:
        kt(l, e), t === null && a & 4 && Wo(e), a & 512 && on(e, e.return);
        break;
      case 12:
        kt(l, e);
        break;
      case 31:
        kt(l, e), a & 4 && td(l, e);
        break;
      case 13:
        kt(l, e), a & 4 && ed(l, e), a & 64 && (l = e.memoizedState, l !== null && (l = l.dehydrated, l !== null && (e = hm.bind(
          null,
          e
        ), Cm(l, e))));
        break;
      case 22:
        if (a = e.memoizedState !== null || Jt, !a) {
          t = t !== null && t.memoizedState !== null || Ml, n = Jt;
          var u = Ml;
          Jt = a, (Ml = t) && !u ? $t(
            l,
            e,
            (e.subtreeFlags & 8772) !== 0
          ) : kt(l, e), Jt = n, Ml = u;
        }
        break;
      case 30:
        break;
      default:
        kt(l, e);
    }
  }
  function Po(l) {
    var t = l.alternate;
    t !== null && (l.alternate = null, Po(t)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (t = l.stateNode, t !== null && ti(t)), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
  }
  var vl = null, Il = !1;
  function Wt(l, t, e) {
    for (e = e.child; e !== null; )
      ld(l, t, e), e = e.sibling;
  }
  function ld(l, t, e) {
    if (nt && typeof nt.onCommitFiberUnmount == "function")
      try {
        nt.onCommitFiberUnmount(Ca, e);
      } catch {
      }
    switch (e.tag) {
      case 26:
        Ml || Ct(e, t), Wt(
          l,
          t,
          e
        ), e.memoizedState ? e.memoizedState.count-- : e.stateNode && (e = e.stateNode, e.parentNode.removeChild(e));
        break;
      case 27:
        Ml || Ct(e, t);
        var a = vl, n = Il;
        Se(e.type) && (vl = e.stateNode, Il = !1), Wt(
          l,
          t,
          e
        ), Sn(e.stateNode), vl = a, Il = n;
        break;
      case 5:
        Ml || Ct(e, t);
      case 6:
        if (a = vl, n = Il, vl = null, Wt(
          l,
          t,
          e
        ), vl = a, Il = n, vl !== null)
          if (Il)
            try {
              (vl.nodeType === 9 ? vl.body : vl.nodeName === "HTML" ? vl.ownerDocument.body : vl).removeChild(e.stateNode);
            } catch (u) {
              nl(
                e,
                t,
                u
              );
            }
          else
            try {
              vl.removeChild(e.stateNode);
            } catch (u) {
              nl(
                e,
                t,
                u
              );
            }
        break;
      case 18:
        vl !== null && (Il ? (l = vl, Kd(
          l.nodeType === 9 ? l.body : l.nodeName === "HTML" ? l.ownerDocument.body : l,
          e.stateNode
        ), Oa(l)) : Kd(vl, e.stateNode));
        break;
      case 4:
        a = vl, n = Il, vl = e.stateNode.containerInfo, Il = !0, Wt(
          l,
          t,
          e
        ), vl = a, Il = n;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        re(2, e, t), Ml || re(4, e, t), Wt(
          l,
          t,
          e
        );
        break;
      case 1:
        Ml || (Ct(e, t), a = e.stateNode, typeof a.componentWillUnmount == "function" && Jo(
          e,
          t,
          a
        )), Wt(
          l,
          t,
          e
        );
        break;
      case 21:
        Wt(
          l,
          t,
          e
        );
        break;
      case 22:
        Ml = (a = Ml) || e.memoizedState !== null, Wt(
          l,
          t,
          e
        ), Ml = a;
        break;
      default:
        Wt(
          l,
          t,
          e
        );
    }
  }
  function td(l, t) {
    if (t.memoizedState === null && (l = t.alternate, l !== null && (l = l.memoizedState, l !== null))) {
      l = l.dehydrated;
      try {
        Oa(l);
      } catch (e) {
        nl(t, t.return, e);
      }
    }
  }
  function ed(l, t) {
    if (t.memoizedState === null && (l = t.alternate, l !== null && (l = l.memoizedState, l !== null && (l = l.dehydrated, l !== null))))
      try {
        Oa(l);
      } catch (e) {
        nl(t, t.return, e);
      }
  }
  function um(l) {
    switch (l.tag) {
      case 31:
      case 13:
      case 19:
        var t = l.stateNode;
        return t === null && (t = l.stateNode = new Fo()), t;
      case 22:
        return l = l.stateNode, t = l._retryCache, t === null && (t = l._retryCache = new Fo()), t;
      default:
        throw Error(y(435, l.tag));
    }
  }
  function Su(l, t) {
    var e = um(l);
    t.forEach(function(a) {
      if (!e.has(a)) {
        e.add(a);
        var n = mm.bind(null, l, a);
        a.then(n, n);
      }
    });
  }
  function Pl(l, t) {
    var e = t.deletions;
    if (e !== null)
      for (var a = 0; a < e.length; a++) {
        var n = e[a], u = l, i = t, f = i;
        l: for (; f !== null; ) {
          switch (f.tag) {
            case 27:
              if (Se(f.type)) {
                vl = f.stateNode, Il = !1;
                break l;
              }
              break;
            case 5:
              vl = f.stateNode, Il = !1;
              break l;
            case 3:
            case 4:
              vl = f.stateNode.containerInfo, Il = !0;
              break l;
          }
          f = f.return;
        }
        if (vl === null) throw Error(y(160));
        ld(u, i, n), vl = null, Il = !1, u = n.alternate, u !== null && (u.return = null), n.return = null;
      }
    if (t.subtreeFlags & 13886)
      for (t = t.child; t !== null; )
        ad(t, l), t = t.sibling;
  }
  var Nt = null;
  function ad(l, t) {
    var e = l.alternate, a = l.flags;
    switch (l.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        Pl(t, l), lt(l), a & 4 && (re(3, l, l.return), sn(3, l), re(5, l, l.return));
        break;
      case 1:
        Pl(t, l), lt(l), a & 512 && (Ml || e === null || Ct(e, e.return)), a & 64 && Jt && (l = l.updateQueue, l !== null && (a = l.callbacks, a !== null && (e = l.shared.hiddenCallbacks, l.shared.hiddenCallbacks = e === null ? a : e.concat(a))));
        break;
      case 26:
        var n = Nt;
        if (Pl(t, l), lt(l), a & 512 && (Ml || e === null || Ct(e, e.return)), a & 4) {
          var u = e !== null ? e.memoizedState : null;
          if (a = l.memoizedState, e === null)
            if (a === null)
              if (l.stateNode === null) {
                l: {
                  a = l.type, e = l.memoizedProps, n = n.ownerDocument || n;
                  t: switch (a) {
                    case "title":
                      u = n.getElementsByTagName("title")[0], (!u || u[qa] || u[Bl] || u.namespaceURI === "http://www.w3.org/2000/svg" || u.hasAttribute("itemprop")) && (u = n.createElement(a), n.head.insertBefore(
                        u,
                        n.querySelector("head > title")
                      )), Ql(u, a, e), u[Bl] = l, Hl(u), a = u;
                      break l;
                    case "link":
                      var i = ar(
                        "link",
                        "href",
                        n
                      ).get(a + (e.href || ""));
                      if (i) {
                        for (var f = 0; f < i.length; f++)
                          if (u = i[f], u.getAttribute("href") === (e.href == null || e.href === "" ? null : e.href) && u.getAttribute("rel") === (e.rel == null ? null : e.rel) && u.getAttribute("title") === (e.title == null ? null : e.title) && u.getAttribute("crossorigin") === (e.crossOrigin == null ? null : e.crossOrigin)) {
                            i.splice(f, 1);
                            break t;
                          }
                      }
                      u = n.createElement(a), Ql(u, a, e), n.head.appendChild(u);
                      break;
                    case "meta":
                      if (i = ar(
                        "meta",
                        "content",
                        n
                      ).get(a + (e.content || ""))) {
                        for (f = 0; f < i.length; f++)
                          if (u = i[f], u.getAttribute("content") === (e.content == null ? null : "" + e.content) && u.getAttribute("name") === (e.name == null ? null : e.name) && u.getAttribute("property") === (e.property == null ? null : e.property) && u.getAttribute("http-equiv") === (e.httpEquiv == null ? null : e.httpEquiv) && u.getAttribute("charset") === (e.charSet == null ? null : e.charSet)) {
                            i.splice(f, 1);
                            break t;
                          }
                      }
                      u = n.createElement(a), Ql(u, a, e), n.head.appendChild(u);
                      break;
                    default:
                      throw Error(y(468, a));
                  }
                  u[Bl] = l, Hl(u), a = u;
                }
                l.stateNode = a;
              } else
                nr(
                  n,
                  l.type,
                  l.stateNode
                );
            else
              l.stateNode = er(
                n,
                a,
                l.memoizedProps
              );
          else
            u !== a ? (u === null ? e.stateNode !== null && (e = e.stateNode, e.parentNode.removeChild(e)) : u.count--, a === null ? nr(
              n,
              l.type,
              l.stateNode
            ) : er(
              n,
              a,
              l.memoizedProps
            )) : a === null && l.stateNode !== null && Tc(
              l,
              l.memoizedProps,
              e.memoizedProps
            );
        }
        break;
      case 27:
        Pl(t, l), lt(l), a & 512 && (Ml || e === null || Ct(e, e.return)), e !== null && a & 4 && Tc(
          l,
          l.memoizedProps,
          e.memoizedProps
        );
        break;
      case 5:
        if (Pl(t, l), lt(l), a & 512 && (Ml || e === null || Ct(e, e.return)), l.flags & 32) {
          n = l.stateNode;
          try {
            Fe(n, "");
          } catch (D) {
            nl(l, l.return, D);
          }
        }
        a & 4 && l.stateNode != null && (n = l.memoizedProps, Tc(
          l,
          n,
          e !== null ? e.memoizedProps : n
        )), a & 1024 && (Ac = !0);
        break;
      case 6:
        if (Pl(t, l), lt(l), a & 4) {
          if (l.stateNode === null)
            throw Error(y(162));
          a = l.memoizedProps, e = l.stateNode;
          try {
            e.nodeValue = a;
          } catch (D) {
            nl(l, l.return, D);
          }
        }
        break;
      case 3:
        if (Hu = null, n = Nt, Nt = Cu(t.containerInfo), Pl(t, l), Nt = n, lt(l), a & 4 && e !== null && e.memoizedState.isDehydrated)
          try {
            Oa(t.containerInfo);
          } catch (D) {
            nl(l, l.return, D);
          }
        Ac && (Ac = !1, nd(l));
        break;
      case 4:
        a = Nt, Nt = Cu(
          l.stateNode.containerInfo
        ), Pl(t, l), lt(l), Nt = a;
        break;
      case 12:
        Pl(t, l), lt(l);
        break;
      case 31:
        Pl(t, l), lt(l), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, Su(l, a)));
        break;
      case 13:
        Pl(t, l), lt(l), l.child.flags & 8192 && l.memoizedState !== null != (e !== null && e.memoizedState !== null) && (xu = at()), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, Su(l, a)));
        break;
      case 22:
        n = l.memoizedState !== null;
        var s = e !== null && e.memoizedState !== null, m = Jt, S = Ml;
        if (Jt = m || n, Ml = S || s, Pl(t, l), Ml = S, Jt = m, lt(l), a & 8192)
          l: for (t = l.stateNode, t._visibility = n ? t._visibility & -2 : t._visibility | 1, n && (e === null || s || Jt || Ml || Le(l)), e = null, t = l; ; ) {
            if (t.tag === 5 || t.tag === 26) {
              if (e === null) {
                s = e = t;
                try {
                  if (u = s.stateNode, n)
                    i = u.style, typeof i.setProperty == "function" ? i.setProperty("display", "none", "important") : i.display = "none";
                  else {
                    f = s.stateNode;
                    var x = s.memoizedProps.style, v = x != null && x.hasOwnProperty("display") ? x.display : null;
                    f.style.display = v == null || typeof v == "boolean" ? "" : ("" + v).trim();
                  }
                } catch (D) {
                  nl(s, s.return, D);
                }
              }
            } else if (t.tag === 6) {
              if (e === null) {
                s = t;
                try {
                  s.stateNode.nodeValue = n ? "" : s.memoizedProps;
                } catch (D) {
                  nl(s, s.return, D);
                }
              }
            } else if (t.tag === 18) {
              if (e === null) {
                s = t;
                try {
                  var g = s.stateNode;
                  n ? Jd(g, !0) : Jd(s.stateNode, !1);
                } catch (D) {
                  nl(s, s.return, D);
                }
              }
            } else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === l) && t.child !== null) {
              t.child.return = t, t = t.child;
              continue;
            }
            if (t === l) break l;
            for (; t.sibling === null; ) {
              if (t.return === null || t.return === l) break l;
              e === t && (e = null), t = t.return;
            }
            e === t && (e = null), t.sibling.return = t.return, t = t.sibling;
          }
        a & 4 && (a = l.updateQueue, a !== null && (e = a.retryQueue, e !== null && (a.retryQueue = null, Su(l, e))));
        break;
      case 19:
        Pl(t, l), lt(l), a & 4 && (a = l.updateQueue, a !== null && (l.updateQueue = null, Su(l, a)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        Pl(t, l), lt(l);
    }
  }
  function lt(l) {
    var t = l.flags;
    if (t & 2) {
      try {
        for (var e, a = l.return; a !== null; ) {
          if (ko(a)) {
            e = a;
            break;
          }
          a = a.return;
        }
        if (e == null) throw Error(y(160));
        switch (e.tag) {
          case 27:
            var n = e.stateNode, u = Ec(l);
            pu(l, u, n);
            break;
          case 5:
            var i = e.stateNode;
            e.flags & 32 && (Fe(i, ""), e.flags &= -33);
            var f = Ec(l);
            pu(l, f, i);
            break;
          case 3:
          case 4:
            var s = e.stateNode.containerInfo, m = Ec(l);
            jc(
              l,
              m,
              s
            );
            break;
          default:
            throw Error(y(161));
        }
      } catch (S) {
        nl(l, l.return, S);
      }
      l.flags &= -3;
    }
    t & 4096 && (l.flags &= -4097);
  }
  function nd(l) {
    if (l.subtreeFlags & 1024)
      for (l = l.child; l !== null; ) {
        var t = l;
        nd(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), l = l.sibling;
      }
  }
  function kt(l, t) {
    if (t.subtreeFlags & 8772)
      for (t = t.child; t !== null; )
        Io(l, t.alternate, t), t = t.sibling;
  }
  function Le(l) {
    for (l = l.child; l !== null; ) {
      var t = l;
      switch (t.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          re(4, t, t.return), Le(t);
          break;
        case 1:
          Ct(t, t.return);
          var e = t.stateNode;
          typeof e.componentWillUnmount == "function" && Jo(
            t,
            t.return,
            e
          ), Le(t);
          break;
        case 27:
          Sn(t.stateNode);
        case 26:
        case 5:
          Ct(t, t.return), Le(t);
          break;
        case 22:
          t.memoizedState === null && Le(t);
          break;
        case 30:
          Le(t);
          break;
        default:
          Le(t);
      }
      l = l.sibling;
    }
  }
  function $t(l, t, e) {
    for (e = e && (t.subtreeFlags & 8772) !== 0, t = t.child; t !== null; ) {
      var a = t.alternate, n = l, u = t, i = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          $t(
            n,
            u,
            e
          ), sn(4, u);
          break;
        case 1:
          if ($t(
            n,
            u,
            e
          ), a = u, n = a.stateNode, typeof n.componentDidMount == "function")
            try {
              n.componentDidMount();
            } catch (m) {
              nl(a, a.return, m);
            }
          if (a = u, n = a.updateQueue, n !== null) {
            var f = a.stateNode;
            try {
              var s = n.shared.hiddenCallbacks;
              if (s !== null)
                for (n.shared.hiddenCallbacks = null, n = 0; n < s.length; n++)
                  Rs(s[n], f);
            } catch (m) {
              nl(a, a.return, m);
            }
          }
          e && i & 64 && Ko(u), on(u, u.return);
          break;
        case 27:
          $o(u);
        case 26:
        case 5:
          $t(
            n,
            u,
            e
          ), e && a === null && i & 4 && Wo(u), on(u, u.return);
          break;
        case 12:
          $t(
            n,
            u,
            e
          );
          break;
        case 31:
          $t(
            n,
            u,
            e
          ), e && i & 4 && td(n, u);
          break;
        case 13:
          $t(
            n,
            u,
            e
          ), e && i & 4 && ed(n, u);
          break;
        case 22:
          u.memoizedState === null && $t(
            n,
            u,
            e
          ), on(u, u.return);
          break;
        case 30:
          break;
        default:
          $t(
            n,
            u,
            e
          );
      }
      t = t.sibling;
    }
  }
  function zc(l, t) {
    var e = null;
    l !== null && l.memoizedState !== null && l.memoizedState.cachePool !== null && (e = l.memoizedState.cachePool.pool), l = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (l = t.memoizedState.cachePool.pool), l !== e && (l != null && l.refCount++, e != null && ka(e));
  }
  function Nc(l, t) {
    l = null, t.alternate !== null && (l = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== l && (t.refCount++, l != null && ka(l));
  }
  function Ot(l, t, e, a) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        ud(
          l,
          t,
          e,
          a
        ), t = t.sibling;
  }
  function ud(l, t, e, a) {
    var n = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        Ot(
          l,
          t,
          e,
          a
        ), n & 2048 && sn(9, t);
        break;
      case 1:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 3:
        Ot(
          l,
          t,
          e,
          a
        ), n & 2048 && (l = null, t.alternate !== null && (l = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== l && (t.refCount++, l != null && ka(l)));
        break;
      case 12:
        if (n & 2048) {
          Ot(
            l,
            t,
            e,
            a
          ), l = t.stateNode;
          try {
            var u = t.memoizedProps, i = u.id, f = u.onPostCommit;
            typeof f == "function" && f(
              i,
              t.alternate === null ? "mount" : "update",
              l.passiveEffectDuration,
              -0
            );
          } catch (s) {
            nl(t, t.return, s);
          }
        } else
          Ot(
            l,
            t,
            e,
            a
          );
        break;
      case 31:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 13:
        Ot(
          l,
          t,
          e,
          a
        );
        break;
      case 23:
        break;
      case 22:
        u = t.stateNode, i = t.alternate, t.memoizedState !== null ? u._visibility & 2 ? Ot(
          l,
          t,
          e,
          a
        ) : dn(l, t) : u._visibility & 2 ? Ot(
          l,
          t,
          e,
          a
        ) : (u._visibility |= 2, ga(
          l,
          t,
          e,
          a,
          (t.subtreeFlags & 10256) !== 0 || !1
        )), n & 2048 && zc(i, t);
        break;
      case 24:
        Ot(
          l,
          t,
          e,
          a
        ), n & 2048 && Nc(t.alternate, t);
        break;
      default:
        Ot(
          l,
          t,
          e,
          a
        );
    }
  }
  function ga(l, t, e, a, n) {
    for (n = n && ((t.subtreeFlags & 10256) !== 0 || !1), t = t.child; t !== null; ) {
      var u = l, i = t, f = e, s = a, m = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          ga(
            u,
            i,
            f,
            s,
            n
          ), sn(8, i);
          break;
        case 23:
          break;
        case 22:
          var S = i.stateNode;
          i.memoizedState !== null ? S._visibility & 2 ? ga(
            u,
            i,
            f,
            s,
            n
          ) : dn(
            u,
            i
          ) : (S._visibility |= 2, ga(
            u,
            i,
            f,
            s,
            n
          )), n && m & 2048 && zc(
            i.alternate,
            i
          );
          break;
        case 24:
          ga(
            u,
            i,
            f,
            s,
            n
          ), n && m & 2048 && Nc(i.alternate, i);
          break;
        default:
          ga(
            u,
            i,
            f,
            s,
            n
          );
      }
      t = t.sibling;
    }
  }
  function dn(l, t) {
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; ) {
        var e = l, a = t, n = a.flags;
        switch (a.tag) {
          case 22:
            dn(e, a), n & 2048 && zc(
              a.alternate,
              a
            );
            break;
          case 24:
            dn(e, a), n & 2048 && Nc(a.alternate, a);
            break;
          default:
            dn(e, a);
        }
        t = t.sibling;
      }
  }
  var rn = 8192;
  function pa(l, t, e) {
    if (l.subtreeFlags & rn)
      for (l = l.child; l !== null; )
        id(
          l,
          t,
          e
        ), l = l.sibling;
  }
  function id(l, t, e) {
    switch (l.tag) {
      case 26:
        pa(
          l,
          t,
          e
        ), l.flags & rn && l.memoizedState !== null && Vm(
          e,
          Nt,
          l.memoizedState,
          l.memoizedProps
        );
        break;
      case 5:
        pa(
          l,
          t,
          e
        );
        break;
      case 3:
      case 4:
        var a = Nt;
        Nt = Cu(l.stateNode.containerInfo), pa(
          l,
          t,
          e
        ), Nt = a;
        break;
      case 22:
        l.memoizedState === null && (a = l.alternate, a !== null && a.memoizedState !== null ? (a = rn, rn = 16777216, pa(
          l,
          t,
          e
        ), rn = a) : pa(
          l,
          t,
          e
        ));
        break;
      default:
        pa(
          l,
          t,
          e
        );
    }
  }
  function cd(l) {
    var t = l.alternate;
    if (t !== null && (l = t.child, l !== null)) {
      t.child = null;
      do
        t = l.sibling, l.sibling = null, l = t;
      while (l !== null);
    }
  }
  function hn(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var e = 0; e < t.length; e++) {
          var a = t[e];
          ql = a, sd(
            a,
            l
          );
        }
      cd(l);
    }
    if (l.subtreeFlags & 10256)
      for (l = l.child; l !== null; )
        fd(l), l = l.sibling;
  }
  function fd(l) {
    switch (l.tag) {
      case 0:
      case 11:
      case 15:
        hn(l), l.flags & 2048 && re(9, l, l.return);
        break;
      case 3:
        hn(l);
        break;
      case 12:
        hn(l);
        break;
      case 22:
        var t = l.stateNode;
        l.memoizedState !== null && t._visibility & 2 && (l.return === null || l.return.tag !== 13) ? (t._visibility &= -3, bu(l)) : hn(l);
        break;
      default:
        hn(l);
    }
  }
  function bu(l) {
    var t = l.deletions;
    if ((l.flags & 16) !== 0) {
      if (t !== null)
        for (var e = 0; e < t.length; e++) {
          var a = t[e];
          ql = a, sd(
            a,
            l
          );
        }
      cd(l);
    }
    for (l = l.child; l !== null; ) {
      switch (t = l, t.tag) {
        case 0:
        case 11:
        case 15:
          re(8, t, t.return), bu(t);
          break;
        case 22:
          e = t.stateNode, e._visibility & 2 && (e._visibility &= -3, bu(t));
          break;
        default:
          bu(t);
      }
      l = l.sibling;
    }
  }
  function sd(l, t) {
    for (; ql !== null; ) {
      var e = ql;
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          re(8, e, t);
          break;
        case 23:
        case 22:
          if (e.memoizedState !== null && e.memoizedState.cachePool !== null) {
            var a = e.memoizedState.cachePool.pool;
            a != null && a.refCount++;
          }
          break;
        case 24:
          ka(e.memoizedState.cache);
      }
      if (a = e.child, a !== null) a.return = e, ql = a;
      else
        l: for (e = l; ql !== null; ) {
          a = ql;
          var n = a.sibling, u = a.return;
          if (Po(a), a === e) {
            ql = null;
            break l;
          }
          if (n !== null) {
            n.return = u, ql = n;
            break l;
          }
          ql = u;
        }
    }
  }
  var im = {
    getCacheForType: function(l) {
      var t = Gl(Ol), e = t.data.get(l);
      return e === void 0 && (e = l(), t.data.set(l, e)), e;
    },
    cacheSignal: function() {
      return Gl(Ol).controller.signal;
    }
  }, cm = typeof WeakMap == "function" ? WeakMap : Map, tl = 0, fl = null, w = null, K = 0, al = 0, ot = null, he = !1, Sa = !1, Oc = !1, Ft = 0, bl = 0, me = 0, Ze = 0, _c = 0, dt = 0, ba = 0, mn = null, tt = null, Dc = !1, xu = 0, od = 0, Tu = 1 / 0, Eu = null, ve = null, Cl = 0, ye = null, xa = null, It = 0, Mc = 0, Uc = null, dd = null, vn = 0, Cc = null;
  function rt() {
    return (tl & 2) !== 0 && K !== 0 ? K & -K : p.T !== null ? Gc() : zf();
  }
  function rd() {
    if (dt === 0)
      if ((K & 536870912) === 0 || k) {
        var l = Mn;
        Mn <<= 1, (Mn & 3932160) === 0 && (Mn = 262144), dt = l;
      } else dt = 536870912;
    return l = ft.current, l !== null && (l.flags |= 32), dt;
  }
  function et(l, t, e) {
    (l === fl && (al === 2 || al === 9) || l.cancelPendingCommit !== null) && (Ta(l, 0), ge(
      l,
      K,
      dt,
      !1
    )), Ha(l, e), ((tl & 2) === 0 || l !== fl) && (l === fl && ((tl & 2) === 0 && (Ze |= e), bl === 4 && ge(
      l,
      K,
      dt,
      !1
    )), Rt(l));
  }
  function hd(l, t, e) {
    if ((tl & 6) !== 0) throw Error(y(327));
    var a = !e && (t & 127) === 0 && (t & l.expiredLanes) === 0 || Ra(l, t), n = a ? om(l, t) : Hc(l, t, !0), u = a;
    do {
      if (n === 0) {
        Sa && !a && ge(l, t, 0, !1);
        break;
      } else {
        if (e = l.current.alternate, u && !fm(e)) {
          n = Hc(l, t, !1), u = !1;
          continue;
        }
        if (n === 2) {
          if (u = t, l.errorRecoveryDisabledLanes & u)
            var i = 0;
          else
            i = l.pendingLanes & -536870913, i = i !== 0 ? i : i & 536870912 ? 536870912 : 0;
          if (i !== 0) {
            t = i;
            l: {
              var f = l;
              n = mn;
              var s = f.current.memoizedState.isDehydrated;
              if (s && (Ta(f, i).flags |= 256), i = Hc(
                f,
                i,
                !1
              ), i !== 2) {
                if (Oc && !s) {
                  f.errorRecoveryDisabledLanes |= u, Ze |= u, n = 4;
                  break l;
                }
                u = tt, tt = n, u !== null && (tt === null ? tt = u : tt.push.apply(
                  tt,
                  u
                ));
              }
              n = i;
            }
            if (u = !1, n !== 2) continue;
          }
        }
        if (n === 1) {
          Ta(l, 0), ge(l, t, 0, !0);
          break;
        }
        l: {
          switch (a = l, u = n, u) {
            case 0:
            case 1:
              throw Error(y(345));
            case 4:
              if ((t & 4194048) !== t) break;
            case 6:
              ge(
                a,
                t,
                dt,
                !he
              );
              break l;
            case 2:
              tt = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(y(329));
          }
          if ((t & 62914560) === t && (n = xu + 300 - at(), 10 < n)) {
            if (ge(
              a,
              t,
              dt,
              !he
            ), Cn(a, 0, !0) !== 0) break l;
            It = t, a.timeoutHandle = wd(
              md.bind(
                null,
                a,
                e,
                tt,
                Eu,
                Dc,
                t,
                dt,
                Ze,
                ba,
                he,
                u,
                "Throttled",
                -0,
                0
              ),
              n
            );
            break l;
          }
          md(
            a,
            e,
            tt,
            Eu,
            Dc,
            t,
            dt,
            Ze,
            ba,
            he,
            u,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    Rt(l);
  }
  function md(l, t, e, a, n, u, i, f, s, m, S, x, v, g) {
    if (l.timeoutHandle = -1, x = t.subtreeFlags, x & 8192 || (x & 16785408) === 16785408) {
      x = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: !0,
        waitingForViewTransition: !1,
        unsuspend: Bt
      }, id(
        t,
        u,
        x
      );
      var D = (u & 62914560) === u ? xu - at() : (u & 4194048) === u ? od - at() : 0;
      if (D = Km(
        x,
        D
      ), D !== null) {
        It = u, l.cancelPendingCommit = D(
          Td.bind(
            null,
            l,
            t,
            u,
            e,
            a,
            n,
            i,
            f,
            s,
            S,
            x,
            null,
            v,
            g
          )
        ), ge(l, u, i, !m);
        return;
      }
    }
    Td(
      l,
      t,
      u,
      e,
      a,
      n,
      i,
      f,
      s
    );
  }
  function fm(l) {
    for (var t = l; ; ) {
      var e = t.tag;
      if ((e === 0 || e === 11 || e === 15) && t.flags & 16384 && (e = t.updateQueue, e !== null && (e = e.stores, e !== null)))
        for (var a = 0; a < e.length; a++) {
          var n = e[a], u = n.getSnapshot;
          n = n.value;
          try {
            if (!it(u(), n)) return !1;
          } catch {
            return !1;
          }
        }
      if (e = t.child, t.subtreeFlags & 16384 && e !== null)
        e.return = t, t = e;
      else {
        if (t === l) break;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === l) return !0;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    }
    return !0;
  }
  function ge(l, t, e, a) {
    t &= ~_c, t &= ~Ze, l.suspendedLanes |= t, l.pingedLanes &= ~t, a && (l.warmLanes |= t), a = l.expirationTimes;
    for (var n = t; 0 < n; ) {
      var u = 31 - ut(n), i = 1 << u;
      a[u] = -1, n &= ~i;
    }
    e !== 0 && Ef(l, e, t);
  }
  function ju() {
    return (tl & 6) === 0 ? (yn(0), !1) : !0;
  }
  function Rc() {
    if (w !== null) {
      if (al === 0)
        var l = w.return;
      else
        l = w, Qt = Re = null, $i(l), ra = null, Fa = 0, l = w;
      for (; l !== null; )
        Vo(l.alternate, l), l = l.return;
      w = null;
    }
  }
  function Ta(l, t) {
    var e = l.timeoutHandle;
    e !== -1 && (l.timeoutHandle = -1, Om(e)), e = l.cancelPendingCommit, e !== null && (l.cancelPendingCommit = null, e()), It = 0, Rc(), fl = l, w = e = Gt(l.current, null), K = t, al = 0, ot = null, he = !1, Sa = Ra(l, t), Oc = !1, ba = dt = _c = Ze = me = bl = 0, tt = mn = null, Dc = !1, (t & 8) !== 0 && (t |= t & 32);
    var a = l.entangledLanes;
    if (a !== 0)
      for (l = l.entanglements, a &= t; 0 < a; ) {
        var n = 31 - ut(a), u = 1 << n;
        t |= l[n], a &= ~u;
      }
    return Ft = t, Vn(), e;
  }
  function vd(l, t) {
    X = null, p.H = un, t === da || t === Pn ? (t = Ds(), al = 3) : t === Yi ? (t = Ds(), al = 4) : al = t === rc ? 8 : t !== null && typeof t == "object" && typeof t.then == "function" ? 6 : 1, ot = t, w === null && (bl = 1, hu(
      l,
      gt(t, l.current)
    ));
  }
  function yd() {
    var l = ft.current;
    return l === null ? !0 : (K & 4194048) === K ? xt === null : (K & 62914560) === K || (K & 536870912) !== 0 ? l === xt : !1;
  }
  function gd() {
    var l = p.H;
    return p.H = un, l === null ? un : l;
  }
  function pd() {
    var l = p.A;
    return p.A = im, l;
  }
  function Au() {
    bl = 4, he || (K & 4194048) !== K && ft.current !== null || (Sa = !0), (me & 134217727) === 0 && (Ze & 134217727) === 0 || fl === null || ge(
      fl,
      K,
      dt,
      !1
    );
  }
  function Hc(l, t, e) {
    var a = tl;
    tl |= 2;
    var n = gd(), u = pd();
    (fl !== l || K !== t) && (Eu = null, Ta(l, t)), t = !1;
    var i = bl;
    l: do
      try {
        if (al !== 0 && w !== null) {
          var f = w, s = ot;
          switch (al) {
            case 8:
              Rc(), i = 6;
              break l;
            case 3:
            case 2:
            case 9:
            case 6:
              ft.current === null && (t = !0);
              var m = al;
              if (al = 0, ot = null, Ea(l, f, s, m), e && Sa) {
                i = 0;
                break l;
              }
              break;
            default:
              m = al, al = 0, ot = null, Ea(l, f, s, m);
          }
        }
        sm(), i = bl;
        break;
      } catch (S) {
        vd(l, S);
      }
    while (!0);
    return t && l.shellSuspendCounter++, Qt = Re = null, tl = a, p.H = n, p.A = u, w === null && (fl = null, K = 0, Vn()), i;
  }
  function sm() {
    for (; w !== null; ) Sd(w);
  }
  function om(l, t) {
    var e = tl;
    tl |= 2;
    var a = gd(), n = pd();
    fl !== l || K !== t ? (Eu = null, Tu = at() + 500, Ta(l, t)) : Sa = Ra(
      l,
      t
    );
    l: do
      try {
        if (al !== 0 && w !== null) {
          t = w;
          var u = ot;
          t: switch (al) {
            case 1:
              al = 0, ot = null, Ea(l, t, u, 1);
              break;
            case 2:
            case 9:
              if (Os(u)) {
                al = 0, ot = null, bd(t);
                break;
              }
              t = function() {
                al !== 2 && al !== 9 || fl !== l || (al = 7), Rt(l);
              }, u.then(t, t);
              break l;
            case 3:
              al = 7;
              break l;
            case 4:
              al = 5;
              break l;
            case 7:
              Os(u) ? (al = 0, ot = null, bd(t)) : (al = 0, ot = null, Ea(l, t, u, 7));
              break;
            case 5:
              var i = null;
              switch (w.tag) {
                case 26:
                  i = w.memoizedState;
                case 5:
                case 27:
                  var f = w;
                  if (i ? ur(i) : f.stateNode.complete) {
                    al = 0, ot = null;
                    var s = f.sibling;
                    if (s !== null) w = s;
                    else {
                      var m = f.return;
                      m !== null ? (w = m, zu(m)) : w = null;
                    }
                    break t;
                  }
              }
              al = 0, ot = null, Ea(l, t, u, 5);
              break;
            case 6:
              al = 0, ot = null, Ea(l, t, u, 6);
              break;
            case 8:
              Rc(), bl = 6;
              break l;
            default:
              throw Error(y(462));
          }
        }
        dm();
        break;
      } catch (S) {
        vd(l, S);
      }
    while (!0);
    return Qt = Re = null, p.H = a, p.A = n, tl = e, w !== null ? 0 : (fl = null, K = 0, Vn(), bl);
  }
  function dm() {
    for (; w !== null && !Rr(); )
      Sd(w);
  }
  function Sd(l) {
    var t = Zo(l.alternate, l, Ft);
    l.memoizedProps = l.pendingProps, t === null ? zu(l) : w = t;
  }
  function bd(l) {
    var t = l, e = t.alternate;
    switch (t.tag) {
      case 15:
      case 0:
        t = Bo(
          e,
          t,
          t.pendingProps,
          t.type,
          void 0,
          K
        );
        break;
      case 11:
        t = Bo(
          e,
          t,
          t.pendingProps,
          t.type.render,
          t.ref,
          K
        );
        break;
      case 5:
        $i(t);
      default:
        Vo(e, t), t = w = gs(t, Ft), t = Zo(e, t, Ft);
    }
    l.memoizedProps = l.pendingProps, t === null ? zu(l) : w = t;
  }
  function Ea(l, t, e, a) {
    Qt = Re = null, $i(t), ra = null, Fa = 0;
    var n = t.return;
    try {
      if (Ph(
        l,
        n,
        t,
        e,
        K
      )) {
        bl = 1, hu(
          l,
          gt(e, l.current)
        ), w = null;
        return;
      }
    } catch (u) {
      if (n !== null) throw w = n, u;
      bl = 1, hu(
        l,
        gt(e, l.current)
      ), w = null;
      return;
    }
    t.flags & 32768 ? (k || a === 1 ? l = !0 : Sa || (K & 536870912) !== 0 ? l = !1 : (he = l = !0, (a === 2 || a === 9 || a === 3 || a === 6) && (a = ft.current, a !== null && a.tag === 13 && (a.flags |= 16384))), xd(t, l)) : zu(t);
  }
  function zu(l) {
    var t = l;
    do {
      if ((t.flags & 32768) !== 0) {
        xd(
          t,
          he
        );
        return;
      }
      l = t.return;
      var e = em(
        t.alternate,
        t,
        Ft
      );
      if (e !== null) {
        w = e;
        return;
      }
      if (t = t.sibling, t !== null) {
        w = t;
        return;
      }
      w = t = l;
    } while (t !== null);
    bl === 0 && (bl = 5);
  }
  function xd(l, t) {
    do {
      var e = am(l.alternate, l);
      if (e !== null) {
        e.flags &= 32767, w = e;
        return;
      }
      if (e = l.return, e !== null && (e.flags |= 32768, e.subtreeFlags = 0, e.deletions = null), !t && (l = l.sibling, l !== null)) {
        w = l;
        return;
      }
      w = l = e;
    } while (l !== null);
    bl = 6, w = null;
  }
  function Td(l, t, e, a, n, u, i, f, s) {
    l.cancelPendingCommit = null;
    do
      Nu();
    while (Cl !== 0);
    if ((tl & 6) !== 0) throw Error(y(327));
    if (t !== null) {
      if (t === l.current) throw Error(y(177));
      if (u = t.lanes | t.childLanes, u |= Ei, wr(
        l,
        e,
        u,
        i,
        f,
        s
      ), l === fl && (w = fl = null, K = 0), xa = t, ye = l, It = e, Mc = u, Uc = n, dd = a, (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? (l.callbackNode = null, l.callbackPriority = 0, vm(_n, function() {
        return Nd(), null;
      })) : (l.callbackNode = null, l.callbackPriority = 0), a = (t.flags & 13878) !== 0, (t.subtreeFlags & 13878) !== 0 || a) {
        a = p.T, p.T = null, n = j.p, j.p = 2, i = tl, tl |= 4;
        try {
          nm(l, t, e);
        } finally {
          tl = i, j.p = n, p.T = a;
        }
      }
      Cl = 1, Ed(), jd(), Ad();
    }
  }
  function Ed() {
    if (Cl === 1) {
      Cl = 0;
      var l = ye, t = xa, e = (t.flags & 13878) !== 0;
      if ((t.subtreeFlags & 13878) !== 0 || e) {
        e = p.T, p.T = null;
        var a = j.p;
        j.p = 2;
        var n = tl;
        tl |= 4;
        try {
          ad(t, l);
          var u = Jc, i = fs(l.containerInfo), f = u.focusedElem, s = u.selectionRange;
          if (i !== f && f && f.ownerDocument && cs(
            f.ownerDocument.documentElement,
            f
          )) {
            if (s !== null && pi(f)) {
              var m = s.start, S = s.end;
              if (S === void 0 && (S = m), "selectionStart" in f)
                f.selectionStart = m, f.selectionEnd = Math.min(
                  S,
                  f.value.length
                );
              else {
                var x = f.ownerDocument || document, v = x && x.defaultView || window;
                if (v.getSelection) {
                  var g = v.getSelection(), D = f.textContent.length, q = Math.min(s.start, D), cl = s.end === void 0 ? q : Math.min(s.end, D);
                  !g.extend && q > cl && (i = cl, cl = q, q = i);
                  var r = is(
                    f,
                    q
                  ), d = is(
                    f,
                    cl
                  );
                  if (r && d && (g.rangeCount !== 1 || g.anchorNode !== r.node || g.anchorOffset !== r.offset || g.focusNode !== d.node || g.focusOffset !== d.offset)) {
                    var h = x.createRange();
                    h.setStart(r.node, r.offset), g.removeAllRanges(), q > cl ? (g.addRange(h), g.extend(d.node, d.offset)) : (h.setEnd(d.node, d.offset), g.addRange(h));
                  }
                }
              }
            }
            for (x = [], g = f; g = g.parentNode; )
              g.nodeType === 1 && x.push({
                element: g,
                left: g.scrollLeft,
                top: g.scrollTop
              });
            for (typeof f.focus == "function" && f.focus(), f = 0; f < x.length; f++) {
              var b = x[f];
              b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
            }
          }
          Gu = !!Kc, Jc = Kc = null;
        } finally {
          tl = n, j.p = a, p.T = e;
        }
      }
      l.current = t, Cl = 2;
    }
  }
  function jd() {
    if (Cl === 2) {
      Cl = 0;
      var l = ye, t = xa, e = (t.flags & 8772) !== 0;
      if ((t.subtreeFlags & 8772) !== 0 || e) {
        e = p.T, p.T = null;
        var a = j.p;
        j.p = 2;
        var n = tl;
        tl |= 4;
        try {
          Io(l, t.alternate, t);
        } finally {
          tl = n, j.p = a, p.T = e;
        }
      }
      Cl = 3;
    }
  }
  function Ad() {
    if (Cl === 4 || Cl === 3) {
      Cl = 0, Hr();
      var l = ye, t = xa, e = It, a = dd;
      (t.subtreeFlags & 10256) !== 0 || (t.flags & 10256) !== 0 ? Cl = 5 : (Cl = 0, xa = ye = null, zd(l, l.pendingLanes));
      var n = l.pendingLanes;
      if (n === 0 && (ve = null), Pu(e), t = t.stateNode, nt && typeof nt.onCommitFiberRoot == "function")
        try {
          nt.onCommitFiberRoot(
            Ca,
            t,
            void 0,
            (t.current.flags & 128) === 128
          );
        } catch {
        }
      if (a !== null) {
        t = p.T, n = j.p, j.p = 2, p.T = null;
        try {
          for (var u = l.onRecoverableError, i = 0; i < a.length; i++) {
            var f = a[i];
            u(f.value, {
              componentStack: f.stack
            });
          }
        } finally {
          p.T = t, j.p = n;
        }
      }
      (It & 3) !== 0 && Nu(), Rt(l), n = l.pendingLanes, (e & 261930) !== 0 && (n & 42) !== 0 ? l === Cc ? vn++ : (vn = 0, Cc = l) : vn = 0, yn(0);
    }
  }
  function zd(l, t) {
    (l.pooledCacheLanes &= t) === 0 && (t = l.pooledCache, t != null && (l.pooledCache = null, ka(t)));
  }
  function Nu() {
    return Ed(), jd(), Ad(), Nd();
  }
  function Nd() {
    if (Cl !== 5) return !1;
    var l = ye, t = Mc;
    Mc = 0;
    var e = Pu(It), a = p.T, n = j.p;
    try {
      j.p = 32 > e ? 32 : e, p.T = null, e = Uc, Uc = null;
      var u = ye, i = It;
      if (Cl = 0, xa = ye = null, It = 0, (tl & 6) !== 0) throw Error(y(331));
      var f = tl;
      if (tl |= 4, fd(u.current), ud(
        u,
        u.current,
        i,
        e
      ), tl = f, yn(0, !1), nt && typeof nt.onPostCommitFiberRoot == "function")
        try {
          nt.onPostCommitFiberRoot(Ca, u);
        } catch {
        }
      return !0;
    } finally {
      j.p = n, p.T = a, zd(l, t);
    }
  }
  function Od(l, t, e) {
    t = gt(e, t), t = dc(l.stateNode, t, 2), l = se(l, t, 2), l !== null && (Ha(l, 2), Rt(l));
  }
  function nl(l, t, e) {
    if (l.tag === 3)
      Od(l, l, e);
    else
      for (; t !== null; ) {
        if (t.tag === 3) {
          Od(
            t,
            l,
            e
          );
          break;
        } else if (t.tag === 1) {
          var a = t.stateNode;
          if (typeof t.type.getDerivedStateFromError == "function" || typeof a.componentDidCatch == "function" && (ve === null || !ve.has(a))) {
            l = gt(e, l), e = _o(2), a = se(t, e, 2), a !== null && (Do(
              e,
              a,
              t,
              l
            ), Ha(a, 2), Rt(a));
            break;
          }
        }
        t = t.return;
      }
  }
  function qc(l, t, e) {
    var a = l.pingCache;
    if (a === null) {
      a = l.pingCache = new cm();
      var n = /* @__PURE__ */ new Set();
      a.set(t, n);
    } else
      n = a.get(t), n === void 0 && (n = /* @__PURE__ */ new Set(), a.set(t, n));
    n.has(e) || (Oc = !0, n.add(e), l = rm.bind(null, l, t, e), t.then(l, l));
  }
  function rm(l, t, e) {
    var a = l.pingCache;
    a !== null && a.delete(t), l.pingedLanes |= l.suspendedLanes & e, l.warmLanes &= ~e, fl === l && (K & e) === e && (bl === 4 || bl === 3 && (K & 62914560) === K && 300 > at() - xu ? (tl & 2) === 0 && Ta(l, 0) : _c |= e, ba === K && (ba = 0)), Rt(l);
  }
  function _d(l, t) {
    t === 0 && (t = Tf()), l = Me(l, t), l !== null && (Ha(l, t), Rt(l));
  }
  function hm(l) {
    var t = l.memoizedState, e = 0;
    t !== null && (e = t.retryLane), _d(l, e);
  }
  function mm(l, t) {
    var e = 0;
    switch (l.tag) {
      case 31:
      case 13:
        var a = l.stateNode, n = l.memoizedState;
        n !== null && (e = n.retryLane);
        break;
      case 19:
        a = l.stateNode;
        break;
      case 22:
        a = l.stateNode._retryCache;
        break;
      default:
        throw Error(y(314));
    }
    a !== null && a.delete(t), _d(l, e);
  }
  function vm(l, t) {
    return ku(l, t);
  }
  var Ou = null, ja = null, Bc = !1, _u = !1, Yc = !1, pe = 0;
  function Rt(l) {
    l !== ja && l.next === null && (ja === null ? Ou = ja = l : ja = ja.next = l), _u = !0, Bc || (Bc = !0, gm());
  }
  function yn(l, t) {
    if (!Yc && _u) {
      Yc = !0;
      do
        for (var e = !1, a = Ou; a !== null; ) {
          if (l !== 0) {
            var n = a.pendingLanes;
            if (n === 0) var u = 0;
            else {
              var i = a.suspendedLanes, f = a.pingedLanes;
              u = (1 << 31 - ut(42 | l) + 1) - 1, u &= n & ~(i & ~f), u = u & 201326741 ? u & 201326741 | 1 : u ? u | 2 : 0;
            }
            u !== 0 && (e = !0, Cd(a, u));
          } else
            u = K, u = Cn(
              a,
              a === fl ? u : 0,
              a.cancelPendingCommit !== null || a.timeoutHandle !== -1
            ), (u & 3) === 0 || Ra(a, u) || (e = !0, Cd(a, u));
          a = a.next;
        }
      while (e);
      Yc = !1;
    }
  }
  function ym() {
    Dd();
  }
  function Dd() {
    _u = Bc = !1;
    var l = 0;
    pe !== 0 && Nm() && (l = pe);
    for (var t = at(), e = null, a = Ou; a !== null; ) {
      var n = a.next, u = Md(a, t);
      u === 0 ? (a.next = null, e === null ? Ou = n : e.next = n, n === null && (ja = e)) : (e = a, (l !== 0 || (u & 3) !== 0) && (_u = !0)), a = n;
    }
    Cl !== 0 && Cl !== 5 || yn(l), pe !== 0 && (pe = 0);
  }
  function Md(l, t) {
    for (var e = l.suspendedLanes, a = l.pingedLanes, n = l.expirationTimes, u = l.pendingLanes & -62914561; 0 < u; ) {
      var i = 31 - ut(u), f = 1 << i, s = n[i];
      s === -1 ? ((f & e) === 0 || (f & a) !== 0) && (n[i] = Zr(f, t)) : s <= t && (l.expiredLanes |= f), u &= ~f;
    }
    if (t = fl, e = K, e = Cn(
      l,
      l === t ? e : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), a = l.callbackNode, e === 0 || l === t && (al === 2 || al === 9) || l.cancelPendingCommit !== null)
      return a !== null && a !== null && $u(a), l.callbackNode = null, l.callbackPriority = 0;
    if ((e & 3) === 0 || Ra(l, e)) {
      if (t = e & -e, t === l.callbackPriority) return t;
      switch (a !== null && $u(a), Pu(e)) {
        case 2:
        case 8:
          e = bf;
          break;
        case 32:
          e = _n;
          break;
        case 268435456:
          e = xf;
          break;
        default:
          e = _n;
      }
      return a = Ud.bind(null, l), e = ku(e, a), l.callbackPriority = t, l.callbackNode = e, t;
    }
    return a !== null && a !== null && $u(a), l.callbackPriority = 2, l.callbackNode = null, 2;
  }
  function Ud(l, t) {
    if (Cl !== 0 && Cl !== 5)
      return l.callbackNode = null, l.callbackPriority = 0, null;
    var e = l.callbackNode;
    if (Nu() && l.callbackNode !== e)
      return null;
    var a = K;
    return a = Cn(
      l,
      l === fl ? a : 0,
      l.cancelPendingCommit !== null || l.timeoutHandle !== -1
    ), a === 0 ? null : (hd(l, a, t), Md(l, at()), l.callbackNode != null && l.callbackNode === e ? Ud.bind(null, l) : null);
  }
  function Cd(l, t) {
    if (Nu()) return null;
    hd(l, t, !0);
  }
  function gm() {
    _m(function() {
      (tl & 6) !== 0 ? ku(
        Sf,
        ym
      ) : Dd();
    });
  }
  function Gc() {
    if (pe === 0) {
      var l = sa;
      l === 0 && (l = Dn, Dn <<= 1, (Dn & 261888) === 0 && (Dn = 256)), pe = l;
    }
    return pe;
  }
  function Rd(l) {
    return l == null || typeof l == "symbol" || typeof l == "boolean" ? null : typeof l == "function" ? l : Bn("" + l);
  }
  function Hd(l, t) {
    var e = t.ownerDocument.createElement("input");
    return e.name = t.name, e.value = t.value, l.id && e.setAttribute("form", l.id), t.parentNode.insertBefore(e, t), l = new FormData(l), e.parentNode.removeChild(e), l;
  }
  function pm(l, t, e, a, n) {
    if (t === "submit" && e && e.stateNode === n) {
      var u = Rd(
        (n[$l] || null).action
      ), i = a.submitter;
      i && (t = (t = i[$l] || null) ? Rd(t.formAction) : i.getAttribute("formAction"), t !== null && (u = t, i = null));
      var f = new Qn(
        "action",
        "action",
        null,
        a,
        n
      );
      l.push({
        event: f,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (a.defaultPrevented) {
                if (pe !== 0) {
                  var s = i ? Hd(n, i) : new FormData(n);
                  uc(
                    e,
                    {
                      pending: !0,
                      data: s,
                      method: n.method,
                      action: u
                    },
                    null,
                    s
                  );
                }
              } else
                typeof u == "function" && (f.preventDefault(), s = i ? Hd(n, i) : new FormData(n), uc(
                  e,
                  {
                    pending: !0,
                    data: s,
                    method: n.method,
                    action: u
                  },
                  u,
                  s
                ));
            },
            currentTarget: n
          }
        ]
      });
    }
  }
  for (var Xc = 0; Xc < Ti.length; Xc++) {
    var Qc = Ti[Xc], Sm = Qc.toLowerCase(), bm = Qc[0].toUpperCase() + Qc.slice(1);
    zt(
      Sm,
      "on" + bm
    );
  }
  zt(ds, "onAnimationEnd"), zt(rs, "onAnimationIteration"), zt(hs, "onAnimationStart"), zt("dblclick", "onDoubleClick"), zt("focusin", "onFocus"), zt("focusout", "onBlur"), zt(qh, "onTransitionRun"), zt(Bh, "onTransitionStart"), zt(Yh, "onTransitionCancel"), zt(ms, "onTransitionEnd"), ke("onMouseEnter", ["mouseout", "mouseover"]), ke("onMouseLeave", ["mouseout", "mouseover"]), ke("onPointerEnter", ["pointerout", "pointerover"]), ke("onPointerLeave", ["pointerout", "pointerover"]), Ne(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), Ne(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), Ne("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), Ne(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), Ne(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), Ne(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var gn = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), xm = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(gn)
  );
  function qd(l, t) {
    t = (t & 4) !== 0;
    for (var e = 0; e < l.length; e++) {
      var a = l[e], n = a.event;
      a = a.listeners;
      l: {
        var u = void 0;
        if (t)
          for (var i = a.length - 1; 0 <= i; i--) {
            var f = a[i], s = f.instance, m = f.currentTarget;
            if (f = f.listener, s !== u && n.isPropagationStopped())
              break l;
            u = f, n.currentTarget = m;
            try {
              u(n);
            } catch (S) {
              wn(S);
            }
            n.currentTarget = null, u = s;
          }
        else
          for (i = 0; i < a.length; i++) {
            if (f = a[i], s = f.instance, m = f.currentTarget, f = f.listener, s !== u && n.isPropagationStopped())
              break l;
            u = f, n.currentTarget = m;
            try {
              u(n);
            } catch (S) {
              wn(S);
            }
            n.currentTarget = null, u = s;
          }
      }
    }
  }
  function V(l, t) {
    var e = t[li];
    e === void 0 && (e = t[li] = /* @__PURE__ */ new Set());
    var a = l + "__bubble";
    e.has(a) || (Bd(t, l, 2, !1), e.add(a));
  }
  function Lc(l, t, e) {
    var a = 0;
    t && (a |= 4), Bd(
      e,
      l,
      a,
      t
    );
  }
  var Du = "_reactListening" + Math.random().toString(36).slice(2);
  function Zc(l) {
    if (!l[Du]) {
      l[Du] = !0, _f.forEach(function(e) {
        e !== "selectionchange" && (xm.has(e) || Lc(e, !1, l), Lc(e, !0, l));
      });
      var t = l.nodeType === 9 ? l : l.ownerDocument;
      t === null || t[Du] || (t[Du] = !0, Lc("selectionchange", !1, t));
    }
  }
  function Bd(l, t, e, a) {
    switch (rr(t)) {
      case 2:
        var n = km;
        break;
      case 8:
        n = $m;
        break;
      default:
        n = nf;
    }
    e = n.bind(
      null,
      t,
      e,
      l
    ), n = void 0, !si || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (n = !0), a ? n !== void 0 ? l.addEventListener(t, e, {
      capture: !0,
      passive: n
    }) : l.addEventListener(t, e, !0) : n !== void 0 ? l.addEventListener(t, e, {
      passive: n
    }) : l.addEventListener(t, e, !1);
  }
  function wc(l, t, e, a, n) {
    var u = a;
    if ((t & 1) === 0 && (t & 2) === 0 && a !== null)
      l: for (; ; ) {
        if (a === null) return;
        var i = a.tag;
        if (i === 3 || i === 4) {
          var f = a.stateNode.containerInfo;
          if (f === n) break;
          if (i === 4)
            for (i = a.return; i !== null; ) {
              var s = i.tag;
              if ((s === 3 || s === 4) && i.stateNode.containerInfo === n)
                return;
              i = i.return;
            }
          for (; f !== null; ) {
            if (i = Ke(f), i === null) return;
            if (s = i.tag, s === 5 || s === 6 || s === 26 || s === 27) {
              a = u = i;
              continue l;
            }
            f = f.parentNode;
          }
        }
        a = a.return;
      }
    Qf(function() {
      var m = u, S = ci(e), x = [];
      l: {
        var v = vs.get(l);
        if (v !== void 0) {
          var g = Qn, D = l;
          switch (l) {
            case "keypress":
              if (Gn(e) === 0) break l;
            case "keydown":
            case "keyup":
              g = mh;
              break;
            case "focusin":
              D = "focus", g = hi;
              break;
            case "focusout":
              D = "blur", g = hi;
              break;
            case "beforeblur":
            case "afterblur":
              g = hi;
              break;
            case "click":
              if (e.button === 2) break l;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              g = wf;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              g = eh;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              g = gh;
              break;
            case ds:
            case rs:
            case hs:
              g = uh;
              break;
            case ms:
              g = Sh;
              break;
            case "scroll":
            case "scrollend":
              g = lh;
              break;
            case "wheel":
              g = xh;
              break;
            case "copy":
            case "cut":
            case "paste":
              g = ch;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              g = Kf;
              break;
            case "toggle":
            case "beforetoggle":
              g = Eh;
          }
          var q = (t & 4) !== 0, cl = !q && (l === "scroll" || l === "scrollend"), r = q ? v !== null ? v + "Capture" : null : v;
          q = [];
          for (var d = m, h; d !== null; ) {
            var b = d;
            if (h = b.stateNode, b = b.tag, b !== 5 && b !== 26 && b !== 27 || h === null || r === null || (b = Ya(d, r), b != null && q.push(
              pn(d, b, h)
            )), cl) break;
            d = d.return;
          }
          0 < q.length && (v = new g(
            v,
            D,
            null,
            e,
            S
          ), x.push({ event: v, listeners: q }));
        }
      }
      if ((t & 7) === 0) {
        l: {
          if (v = l === "mouseover" || l === "pointerover", g = l === "mouseout" || l === "pointerout", v && e !== ii && (D = e.relatedTarget || e.fromElement) && (Ke(D) || D[Ve]))
            break l;
          if ((g || v) && (v = S.window === S ? S : (v = S.ownerDocument) ? v.defaultView || v.parentWindow : window, g ? (D = e.relatedTarget || e.toElement, g = m, D = D ? Ke(D) : null, D !== null && (cl = sl(D), q = D.tag, D !== cl || q !== 5 && q !== 27 && q !== 6) && (D = null)) : (g = null, D = m), g !== D)) {
            if (q = wf, b = "onMouseLeave", r = "onMouseEnter", d = "mouse", (l === "pointerout" || l === "pointerover") && (q = Kf, b = "onPointerLeave", r = "onPointerEnter", d = "pointer"), cl = g == null ? v : Ba(g), h = D == null ? v : Ba(D), v = new q(
              b,
              d + "leave",
              g,
              e,
              S
            ), v.target = cl, v.relatedTarget = h, b = null, Ke(S) === m && (q = new q(
              r,
              d + "enter",
              D,
              e,
              S
            ), q.target = h, q.relatedTarget = cl, b = q), cl = b, g && D)
              t: {
                for (q = Tm, r = g, d = D, h = 0, b = r; b; b = q(b))
                  h++;
                b = 0;
                for (var R = d; R; R = q(R))
                  b++;
                for (; 0 < h - b; )
                  r = q(r), h--;
                for (; 0 < b - h; )
                  d = q(d), b--;
                for (; h--; ) {
                  if (r === d || d !== null && r === d.alternate) {
                    q = r;
                    break t;
                  }
                  r = q(r), d = q(d);
                }
                q = null;
              }
            else q = null;
            g !== null && Yd(
              x,
              v,
              g,
              q,
              !1
            ), D !== null && cl !== null && Yd(
              x,
              cl,
              D,
              q,
              !0
            );
          }
        }
        l: {
          if (v = m ? Ba(m) : window, g = v.nodeName && v.nodeName.toLowerCase(), g === "select" || g === "input" && v.type === "file")
            var P = ls;
          else if (If(v))
            if (ts)
              P = Ch;
            else {
              P = Mh;
              var M = Dh;
            }
          else
            g = v.nodeName, !g || g.toLowerCase() !== "input" || v.type !== "checkbox" && v.type !== "radio" ? m && ui(m.elementType) && (P = ls) : P = Uh;
          if (P && (P = P(l, m))) {
            Pf(
              x,
              P,
              e,
              S
            );
            break l;
          }
          M && M(l, v, m), l === "focusout" && m && v.type === "number" && m.memoizedProps.value != null && ni(v, "number", v.value);
        }
        switch (M = m ? Ba(m) : window, l) {
          case "focusin":
            (If(M) || M.contentEditable === "true") && (ta = M, Si = m, Ka = null);
            break;
          case "focusout":
            Ka = Si = ta = null;
            break;
          case "mousedown":
            bi = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            bi = !1, ss(x, e, S);
            break;
          case "selectionchange":
            if (Hh) break;
          case "keydown":
          case "keyup":
            ss(x, e, S);
        }
        var Q;
        if (vi)
          l: {
            switch (l) {
              case "compositionstart":
                var J = "onCompositionStart";
                break l;
              case "compositionend":
                J = "onCompositionEnd";
                break l;
              case "compositionupdate":
                J = "onCompositionUpdate";
                break l;
            }
            J = void 0;
          }
        else
          la ? $f(l, e) && (J = "onCompositionEnd") : l === "keydown" && e.keyCode === 229 && (J = "onCompositionStart");
        J && (Jf && e.locale !== "ko" && (la || J !== "onCompositionStart" ? J === "onCompositionEnd" && la && (Q = Lf()) : (ee = S, oi = "value" in ee ? ee.value : ee.textContent, la = !0)), M = Mu(m, J), 0 < M.length && (J = new Vf(
          J,
          l,
          null,
          e,
          S
        ), x.push({ event: J, listeners: M }), Q ? J.data = Q : (Q = Ff(e), Q !== null && (J.data = Q)))), (Q = Ah ? zh(l, e) : Nh(l, e)) && (J = Mu(m, "onBeforeInput"), 0 < J.length && (M = new Vf(
          "onBeforeInput",
          "beforeinput",
          null,
          e,
          S
        ), x.push({
          event: M,
          listeners: J
        }), M.data = Q)), pm(
          x,
          l,
          m,
          e,
          S
        );
      }
      qd(x, t);
    });
  }
  function pn(l, t, e) {
    return {
      instance: l,
      listener: t,
      currentTarget: e
    };
  }
  function Mu(l, t) {
    for (var e = t + "Capture", a = []; l !== null; ) {
      var n = l, u = n.stateNode;
      if (n = n.tag, n !== 5 && n !== 26 && n !== 27 || u === null || (n = Ya(l, e), n != null && a.unshift(
        pn(l, n, u)
      ), n = Ya(l, t), n != null && a.push(
        pn(l, n, u)
      )), l.tag === 3) return a;
      l = l.return;
    }
    return [];
  }
  function Tm(l) {
    if (l === null) return null;
    do
      l = l.return;
    while (l && l.tag !== 5 && l.tag !== 27);
    return l || null;
  }
  function Yd(l, t, e, a, n) {
    for (var u = t._reactName, i = []; e !== null && e !== a; ) {
      var f = e, s = f.alternate, m = f.stateNode;
      if (f = f.tag, s !== null && s === a) break;
      f !== 5 && f !== 26 && f !== 27 || m === null || (s = m, n ? (m = Ya(e, u), m != null && i.unshift(
        pn(e, m, s)
      )) : n || (m = Ya(e, u), m != null && i.push(
        pn(e, m, s)
      ))), e = e.return;
    }
    i.length !== 0 && l.push({ event: t, listeners: i });
  }
  var Em = /\r\n?/g, jm = /\u0000|\uFFFD/g;
  function Gd(l) {
    return (typeof l == "string" ? l : "" + l).replace(Em, `
`).replace(jm, "");
  }
  function Xd(l, t) {
    return t = Gd(t), Gd(l) === t;
  }
  function il(l, t, e, a, n, u) {
    switch (e) {
      case "children":
        typeof a == "string" ? t === "body" || t === "textarea" && a === "" || Fe(l, a) : (typeof a == "number" || typeof a == "bigint") && t !== "body" && Fe(l, "" + a);
        break;
      case "className":
        Hn(l, "class", a);
        break;
      case "tabIndex":
        Hn(l, "tabindex", a);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        Hn(l, e, a);
        break;
      case "style":
        Gf(l, a, u);
        break;
      case "data":
        if (t !== "object") {
          Hn(l, "data", a);
          break;
        }
      case "src":
      case "href":
        if (a === "" && (t !== "a" || e !== "href")) {
          l.removeAttribute(e);
          break;
        }
        if (a == null || typeof a == "function" || typeof a == "symbol" || typeof a == "boolean") {
          l.removeAttribute(e);
          break;
        }
        a = Bn("" + a), l.setAttribute(e, a);
        break;
      case "action":
      case "formAction":
        if (typeof a == "function") {
          l.setAttribute(
            e,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof u == "function" && (e === "formAction" ? (t !== "input" && il(l, t, "name", n.name, n, null), il(
            l,
            t,
            "formEncType",
            n.formEncType,
            n,
            null
          ), il(
            l,
            t,
            "formMethod",
            n.formMethod,
            n,
            null
          ), il(
            l,
            t,
            "formTarget",
            n.formTarget,
            n,
            null
          )) : (il(l, t, "encType", n.encType, n, null), il(l, t, "method", n.method, n, null), il(l, t, "target", n.target, n, null)));
        if (a == null || typeof a == "symbol" || typeof a == "boolean") {
          l.removeAttribute(e);
          break;
        }
        a = Bn("" + a), l.setAttribute(e, a);
        break;
      case "onClick":
        a != null && (l.onclick = Bt);
        break;
      case "onScroll":
        a != null && V("scroll", l);
        break;
      case "onScrollEnd":
        a != null && V("scrollend", l);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(y(61));
          if (e = a.__html, e != null) {
            if (n.children != null) throw Error(y(60));
            l.innerHTML = e;
          }
        }
        break;
      case "multiple":
        l.multiple = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "muted":
        l.muted = a && typeof a != "function" && typeof a != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (a == null || typeof a == "function" || typeof a == "boolean" || typeof a == "symbol") {
          l.removeAttribute("xlink:href");
          break;
        }
        e = Bn("" + a), l.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          e
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        a != null && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, "" + a) : l.removeAttribute(e);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        a && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, "") : l.removeAttribute(e);
        break;
      case "capture":
      case "download":
        a === !0 ? l.setAttribute(e, "") : a !== !1 && a != null && typeof a != "function" && typeof a != "symbol" ? l.setAttribute(e, a) : l.removeAttribute(e);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        a != null && typeof a != "function" && typeof a != "symbol" && !isNaN(a) && 1 <= a ? l.setAttribute(e, a) : l.removeAttribute(e);
        break;
      case "rowSpan":
      case "start":
        a == null || typeof a == "function" || typeof a == "symbol" || isNaN(a) ? l.removeAttribute(e) : l.setAttribute(e, a);
        break;
      case "popover":
        V("beforetoggle", l), V("toggle", l), Rn(l, "popover", a);
        break;
      case "xlinkActuate":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          a
        );
        break;
      case "xlinkArcrole":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          a
        );
        break;
      case "xlinkRole":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          a
        );
        break;
      case "xlinkShow":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          a
        );
        break;
      case "xlinkTitle":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          a
        );
        break;
      case "xlinkType":
        qt(
          l,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          a
        );
        break;
      case "xmlBase":
        qt(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          a
        );
        break;
      case "xmlLang":
        qt(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          a
        );
        break;
      case "xmlSpace":
        qt(
          l,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          a
        );
        break;
      case "is":
        Rn(l, "is", a);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        (!(2 < e.length) || e[0] !== "o" && e[0] !== "O" || e[1] !== "n" && e[1] !== "N") && (e = Ir.get(e) || e, Rn(l, e, a));
    }
  }
  function Vc(l, t, e, a, n, u) {
    switch (e) {
      case "style":
        Gf(l, a, u);
        break;
      case "dangerouslySetInnerHTML":
        if (a != null) {
          if (typeof a != "object" || !("__html" in a))
            throw Error(y(61));
          if (e = a.__html, e != null) {
            if (n.children != null) throw Error(y(60));
            l.innerHTML = e;
          }
        }
        break;
      case "children":
        typeof a == "string" ? Fe(l, a) : (typeof a == "number" || typeof a == "bigint") && Fe(l, "" + a);
        break;
      case "onScroll":
        a != null && V("scroll", l);
        break;
      case "onScrollEnd":
        a != null && V("scrollend", l);
        break;
      case "onClick":
        a != null && (l.onclick = Bt);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!Df.hasOwnProperty(e))
          l: {
            if (e[0] === "o" && e[1] === "n" && (n = e.endsWith("Capture"), t = e.slice(2, n ? e.length - 7 : void 0), u = l[$l] || null, u = u != null ? u[e] : null, typeof u == "function" && l.removeEventListener(t, u, n), typeof a == "function")) {
              typeof u != "function" && u !== null && (e in l ? l[e] = null : l.hasAttribute(e) && l.removeAttribute(e)), l.addEventListener(t, a, n);
              break l;
            }
            e in l ? l[e] = a : a === !0 ? l.setAttribute(e, "") : Rn(l, e, a);
          }
    }
  }
  function Ql(l, t, e) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        V("error", l), V("load", l);
        var a = !1, n = !1, u;
        for (u in e)
          if (e.hasOwnProperty(u)) {
            var i = e[u];
            if (i != null)
              switch (u) {
                case "src":
                  a = !0;
                  break;
                case "srcSet":
                  n = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(y(137, t));
                default:
                  il(l, t, u, i, e, null);
              }
          }
        n && il(l, t, "srcSet", e.srcSet, e, null), a && il(l, t, "src", e.src, e, null);
        return;
      case "input":
        V("invalid", l);
        var f = u = i = n = null, s = null, m = null;
        for (a in e)
          if (e.hasOwnProperty(a)) {
            var S = e[a];
            if (S != null)
              switch (a) {
                case "name":
                  n = S;
                  break;
                case "type":
                  i = S;
                  break;
                case "checked":
                  s = S;
                  break;
                case "defaultChecked":
                  m = S;
                  break;
                case "value":
                  u = S;
                  break;
                case "defaultValue":
                  f = S;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (S != null)
                    throw Error(y(137, t));
                  break;
                default:
                  il(l, t, a, S, e, null);
              }
          }
        Hf(
          l,
          u,
          f,
          s,
          m,
          i,
          n,
          !1
        );
        return;
      case "select":
        V("invalid", l), a = i = u = null;
        for (n in e)
          if (e.hasOwnProperty(n) && (f = e[n], f != null))
            switch (n) {
              case "value":
                u = f;
                break;
              case "defaultValue":
                i = f;
                break;
              case "multiple":
                a = f;
              default:
                il(l, t, n, f, e, null);
            }
        t = u, e = i, l.multiple = !!a, t != null ? $e(l, !!a, t, !1) : e != null && $e(l, !!a, e, !0);
        return;
      case "textarea":
        V("invalid", l), u = n = a = null;
        for (i in e)
          if (e.hasOwnProperty(i) && (f = e[i], f != null))
            switch (i) {
              case "value":
                a = f;
                break;
              case "defaultValue":
                n = f;
                break;
              case "children":
                u = f;
                break;
              case "dangerouslySetInnerHTML":
                if (f != null) throw Error(y(91));
                break;
              default:
                il(l, t, i, f, e, null);
            }
        Bf(l, a, n, u);
        return;
      case "option":
        for (s in e)
          e.hasOwnProperty(s) && (a = e[s], a != null) && (s === "selected" ? l.selected = a && typeof a != "function" && typeof a != "symbol" : il(l, t, s, a, e, null));
        return;
      case "dialog":
        V("beforetoggle", l), V("toggle", l), V("cancel", l), V("close", l);
        break;
      case "iframe":
      case "object":
        V("load", l);
        break;
      case "video":
      case "audio":
        for (a = 0; a < gn.length; a++)
          V(gn[a], l);
        break;
      case "image":
        V("error", l), V("load", l);
        break;
      case "details":
        V("toggle", l);
        break;
      case "embed":
      case "source":
      case "link":
        V("error", l), V("load", l);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (m in e)
          if (e.hasOwnProperty(m) && (a = e[m], a != null))
            switch (m) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(y(137, t));
              default:
                il(l, t, m, a, e, null);
            }
        return;
      default:
        if (ui(t)) {
          for (S in e)
            e.hasOwnProperty(S) && (a = e[S], a !== void 0 && Vc(
              l,
              t,
              S,
              a,
              e,
              void 0
            ));
          return;
        }
    }
    for (f in e)
      e.hasOwnProperty(f) && (a = e[f], a != null && il(l, t, f, a, e, null));
  }
  function Am(l, t, e, a) {
    switch (t) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var n = null, u = null, i = null, f = null, s = null, m = null, S = null;
        for (g in e) {
          var x = e[g];
          if (e.hasOwnProperty(g) && x != null)
            switch (g) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                s = x;
              default:
                a.hasOwnProperty(g) || il(l, t, g, null, a, x);
            }
        }
        for (var v in a) {
          var g = a[v];
          if (x = e[v], a.hasOwnProperty(v) && (g != null || x != null))
            switch (v) {
              case "type":
                u = g;
                break;
              case "name":
                n = g;
                break;
              case "checked":
                m = g;
                break;
              case "defaultChecked":
                S = g;
                break;
              case "value":
                i = g;
                break;
              case "defaultValue":
                f = g;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (g != null)
                  throw Error(y(137, t));
                break;
              default:
                g !== x && il(
                  l,
                  t,
                  v,
                  g,
                  a,
                  x
                );
            }
        }
        ai(
          l,
          i,
          f,
          s,
          m,
          S,
          u,
          n
        );
        return;
      case "select":
        g = i = f = v = null;
        for (u in e)
          if (s = e[u], e.hasOwnProperty(u) && s != null)
            switch (u) {
              case "value":
                break;
              case "multiple":
                g = s;
              default:
                a.hasOwnProperty(u) || il(
                  l,
                  t,
                  u,
                  null,
                  a,
                  s
                );
            }
        for (n in a)
          if (u = a[n], s = e[n], a.hasOwnProperty(n) && (u != null || s != null))
            switch (n) {
              case "value":
                v = u;
                break;
              case "defaultValue":
                f = u;
                break;
              case "multiple":
                i = u;
              default:
                u !== s && il(
                  l,
                  t,
                  n,
                  u,
                  a,
                  s
                );
            }
        t = f, e = i, a = g, v != null ? $e(l, !!e, v, !1) : !!a != !!e && (t != null ? $e(l, !!e, t, !0) : $e(l, !!e, e ? [] : "", !1));
        return;
      case "textarea":
        g = v = null;
        for (f in e)
          if (n = e[f], e.hasOwnProperty(f) && n != null && !a.hasOwnProperty(f))
            switch (f) {
              case "value":
                break;
              case "children":
                break;
              default:
                il(l, t, f, null, a, n);
            }
        for (i in a)
          if (n = a[i], u = e[i], a.hasOwnProperty(i) && (n != null || u != null))
            switch (i) {
              case "value":
                v = n;
                break;
              case "defaultValue":
                g = n;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (n != null) throw Error(y(91));
                break;
              default:
                n !== u && il(l, t, i, n, a, u);
            }
        qf(l, v, g);
        return;
      case "option":
        for (var D in e)
          v = e[D], e.hasOwnProperty(D) && v != null && !a.hasOwnProperty(D) && (D === "selected" ? l.selected = !1 : il(
            l,
            t,
            D,
            null,
            a,
            v
          ));
        for (s in a)
          v = a[s], g = e[s], a.hasOwnProperty(s) && v !== g && (v != null || g != null) && (s === "selected" ? l.selected = v && typeof v != "function" && typeof v != "symbol" : il(
            l,
            t,
            s,
            v,
            a,
            g
          ));
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var q in e)
          v = e[q], e.hasOwnProperty(q) && v != null && !a.hasOwnProperty(q) && il(l, t, q, null, a, v);
        for (m in a)
          if (v = a[m], g = e[m], a.hasOwnProperty(m) && v !== g && (v != null || g != null))
            switch (m) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (v != null)
                  throw Error(y(137, t));
                break;
              default:
                il(
                  l,
                  t,
                  m,
                  v,
                  a,
                  g
                );
            }
        return;
      default:
        if (ui(t)) {
          for (var cl in e)
            v = e[cl], e.hasOwnProperty(cl) && v !== void 0 && !a.hasOwnProperty(cl) && Vc(
              l,
              t,
              cl,
              void 0,
              a,
              v
            );
          for (S in a)
            v = a[S], g = e[S], !a.hasOwnProperty(S) || v === g || v === void 0 && g === void 0 || Vc(
              l,
              t,
              S,
              v,
              a,
              g
            );
          return;
        }
    }
    for (var r in e)
      v = e[r], e.hasOwnProperty(r) && v != null && !a.hasOwnProperty(r) && il(l, t, r, null, a, v);
    for (x in a)
      v = a[x], g = e[x], !a.hasOwnProperty(x) || v === g || v == null && g == null || il(l, t, x, v, a, g);
  }
  function Qd(l) {
    switch (l) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function zm() {
    if (typeof performance.getEntriesByType == "function") {
      for (var l = 0, t = 0, e = performance.getEntriesByType("resource"), a = 0; a < e.length; a++) {
        var n = e[a], u = n.transferSize, i = n.initiatorType, f = n.duration;
        if (u && f && Qd(i)) {
          for (i = 0, f = n.responseEnd, a += 1; a < e.length; a++) {
            var s = e[a], m = s.startTime;
            if (m > f) break;
            var S = s.transferSize, x = s.initiatorType;
            S && Qd(x) && (s = s.responseEnd, i += S * (s < f ? 1 : (f - m) / (s - m)));
          }
          if (--a, t += 8 * (u + i) / (n.duration / 1e3), l++, 10 < l) break;
        }
      }
      if (0 < l) return t / l / 1e6;
    }
    return navigator.connection && (l = navigator.connection.downlink, typeof l == "number") ? l : 5;
  }
  var Kc = null, Jc = null;
  function Uu(l) {
    return l.nodeType === 9 ? l : l.ownerDocument;
  }
  function Ld(l) {
    switch (l) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function Zd(l, t) {
    if (l === 0)
      switch (t) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return l === 1 && t === "foreignObject" ? 0 : l;
  }
  function Wc(l, t) {
    return l === "textarea" || l === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
  }
  var kc = null;
  function Nm() {
    var l = window.event;
    return l && l.type === "popstate" ? l === kc ? !1 : (kc = l, !0) : (kc = null, !1);
  }
  var wd = typeof setTimeout == "function" ? setTimeout : void 0, Om = typeof clearTimeout == "function" ? clearTimeout : void 0, Vd = typeof Promise == "function" ? Promise : void 0, _m = typeof queueMicrotask == "function" ? queueMicrotask : typeof Vd < "u" ? function(l) {
    return Vd.resolve(null).then(l).catch(Dm);
  } : wd;
  function Dm(l) {
    setTimeout(function() {
      throw l;
    });
  }
  function Se(l) {
    return l === "head";
  }
  function Kd(l, t) {
    var e = t, a = 0;
    do {
      var n = e.nextSibling;
      if (l.removeChild(e), n && n.nodeType === 8)
        if (e = n.data, e === "/$" || e === "/&") {
          if (a === 0) {
            l.removeChild(n), Oa(t);
            return;
          }
          a--;
        } else if (e === "$" || e === "$?" || e === "$~" || e === "$!" || e === "&")
          a++;
        else if (e === "html")
          Sn(l.ownerDocument.documentElement);
        else if (e === "head") {
          e = l.ownerDocument.head, Sn(e);
          for (var u = e.firstChild; u; ) {
            var i = u.nextSibling, f = u.nodeName;
            u[qa] || f === "SCRIPT" || f === "STYLE" || f === "LINK" && u.rel.toLowerCase() === "stylesheet" || e.removeChild(u), u = i;
          }
        } else
          e === "body" && Sn(l.ownerDocument.body);
      e = n;
    } while (e);
    Oa(t);
  }
  function Jd(l, t) {
    var e = l;
    l = 0;
    do {
      var a = e.nextSibling;
      if (e.nodeType === 1 ? t ? (e._stashedDisplay = e.style.display, e.style.display = "none") : (e.style.display = e._stashedDisplay || "", e.getAttribute("style") === "" && e.removeAttribute("style")) : e.nodeType === 3 && (t ? (e._stashedText = e.nodeValue, e.nodeValue = "") : e.nodeValue = e._stashedText || ""), a && a.nodeType === 8)
        if (e = a.data, e === "/$") {
          if (l === 0) break;
          l--;
        } else
          e !== "$" && e !== "$?" && e !== "$~" && e !== "$!" || l++;
      e = a;
    } while (e);
  }
  function $c(l) {
    var t = l.firstChild;
    for (t && t.nodeType === 10 && (t = t.nextSibling); t; ) {
      var e = t;
      switch (t = t.nextSibling, e.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          $c(e), ti(e);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (e.rel.toLowerCase() === "stylesheet") continue;
      }
      l.removeChild(e);
    }
  }
  function Mm(l, t, e, a) {
    for (; l.nodeType === 1; ) {
      var n = e;
      if (l.nodeName.toLowerCase() !== t.toLowerCase()) {
        if (!a && (l.nodeName !== "INPUT" || l.type !== "hidden"))
          break;
      } else if (a) {
        if (!l[qa])
          switch (t) {
            case "meta":
              if (!l.hasAttribute("itemprop")) break;
              return l;
            case "link":
              if (u = l.getAttribute("rel"), u === "stylesheet" && l.hasAttribute("data-precedence"))
                break;
              if (u !== n.rel || l.getAttribute("href") !== (n.href == null || n.href === "" ? null : n.href) || l.getAttribute("crossorigin") !== (n.crossOrigin == null ? null : n.crossOrigin) || l.getAttribute("title") !== (n.title == null ? null : n.title))
                break;
              return l;
            case "style":
              if (l.hasAttribute("data-precedence")) break;
              return l;
            case "script":
              if (u = l.getAttribute("src"), (u !== (n.src == null ? null : n.src) || l.getAttribute("type") !== (n.type == null ? null : n.type) || l.getAttribute("crossorigin") !== (n.crossOrigin == null ? null : n.crossOrigin)) && u && l.hasAttribute("async") && !l.hasAttribute("itemprop"))
                break;
              return l;
            default:
              return l;
          }
      } else if (t === "input" && l.type === "hidden") {
        var u = n.name == null ? null : "" + n.name;
        if (n.type === "hidden" && l.getAttribute("name") === u)
          return l;
      } else return l;
      if (l = Tt(l.nextSibling), l === null) break;
    }
    return null;
  }
  function Um(l, t, e) {
    if (t === "") return null;
    for (; l.nodeType !== 3; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !e || (l = Tt(l.nextSibling), l === null)) return null;
    return l;
  }
  function Wd(l, t) {
    for (; l.nodeType !== 8; )
      if ((l.nodeType !== 1 || l.nodeName !== "INPUT" || l.type !== "hidden") && !t || (l = Tt(l.nextSibling), l === null)) return null;
    return l;
  }
  function Fc(l) {
    return l.data === "$?" || l.data === "$~";
  }
  function Ic(l) {
    return l.data === "$!" || l.data === "$?" && l.ownerDocument.readyState !== "loading";
  }
  function Cm(l, t) {
    var e = l.ownerDocument;
    if (l.data === "$~") l._reactRetry = t;
    else if (l.data !== "$?" || e.readyState !== "loading")
      t();
    else {
      var a = function() {
        t(), e.removeEventListener("DOMContentLoaded", a);
      };
      e.addEventListener("DOMContentLoaded", a), l._reactRetry = a;
    }
  }
  function Tt(l) {
    for (; l != null; l = l.nextSibling) {
      var t = l.nodeType;
      if (t === 1 || t === 3) break;
      if (t === 8) {
        if (t = l.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F")
          break;
        if (t === "/$" || t === "/&") return null;
      }
    }
    return l;
  }
  var Pc = null;
  function kd(l) {
    l = l.nextSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var e = l.data;
        if (e === "/$" || e === "/&") {
          if (t === 0)
            return Tt(l.nextSibling);
          t--;
        } else
          e !== "$" && e !== "$!" && e !== "$?" && e !== "$~" && e !== "&" || t++;
      }
      l = l.nextSibling;
    }
    return null;
  }
  function $d(l) {
    l = l.previousSibling;
    for (var t = 0; l; ) {
      if (l.nodeType === 8) {
        var e = l.data;
        if (e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&") {
          if (t === 0) return l;
          t--;
        } else e !== "/$" && e !== "/&" || t++;
      }
      l = l.previousSibling;
    }
    return null;
  }
  function Fd(l, t, e) {
    switch (t = Uu(e), l) {
      case "html":
        if (l = t.documentElement, !l) throw Error(y(452));
        return l;
      case "head":
        if (l = t.head, !l) throw Error(y(453));
        return l;
      case "body":
        if (l = t.body, !l) throw Error(y(454));
        return l;
      default:
        throw Error(y(451));
    }
  }
  function Sn(l) {
    for (var t = l.attributes; t.length; )
      l.removeAttributeNode(t[0]);
    ti(l);
  }
  var Et = /* @__PURE__ */ new Map(), Id = /* @__PURE__ */ new Set();
  function Cu(l) {
    return typeof l.getRootNode == "function" ? l.getRootNode() : l.nodeType === 9 ? l : l.ownerDocument;
  }
  var Pt = j.d;
  j.d = {
    f: Rm,
    r: Hm,
    D: qm,
    C: Bm,
    L: Ym,
    m: Gm,
    X: Qm,
    S: Xm,
    M: Lm
  };
  function Rm() {
    var l = Pt.f(), t = ju();
    return l || t;
  }
  function Hm(l) {
    var t = Je(l);
    t !== null && t.tag === 5 && t.type === "form" ? vo(t) : Pt.r(l);
  }
  var Aa = typeof document > "u" ? null : document;
  function Pd(l, t, e) {
    var a = Aa;
    if (a && typeof t == "string" && t) {
      var n = vt(t);
      n = 'link[rel="' + l + '"][href="' + n + '"]', typeof e == "string" && (n += '[crossorigin="' + e + '"]'), Id.has(n) || (Id.add(n), l = { rel: l, crossOrigin: e, href: t }, a.querySelector(n) === null && (t = a.createElement("link"), Ql(t, "link", l), Hl(t), a.head.appendChild(t)));
    }
  }
  function qm(l) {
    Pt.D(l), Pd("dns-prefetch", l, null);
  }
  function Bm(l, t) {
    Pt.C(l, t), Pd("preconnect", l, t);
  }
  function Ym(l, t, e) {
    Pt.L(l, t, e);
    var a = Aa;
    if (a && l && t) {
      var n = 'link[rel="preload"][as="' + vt(t) + '"]';
      t === "image" && e && e.imageSrcSet ? (n += '[imagesrcset="' + vt(
        e.imageSrcSet
      ) + '"]', typeof e.imageSizes == "string" && (n += '[imagesizes="' + vt(
        e.imageSizes
      ) + '"]')) : n += '[href="' + vt(l) + '"]';
      var u = n;
      switch (t) {
        case "style":
          u = za(l);
          break;
        case "script":
          u = Na(l);
      }
      Et.has(u) || (l = H(
        {
          rel: "preload",
          href: t === "image" && e && e.imageSrcSet ? void 0 : l,
          as: t
        },
        e
      ), Et.set(u, l), a.querySelector(n) !== null || t === "style" && a.querySelector(bn(u)) || t === "script" && a.querySelector(xn(u)) || (t = a.createElement("link"), Ql(t, "link", l), Hl(t), a.head.appendChild(t)));
    }
  }
  function Gm(l, t) {
    Pt.m(l, t);
    var e = Aa;
    if (e && l) {
      var a = t && typeof t.as == "string" ? t.as : "script", n = 'link[rel="modulepreload"][as="' + vt(a) + '"][href="' + vt(l) + '"]', u = n;
      switch (a) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          u = Na(l);
      }
      if (!Et.has(u) && (l = H({ rel: "modulepreload", href: l }, t), Et.set(u, l), e.querySelector(n) === null)) {
        switch (a) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (e.querySelector(xn(u)))
              return;
        }
        a = e.createElement("link"), Ql(a, "link", l), Hl(a), e.head.appendChild(a);
      }
    }
  }
  function Xm(l, t, e) {
    Pt.S(l, t, e);
    var a = Aa;
    if (a && l) {
      var n = We(a).hoistableStyles, u = za(l);
      t = t || "default";
      var i = n.get(u);
      if (!i) {
        var f = { loading: 0, preload: null };
        if (i = a.querySelector(
          bn(u)
        ))
          f.loading = 5;
        else {
          l = H(
            { rel: "stylesheet", href: l, "data-precedence": t },
            e
          ), (e = Et.get(u)) && lf(l, e);
          var s = i = a.createElement("link");
          Hl(s), Ql(s, "link", l), s._p = new Promise(function(m, S) {
            s.onload = m, s.onerror = S;
          }), s.addEventListener("load", function() {
            f.loading |= 1;
          }), s.addEventListener("error", function() {
            f.loading |= 2;
          }), f.loading |= 4, Ru(i, t, a);
        }
        i = {
          type: "stylesheet",
          instance: i,
          count: 1,
          state: f
        }, n.set(u, i);
      }
    }
  }
  function Qm(l, t) {
    Pt.X(l, t);
    var e = Aa;
    if (e && l) {
      var a = We(e).hoistableScripts, n = Na(l), u = a.get(n);
      u || (u = e.querySelector(xn(n)), u || (l = H({ src: l, async: !0 }, t), (t = Et.get(n)) && tf(l, t), u = e.createElement("script"), Hl(u), Ql(u, "link", l), e.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, a.set(n, u));
    }
  }
  function Lm(l, t) {
    Pt.M(l, t);
    var e = Aa;
    if (e && l) {
      var a = We(e).hoistableScripts, n = Na(l), u = a.get(n);
      u || (u = e.querySelector(xn(n)), u || (l = H({ src: l, async: !0, type: "module" }, t), (t = Et.get(n)) && tf(l, t), u = e.createElement("script"), Hl(u), Ql(u, "link", l), e.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, a.set(n, u));
    }
  }
  function lr(l, t, e, a) {
    var n = (n = L.current) ? Cu(n) : null;
    if (!n) throw Error(y(446));
    switch (l) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof e.precedence == "string" && typeof e.href == "string" ? (t = za(e.href), e = We(
          n
        ).hoistableStyles, a = e.get(t), a || (a = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, e.set(t, a)), a) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (e.rel === "stylesheet" && typeof e.href == "string" && typeof e.precedence == "string") {
          l = za(e.href);
          var u = We(
            n
          ).hoistableStyles, i = u.get(l);
          if (i || (n = n.ownerDocument || n, i = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, u.set(l, i), (u = n.querySelector(
            bn(l)
          )) && !u._p && (i.instance = u, i.state.loading = 5), Et.has(l) || (e = {
            rel: "preload",
            as: "style",
            href: e.href,
            crossOrigin: e.crossOrigin,
            integrity: e.integrity,
            media: e.media,
            hrefLang: e.hrefLang,
            referrerPolicy: e.referrerPolicy
          }, Et.set(l, e), u || Zm(
            n,
            l,
            e,
            i.state
          ))), t && a === null)
            throw Error(y(528, ""));
          return i;
        }
        if (t && a !== null)
          throw Error(y(529, ""));
        return null;
      case "script":
        return t = e.async, e = e.src, typeof e == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Na(e), e = We(
          n
        ).hoistableScripts, a = e.get(t), a || (a = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, e.set(t, a)), a) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(y(444, l));
    }
  }
  function za(l) {
    return 'href="' + vt(l) + '"';
  }
  function bn(l) {
    return 'link[rel="stylesheet"][' + l + "]";
  }
  function tr(l) {
    return H({}, l, {
      "data-precedence": l.precedence,
      precedence: null
    });
  }
  function Zm(l, t, e, a) {
    l.querySelector('link[rel="preload"][as="style"][' + t + "]") ? a.loading = 1 : (t = l.createElement("link"), a.preload = t, t.addEventListener("load", function() {
      return a.loading |= 1;
    }), t.addEventListener("error", function() {
      return a.loading |= 2;
    }), Ql(t, "link", e), Hl(t), l.head.appendChild(t));
  }
  function Na(l) {
    return '[src="' + vt(l) + '"]';
  }
  function xn(l) {
    return "script[async]" + l;
  }
  function er(l, t, e) {
    if (t.count++, t.instance === null)
      switch (t.type) {
        case "style":
          var a = l.querySelector(
            'style[data-href~="' + vt(e.href) + '"]'
          );
          if (a)
            return t.instance = a, Hl(a), a;
          var n = H({}, e, {
            "data-href": e.href,
            "data-precedence": e.precedence,
            href: null,
            precedence: null
          });
          return a = (l.ownerDocument || l).createElement(
            "style"
          ), Hl(a), Ql(a, "style", n), Ru(a, e.precedence, l), t.instance = a;
        case "stylesheet":
          n = za(e.href);
          var u = l.querySelector(
            bn(n)
          );
          if (u)
            return t.state.loading |= 4, t.instance = u, Hl(u), u;
          a = tr(e), (n = Et.get(n)) && lf(a, n), u = (l.ownerDocument || l).createElement("link"), Hl(u);
          var i = u;
          return i._p = new Promise(function(f, s) {
            i.onload = f, i.onerror = s;
          }), Ql(u, "link", a), t.state.loading |= 4, Ru(u, e.precedence, l), t.instance = u;
        case "script":
          return u = Na(e.src), (n = l.querySelector(
            xn(u)
          )) ? (t.instance = n, Hl(n), n) : (a = e, (n = Et.get(u)) && (a = H({}, e), tf(a, n)), l = l.ownerDocument || l, n = l.createElement("script"), Hl(n), Ql(n, "link", a), l.head.appendChild(n), t.instance = n);
        case "void":
          return null;
        default:
          throw Error(y(443, t.type));
      }
    else
      t.type === "stylesheet" && (t.state.loading & 4) === 0 && (a = t.instance, t.state.loading |= 4, Ru(a, e.precedence, l));
    return t.instance;
  }
  function Ru(l, t, e) {
    for (var a = e.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), n = a.length ? a[a.length - 1] : null, u = n, i = 0; i < a.length; i++) {
      var f = a[i];
      if (f.dataset.precedence === t) u = f;
      else if (u !== n) break;
    }
    u ? u.parentNode.insertBefore(l, u.nextSibling) : (t = e.nodeType === 9 ? e.head : e, t.insertBefore(l, t.firstChild));
  }
  function lf(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy), l.title == null && (l.title = t.title);
  }
  function tf(l, t) {
    l.crossOrigin == null && (l.crossOrigin = t.crossOrigin), l.referrerPolicy == null && (l.referrerPolicy = t.referrerPolicy), l.integrity == null && (l.integrity = t.integrity);
  }
  var Hu = null;
  function ar(l, t, e) {
    if (Hu === null) {
      var a = /* @__PURE__ */ new Map(), n = Hu = /* @__PURE__ */ new Map();
      n.set(e, a);
    } else
      n = Hu, a = n.get(e), a || (a = /* @__PURE__ */ new Map(), n.set(e, a));
    if (a.has(l)) return a;
    for (a.set(l, null), e = e.getElementsByTagName(l), n = 0; n < e.length; n++) {
      var u = e[n];
      if (!(u[qa] || u[Bl] || l === "link" && u.getAttribute("rel") === "stylesheet") && u.namespaceURI !== "http://www.w3.org/2000/svg") {
        var i = u.getAttribute(t) || "";
        i = l + i;
        var f = a.get(i);
        f ? f.push(u) : a.set(i, [u]);
      }
    }
    return a;
  }
  function nr(l, t, e) {
    l = l.ownerDocument || l, l.head.insertBefore(
      e,
      t === "title" ? l.querySelector("head > title") : null
    );
  }
  function wm(l, t, e) {
    if (e === 1 || t.itemProp != null) return !1;
    switch (l) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "")
          break;
        return !0;
      case "link":
        if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError)
          break;
        return t.rel === "stylesheet" ? (l = t.disabled, typeof t.precedence == "string" && l == null) : !0;
      case "script":
        if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string")
          return !0;
    }
    return !1;
  }
  function ur(l) {
    return !(l.type === "stylesheet" && (l.state.loading & 3) === 0);
  }
  function Vm(l, t, e, a) {
    if (e.type === "stylesheet" && (typeof a.media != "string" || matchMedia(a.media).matches !== !1) && (e.state.loading & 4) === 0) {
      if (e.instance === null) {
        var n = za(a.href), u = t.querySelector(
          bn(n)
        );
        if (u) {
          t = u._p, t !== null && typeof t == "object" && typeof t.then == "function" && (l.count++, l = qu.bind(l), t.then(l, l)), e.state.loading |= 4, e.instance = u, Hl(u);
          return;
        }
        u = t.ownerDocument || t, a = tr(a), (n = Et.get(n)) && lf(a, n), u = u.createElement("link"), Hl(u);
        var i = u;
        i._p = new Promise(function(f, s) {
          i.onload = f, i.onerror = s;
        }), Ql(u, "link", a), e.instance = u;
      }
      l.stylesheets === null && (l.stylesheets = /* @__PURE__ */ new Map()), l.stylesheets.set(e, t), (t = e.state.preload) && (e.state.loading & 3) === 0 && (l.count++, e = qu.bind(l), t.addEventListener("load", e), t.addEventListener("error", e));
    }
  }
  var ef = 0;
  function Km(l, t) {
    return l.stylesheets && l.count === 0 && Yu(l, l.stylesheets), 0 < l.count || 0 < l.imgCount ? function(e) {
      var a = setTimeout(function() {
        if (l.stylesheets && Yu(l, l.stylesheets), l.unsuspend) {
          var u = l.unsuspend;
          l.unsuspend = null, u();
        }
      }, 6e4 + t);
      0 < l.imgBytes && ef === 0 && (ef = 62500 * zm());
      var n = setTimeout(
        function() {
          if (l.waitingForImages = !1, l.count === 0 && (l.stylesheets && Yu(l, l.stylesheets), l.unsuspend)) {
            var u = l.unsuspend;
            l.unsuspend = null, u();
          }
        },
        (l.imgBytes > ef ? 50 : 800) + t
      );
      return l.unsuspend = e, function() {
        l.unsuspend = null, clearTimeout(a), clearTimeout(n);
      };
    } : null;
  }
  function qu() {
    if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
      if (this.stylesheets) Yu(this, this.stylesheets);
      else if (this.unsuspend) {
        var l = this.unsuspend;
        this.unsuspend = null, l();
      }
    }
  }
  var Bu = null;
  function Yu(l, t) {
    l.stylesheets = null, l.unsuspend !== null && (l.count++, Bu = /* @__PURE__ */ new Map(), t.forEach(Jm, l), Bu = null, qu.call(l));
  }
  function Jm(l, t) {
    if (!(t.state.loading & 4)) {
      var e = Bu.get(l);
      if (e) var a = e.get(null);
      else {
        e = /* @__PURE__ */ new Map(), Bu.set(l, e);
        for (var n = l.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), u = 0; u < n.length; u++) {
          var i = n[u];
          (i.nodeName === "LINK" || i.getAttribute("media") !== "not all") && (e.set(i.dataset.precedence, i), a = i);
        }
        a && e.set(null, a);
      }
      n = t.instance, i = n.getAttribute("data-precedence"), u = e.get(i) || a, u === a && e.set(null, n), e.set(i, n), this.count++, a = qu.bind(this), n.addEventListener("load", a), n.addEventListener("error", a), u ? u.parentNode.insertBefore(n, u.nextSibling) : (l = l.nodeType === 9 ? l.head : l, l.insertBefore(n, l.firstChild)), t.state.loading |= 4;
    }
  }
  var Tn = {
    $$typeof: zl,
    Provider: null,
    Consumer: null,
    _currentValue: C,
    _currentValue2: C,
    _threadCount: 0
  };
  function Wm(l, t, e, a, n, u, i, f, s) {
    this.tag = 1, this.containerInfo = l, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Fu(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Fu(0), this.hiddenUpdates = Fu(null), this.identifierPrefix = a, this.onUncaughtError = n, this.onCaughtError = u, this.onRecoverableError = i, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = s, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function ir(l, t, e, a, n, u, i, f, s, m, S, x) {
    return l = new Wm(
      l,
      t,
      e,
      i,
      s,
      m,
      S,
      x,
      f
    ), t = 1, u === !0 && (t |= 24), u = ct(3, null, null, t), l.current = u, u.stateNode = l, t = Hi(), t.refCount++, l.pooledCache = t, t.refCount++, u.memoizedState = {
      element: a,
      isDehydrated: e,
      cache: t
    }, Gi(u), l;
  }
  function cr(l) {
    return l ? (l = na, l) : na;
  }
  function fr(l, t, e, a, n, u) {
    n = cr(n), a.context === null ? a.context = n : a.pendingContext = n, a = fe(t), a.payload = { element: e }, u = u === void 0 ? null : u, u !== null && (a.callback = u), e = se(l, a, t), e !== null && (et(e, l, t), Pa(e, l, t));
  }
  function sr(l, t) {
    if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
      var e = l.retryLane;
      l.retryLane = e !== 0 && e < t ? e : t;
    }
  }
  function af(l, t) {
    sr(l, t), (l = l.alternate) && sr(l, t);
  }
  function or(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = Me(l, 67108864);
      t !== null && et(t, l, 67108864), af(l, 67108864);
    }
  }
  function dr(l) {
    if (l.tag === 13 || l.tag === 31) {
      var t = rt();
      t = Iu(t);
      var e = Me(l, t);
      e !== null && et(e, l, t), af(l, t);
    }
  }
  var Gu = !0;
  function km(l, t, e, a) {
    var n = p.T;
    p.T = null;
    var u = j.p;
    try {
      j.p = 2, nf(l, t, e, a);
    } finally {
      j.p = u, p.T = n;
    }
  }
  function $m(l, t, e, a) {
    var n = p.T;
    p.T = null;
    var u = j.p;
    try {
      j.p = 8, nf(l, t, e, a);
    } finally {
      j.p = u, p.T = n;
    }
  }
  function nf(l, t, e, a) {
    if (Gu) {
      var n = uf(a);
      if (n === null)
        wc(
          l,
          t,
          a,
          Xu,
          e
        ), hr(l, a);
      else if (Im(
        n,
        l,
        t,
        e,
        a
      ))
        a.stopPropagation();
      else if (hr(l, a), t & 4 && -1 < Fm.indexOf(l)) {
        for (; n !== null; ) {
          var u = Je(n);
          if (u !== null)
            switch (u.tag) {
              case 3:
                if (u = u.stateNode, u.current.memoizedState.isDehydrated) {
                  var i = ze(u.pendingLanes);
                  if (i !== 0) {
                    var f = u;
                    for (f.pendingLanes |= 2, f.entangledLanes |= 2; i; ) {
                      var s = 1 << 31 - ut(i);
                      f.entanglements[1] |= s, i &= ~s;
                    }
                    Rt(u), (tl & 6) === 0 && (Tu = at() + 500, yn(0));
                  }
                }
                break;
              case 31:
              case 13:
                f = Me(u, 2), f !== null && et(f, u, 2), ju(), af(u, 2);
            }
          if (u = uf(a), u === null && wc(
            l,
            t,
            a,
            Xu,
            e
          ), u === n) break;
          n = u;
        }
        n !== null && a.stopPropagation();
      } else
        wc(
          l,
          t,
          a,
          null,
          e
        );
    }
  }
  function uf(l) {
    return l = ci(l), cf(l);
  }
  var Xu = null;
  function cf(l) {
    if (Xu = null, l = Ke(l), l !== null) {
      var t = sl(l);
      if (t === null) l = null;
      else {
        var e = t.tag;
        if (e === 13) {
          if (l = El(t), l !== null) return l;
          l = null;
        } else if (e === 31) {
          if (l = Rl(t), l !== null) return l;
          l = null;
        } else if (e === 3) {
          if (t.stateNode.current.memoizedState.isDehydrated)
            return t.tag === 3 ? t.stateNode.containerInfo : null;
          l = null;
        } else t !== l && (l = null);
      }
    }
    return Xu = l, null;
  }
  function rr(l) {
    switch (l) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (qr()) {
          case Sf:
            return 2;
          case bf:
            return 8;
          case _n:
          case Br:
            return 32;
          case xf:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var ff = !1, be = null, xe = null, Te = null, En = /* @__PURE__ */ new Map(), jn = /* @__PURE__ */ new Map(), Ee = [], Fm = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function hr(l, t) {
    switch (l) {
      case "focusin":
      case "focusout":
        be = null;
        break;
      case "dragenter":
      case "dragleave":
        xe = null;
        break;
      case "mouseover":
      case "mouseout":
        Te = null;
        break;
      case "pointerover":
      case "pointerout":
        En.delete(t.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        jn.delete(t.pointerId);
    }
  }
  function An(l, t, e, a, n, u) {
    return l === null || l.nativeEvent !== u ? (l = {
      blockedOn: t,
      domEventName: e,
      eventSystemFlags: a,
      nativeEvent: u,
      targetContainers: [n]
    }, t !== null && (t = Je(t), t !== null && or(t)), l) : (l.eventSystemFlags |= a, t = l.targetContainers, n !== null && t.indexOf(n) === -1 && t.push(n), l);
  }
  function Im(l, t, e, a, n) {
    switch (t) {
      case "focusin":
        return be = An(
          be,
          l,
          t,
          e,
          a,
          n
        ), !0;
      case "dragenter":
        return xe = An(
          xe,
          l,
          t,
          e,
          a,
          n
        ), !0;
      case "mouseover":
        return Te = An(
          Te,
          l,
          t,
          e,
          a,
          n
        ), !0;
      case "pointerover":
        var u = n.pointerId;
        return En.set(
          u,
          An(
            En.get(u) || null,
            l,
            t,
            e,
            a,
            n
          )
        ), !0;
      case "gotpointercapture":
        return u = n.pointerId, jn.set(
          u,
          An(
            jn.get(u) || null,
            l,
            t,
            e,
            a,
            n
          )
        ), !0;
    }
    return !1;
  }
  function mr(l) {
    var t = Ke(l.target);
    if (t !== null) {
      var e = sl(t);
      if (e !== null) {
        if (t = e.tag, t === 13) {
          if (t = El(e), t !== null) {
            l.blockedOn = t, Nf(l.priority, function() {
              dr(e);
            });
            return;
          }
        } else if (t === 31) {
          if (t = Rl(e), t !== null) {
            l.blockedOn = t, Nf(l.priority, function() {
              dr(e);
            });
            return;
          }
        } else if (t === 3 && e.stateNode.current.memoizedState.isDehydrated) {
          l.blockedOn = e.tag === 3 ? e.stateNode.containerInfo : null;
          return;
        }
      }
    }
    l.blockedOn = null;
  }
  function Qu(l) {
    if (l.blockedOn !== null) return !1;
    for (var t = l.targetContainers; 0 < t.length; ) {
      var e = uf(l.nativeEvent);
      if (e === null) {
        e = l.nativeEvent;
        var a = new e.constructor(
          e.type,
          e
        );
        ii = a, e.target.dispatchEvent(a), ii = null;
      } else
        return t = Je(e), t !== null && or(t), l.blockedOn = e, !1;
      t.shift();
    }
    return !0;
  }
  function vr(l, t, e) {
    Qu(l) && e.delete(t);
  }
  function Pm() {
    ff = !1, be !== null && Qu(be) && (be = null), xe !== null && Qu(xe) && (xe = null), Te !== null && Qu(Te) && (Te = null), En.forEach(vr), jn.forEach(vr);
  }
  function Lu(l, t) {
    l.blockedOn === t && (l.blockedOn = null, ff || (ff = !0, N.unstable_scheduleCallback(
      N.unstable_NormalPriority,
      Pm
    )));
  }
  var Zu = null;
  function yr(l) {
    Zu !== l && (Zu = l, N.unstable_scheduleCallback(
      N.unstable_NormalPriority,
      function() {
        Zu === l && (Zu = null);
        for (var t = 0; t < l.length; t += 3) {
          var e = l[t], a = l[t + 1], n = l[t + 2];
          if (typeof a != "function") {
            if (cf(a || e) === null)
              continue;
            break;
          }
          var u = Je(e);
          u !== null && (l.splice(t, 3), t -= 3, uc(
            u,
            {
              pending: !0,
              data: n,
              method: e.method,
              action: a
            },
            a,
            n
          ));
        }
      }
    ));
  }
  function Oa(l) {
    function t(s) {
      return Lu(s, l);
    }
    be !== null && Lu(be, l), xe !== null && Lu(xe, l), Te !== null && Lu(Te, l), En.forEach(t), jn.forEach(t);
    for (var e = 0; e < Ee.length; e++) {
      var a = Ee[e];
      a.blockedOn === l && (a.blockedOn = null);
    }
    for (; 0 < Ee.length && (e = Ee[0], e.blockedOn === null); )
      mr(e), e.blockedOn === null && Ee.shift();
    if (e = (l.ownerDocument || l).$$reactFormReplay, e != null)
      for (a = 0; a < e.length; a += 3) {
        var n = e[a], u = e[a + 1], i = n[$l] || null;
        if (typeof u == "function")
          i || yr(e);
        else if (i) {
          var f = null;
          if (u && u.hasAttribute("formAction")) {
            if (n = u, i = u[$l] || null)
              f = i.formAction;
            else if (cf(n) !== null) continue;
          } else f = i.action;
          typeof f == "function" ? e[a + 1] = f : (e.splice(a, 3), a -= 3), yr(e);
        }
      }
  }
  function gr() {
    function l(u) {
      u.canIntercept && u.info === "react-transition" && u.intercept({
        handler: function() {
          return new Promise(function(i) {
            return n = i;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function t() {
      n !== null && (n(), n = null), a || setTimeout(e, 20);
    }
    function e() {
      if (!a && !navigation.transition) {
        var u = navigation.currentEntry;
        u && u.url != null && navigation.navigate(u.url, {
          state: u.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var a = !1, n = null;
      return navigation.addEventListener("navigate", l), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(e, 100), function() {
        a = !0, navigation.removeEventListener("navigate", l), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), n !== null && (n(), n = null);
      };
    }
  }
  function sf(l) {
    this._internalRoot = l;
  }
  wu.prototype.render = sf.prototype.render = function(l) {
    var t = this._internalRoot;
    if (t === null) throw Error(y(409));
    var e = t.current, a = rt();
    fr(e, a, l, t, null, null);
  }, wu.prototype.unmount = sf.prototype.unmount = function() {
    var l = this._internalRoot;
    if (l !== null) {
      this._internalRoot = null;
      var t = l.containerInfo;
      fr(l.current, 2, null, l, null, null), ju(), t[Ve] = null;
    }
  };
  function wu(l) {
    this._internalRoot = l;
  }
  wu.prototype.unstable_scheduleHydration = function(l) {
    if (l) {
      var t = zf();
      l = { blockedOn: null, target: l, priority: t };
      for (var e = 0; e < Ee.length && t !== 0 && t < Ee[e].priority; e++) ;
      Ee.splice(e, 0, l), e === 0 && mr(l);
    }
  };
  var pr = yl.version;
  if (pr !== "19.2.7")
    throw Error(
      y(
        527,
        pr,
        "19.2.7"
      )
    );
  j.findDOMNode = function(l) {
    var t = l._reactInternals;
    if (t === void 0)
      throw typeof l.render == "function" ? Error(y(188)) : (l = Object.keys(l).join(","), Error(y(268, l)));
    return l = E(t), l = l !== null ? $(l) : null, l = l === null ? null : l.stateNode, l;
  };
  var lv = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: p,
    reconcilerVersion: "19.2.7"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Vu = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Vu.isDisabled && Vu.supportsFiber)
      try {
        Ca = Vu.inject(
          lv
        ), nt = Vu;
      } catch {
      }
  }
  return Nn.createRoot = function(l, t) {
    if (!ml(l)) throw Error(y(299));
    var e = !1, a = "", n = Ao, u = zo, i = No;
    return t != null && (t.unstable_strictMode === !0 && (e = !0), t.identifierPrefix !== void 0 && (a = t.identifierPrefix), t.onUncaughtError !== void 0 && (n = t.onUncaughtError), t.onCaughtError !== void 0 && (u = t.onCaughtError), t.onRecoverableError !== void 0 && (i = t.onRecoverableError)), t = ir(
      l,
      1,
      !1,
      null,
      null,
      e,
      a,
      null,
      n,
      u,
      i,
      gr
    ), l[Ve] = t.current, Zc(l), new sf(t);
  }, Nn.hydrateRoot = function(l, t, e) {
    if (!ml(l)) throw Error(y(299));
    var a = !1, n = "", u = Ao, i = zo, f = No, s = null;
    return e != null && (e.unstable_strictMode === !0 && (a = !0), e.identifierPrefix !== void 0 && (n = e.identifierPrefix), e.onUncaughtError !== void 0 && (u = e.onUncaughtError), e.onCaughtError !== void 0 && (i = e.onCaughtError), e.onRecoverableError !== void 0 && (f = e.onRecoverableError), e.formState !== void 0 && (s = e.formState)), t = ir(
      l,
      1,
      !0,
      t,
      e ?? null,
      a,
      n,
      s,
      u,
      i,
      f,
      gr
    ), t.context = cr(null), e = t.current, a = rt(), a = Iu(a), n = fe(a), n.callback = null, se(e, n, a), e = a, t.current.lanes = e, Ha(t, e), Rt(t), l[Ve] = t.current, Zc(l), new wu(t);
  }, Nn.version = "19.2.7", Nn;
}
var Or;
function ov() {
  if (Or) return df.exports;
  Or = 1;
  function N() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(N);
      } catch (yl) {
        console.error(yl);
      }
  }
  return N(), df.exports = sv(), df.exports;
}
var dv = ov(), Ll = yf();
const rv = "43552548847652", _r = "https://spiralcombat.com/cart/43552548847652:1?storefront=true&utm_source=storefront&utm_medium=offer_page&utm_campaign=wrestling_decision_tree_v1&utm_content=core_cta", hv = "https://www.instagram.com/p/DbOizptICv2/", Dr = "https://cdn.shopify.com/s/files/1/0746/7214/4420/files/Logo.png?width=96", _t = (N) => window.__scWrestlingAssetUrls?.[N] ?? N, _a = [
  {
    level: "01",
    name: "Stance",
    short: "Can your position attack, defend and recover without a reset?",
    shift: "Before the first tie"
  },
  {
    level: "02",
    name: "Contact",
    short: "What did the first hand fight make easier—or more expensive?",
    shift: "From touch to leverage"
  },
  {
    level: "03",
    name: "Entry",
    short: "Which reaction opened the cleanest lane to the legs?",
    shift: "From move to opening"
  },
  {
    level: "04",
    name: "Finish",
    short: "When the first attack meets defense, what chain stays alive?",
    shift: "From shot to sequence"
  },
  {
    level: "05",
    name: "Position",
    short: "Does the next choice build control, escape or exposure?",
    shift: "From score to control"
  },
  {
    level: "06",
    name: "Match",
    short: "How do score, edge, pace and time change the right risk?",
    shift: "From exchange to match"
  }
], Da = [
  {
    prompt: "When an exchange stalls, what do you usually search for first?",
    options: [
      ["A named move I already know", 1],
      ["A grip, post or angle that changes the reaction", 3],
      ["The next two answers in the chain", 5]
    ]
  },
  {
    prompt: "After a failed shot, what is your default?",
    options: [
      ["Reset and try the shot again", 1],
      ["Read the defense and move to the next finish", 4],
      ["Use the reaction to change the whole position", 5]
    ]
  },
  {
    prompt: "From top, what do you notice first?",
    options: [
      ["The turn I want", 2],
      ["The post, base or build I need to remove", 5],
      ["How the clock and score change the safest pressure", 6]
    ]
  },
  {
    prompt: "When studying match footage, what do you record?",
    options: [
      ["The techniques that scored", 1],
      ["The reactions that made those techniques available", 4],
      ["The repeatable decision tree behind the sequence", 6]
    ]
  }
], Mr = [
  ["Start with a live stance", "Build one position that can attack, defend and recover before adding another move."],
  ["Start with contact", "Track what the first tie changes: head position, shoulder line, feet and access to the legs."],
  ["Start with the opening", "Use motion and hand fighting to draw one readable reaction before choosing the entry."],
  ["Start with the second answer", "Choose one attack and pre-plan the most likely defensive response and your next finish."],
  ["Start with position", "Read posts, base and build direction so your control or escape attacks the structure that is actually present."],
  ["Start with match management", "Let score, edge, pace and time shape the risk without abandoning sound position."]
], mv = [
  {
    q: "Is this a list of wrestling moves?",
    a: "No. The Wrestling Codex organizes stance, contact, entries, finishes, top, bottom and match management as connected decisions. It is a study system, not a claim that one answer works in every ruleset or body type."
  },
  {
    q: "Who is it for?",
    a: "Wrestlers, grapplers, MMA learners and coaches who want a clearer way to study why one action leads to the next."
  },
  {
    q: "What do I receive for $97 USD?",
    a: "The existing digital Wrestling Codex and its protected reader access. The physical preorder is not included and is never added by this page."
  },
  {
    q: "Does this replace coaching?",
    a: "No. It helps organize study and questions for practice. Use qualified coaching, safe progression and the rules of your discipline."
  },
  {
    q: "What is the optional $12 deck?",
    a: "A planned 14-card phone-first drill deck, printable chain-wrestling decision map and accessible HTML edition. It is unchecked by default and cannot be purchased until its exact digital product and protected delivery are ready."
  },
  {
    q: "Is anything shipped?",
    a: "No. This isolated offer is digital only. The separate physical Wrestling Codex variant is deliberately excluded."
  },
  {
    q: "How do I get access?",
    a: "After Shopify verifies payment, the existing Wrestling Codex opens in your protected Spiral Combat My Library account."
  },
  {
    q: "What should stop a drill?",
    a: "Stop for pain, dizziness, numbness, loss of coordination, compromised judgment or any partner request. Reduce speed and complexity when position or control degrades."
  }
], Ur = [
  ["/assets/wrestling/codex-cover.webp", "Cover", "The actual Wrestling Codex cover"],
  ["/assets/wrestling/page-014.svg", "How to use it", "How a Wrestling Codex rule spread works"],
  ["/assets/wrestling/page-030.svg", "Decision posture", "Rule: Do not rise to think"],
  ["/assets/wrestling/page-031.svg", "Applied rule", "Applied decision posture rule spread"],
  ["/assets/wrestling/page-092.svg", "Create the angle", "Rule: Create the angle then enter"],
  ["/assets/wrestling/page-164.svg", "Top control", "Rule: Ankle control stops the build"]
], vv = [
  ["/assets/wrestling/page-030.svg", "01", "Decision stays inside stance"],
  ["/assets/wrestling/page-092.svg", "02", "Angle creates the entry"],
  ["/assets/wrestling/page-164.svg", "03", "Top pressure forces a choice"],
  ["/assets/wrestling/page-188.svg", "04", "Bottom structure comes first"]
], On = [
  {
    id: "neutral",
    label: "Neutral",
    title: "Draw the reaction, then enter.",
    next: "Motion → reach or square-up → angle → entry",
    pages: ["/assets/wrestling/page-044.svg", "/assets/wrestling/page-045.svg"]
  },
  {
    id: "top",
    label: "Top",
    title: "Remove the build before chasing the turn.",
    next: "Base starts to rebuild → control ankle → interrupt height → breakdown",
    pages: ["/assets/wrestling/page-164.svg", "/assets/wrestling/page-165.svg"]
  },
  {
    id: "bottom",
    label: "Bottom",
    title: "Create structure before escape speed.",
    next: "Pressure settles → tripod → recover height → clear the position",
    pages: ["/assets/wrestling/page-188.svg", "/assets/wrestling/page-189.svg"]
  }
], Ma = (N, yl = {}) => {
  const F = {
    event: "sc_wrestling_decision_tree",
    action: N,
    offer_id: "wrestling_decision_tree_codex_funnel",
    core_variant_id: rv,
    ...yl
  }, y = window.dataLayer;
  Array.isArray(y) && y.push(F), window.dispatchEvent(new CustomEvent("sc:wrestling-decision-tree", { detail: F }));
};
function yv() {
  const N = Ll.useRef(null), yl = Ll.useRef(null), F = Ll.useRef(null), y = Ll.useRef(null), ml = Ll.useRef(null), [sl, El] = Ll.useState(0), [Rl, U] = Ll.useState([]), [E, $] = Ll.useState(null), [H, el] = Ll.useState(!1), [gl, Zl] = Ll.useState(!1), [jl, jt] = Ll.useState(0), [Al, Dt] = Ll.useState(0), [zl, kl] = Ll.useState(0), [ht, wl] = Ll.useState(1);
  Ll.useEffect(() => {
    const z = N.current, O = yl.current;
    if (!z || !O) return;
    const ol = window.matchMedia("(prefers-reduced-motion: reduce)");
    let Nl = ol.matches, pl = 0, p = 0, j = 0, C = 0, W = 1;
    const I = (B) => Math.min(1, Math.max(0, B)), o = (B, Ul, dl) => {
      const At = I((dl - B) / (Ul - B));
      return At * At * (3 - 2 * At);
    }, T = () => {
      pl = 0, j = Nl ? p : j + (p - j) * 0.095;
      const B = I(j), Ul = 1 - o(0.055, 0.17, B), dl = o(0.12, 0.27, B), At = Math.min(o(0.22, 0.28, B), 1 - o(0.36, 0.43, B)), we = Math.min(o(0.46, 0.53, B), 1 - o(0.65, 0.72, B)), Ua = o(0.72, 0.88, B);
      O.style.setProperty("--p", B.toFixed(4)), O.style.setProperty("--intro", Ul.toFixed(4)), O.style.setProperty("--gate", dl.toFixed(4)), O.style.setProperty("--panel-a", At.toFixed(4)), O.style.setProperty("--panel-b", we.toFixed(4)), O.style.setProperty("--catalog", Ua.toFixed(4)), O.style.setProperty("--world-scale", (1 + B * 0.09).toFixed(4)), O.style.setProperty("--world-y", `${(-B * 2.2).toFixed(2)}%`), O.style.setProperty("--focus", "1"), O.toggleAttribute("data-catalog-active", B > 0.82), Math.abs(j - p) > 5e-4 && (pl = window.requestAnimationFrame(T));
    }, A = () => {
      pl || (pl = window.requestAnimationFrame(T));
    }, _ = () => {
      C = z.getBoundingClientRect().top + window.scrollY, W = Math.max(1, z.offsetHeight - window.innerHeight), p = I((window.scrollY - C) / W), A();
    }, Y = () => {
      p = I((window.scrollY - C) / W), A();
    }, L = (B) => {
      Nl = B.matches, A();
    };
    return _(), window.addEventListener("scroll", Y, { passive: !0 }), window.addEventListener("resize", _, { passive: !0 }), ol.addEventListener("change", L), () => {
      window.removeEventListener("scroll", Y), window.removeEventListener("resize", _), ol.removeEventListener("change", L), pl && window.cancelAnimationFrame(pl);
    };
  }, []), Ll.useEffect(() => {
    const z = document.title;
    return document.title = "Wrestling Is a Decision Tree | Spiral Combat", document.body.classList.add("sc-wrestling-decision-tree-page"), Ma("landing_page_view", { value: 97 }), () => {
      document.title = z, document.body.classList.remove("sc-wrestling-decision-tree-page");
    };
  }, []), Ll.useEffect(() => {
    if (!H) return;
    const z = y.current;
    if (!z) return;
    const O = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    const ol = () => [...z.querySelectorAll('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])')], Nl = window.requestAnimationFrame(() => ol()[0]?.focus()), pl = (p) => {
      if (p.key === "Escape") {
        p.preventDefault(), el(!1);
        return;
      }
      if (p.key !== "Tab") return;
      const j = ol();
      if (!j.length) return;
      const C = j[0], W = j[j.length - 1];
      p.shiftKey && document.activeElement === C ? (p.preventDefault(), W.focus()) : !p.shiftKey && document.activeElement === W && (p.preventDefault(), C.focus());
    };
    return window.addEventListener("keydown", pl), () => {
      window.cancelAnimationFrame(Nl), window.removeEventListener("keydown", pl), document.body.style.overflow = O, ml.current?.focus();
    };
  }, [H]);
  const Z = (z) => {
    const O = N.current;
    if (!O) return;
    const ol = O.getBoundingClientRect().top + window.scrollY, Nl = O.offsetHeight - window.innerHeight;
    window.scrollTo({
      top: ol + Nl * z,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
    });
  }, Vl = (z) => {
    Rl.length || Ma("decision_audit_started");
    const O = [...Rl, z];
    if (U(O), sl === Da.length - 1) {
      const ol = Math.min(6, Math.max(1, Math.round(O.reduce((Nl, pl) => Nl + pl, 0) / O.length)));
      $(ol), Ma("decision_audit_completed", { starting_node: _a[ol - 1].name });
    } else
      El((ol) => ol + 1);
  }, Kl = (z) => {
    ml.current = document.activeElement instanceof HTMLElement ? document.activeElement : null, Ma("primary_cta", { source: z, value: gl ? 109 : 97, deck_selected: gl }), el(!0);
  }, Ht = (z) => {
    const O = F.current;
    O && (O.scrollBy({ left: z * O.clientWidth * 0.72, behavior: "smooth" }), wl((ol) => Math.min(6, Math.max(1, ol + z))));
  };
  return /* @__PURE__ */ c.jsx(
    "div",
    {
      "data-sc-wrestling-decision-tree": !0,
      style: {
        "--seeing-hero-image": `url("${_t("/assets/wrestling/generated/wrestling-decision-tree-hero-parchment-v1.webp")}")`,
        "--wrestling-codex-art": `url("${_t("/assets/wrestling/generated/wrestling-contact-leverage-parchment-v1.webp")}")`
      },
      children: /* @__PURE__ */ c.jsxs("main", { children: [
        /* @__PURE__ */ c.jsxs("header", { className: "site-header", "aria-label": "Primary navigation", children: [
          /* @__PURE__ */ c.jsxs("a", { className: "wordmark", href: "#top", "aria-label": "Return to the Wrestling Decision Tree beginning", children: [
            /* @__PURE__ */ c.jsx("img", { className: "wordmark-mark", src: Dr, width: "48", height: "48", alt: "", "aria-hidden": "true" }),
            /* @__PURE__ */ c.jsxs("span", { children: [
              "SPIRAL COMBAT",
              /* @__PURE__ */ c.jsx("small", { children: "WRESTLING SERIES / 01" })
            ] })
          ] }),
          /* @__PURE__ */ c.jsxs("nav", { children: [
            /* @__PURE__ */ c.jsx("button", { type: "button", onClick: () => Z(0.78), children: "Six nodes" }),
            /* @__PURE__ */ c.jsx("a", { href: "#audit", children: "Decision audit" }),
            /* @__PURE__ */ c.jsx("a", { href: "#complete-edition", children: "The $97 Codex" }),
            /* @__PURE__ */ c.jsx("a", { href: "#sample-drill", children: "Sample rule" }),
            /* @__PURE__ */ c.jsx("button", { className: "header-cta", type: "button", onClick: () => Kl("header"), children: "Get the digital Codex · $97" })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { id: "top", className: "cinematic-scroll", ref: N, "aria-label": "Wrestling decision tree introduction", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "cinematic-stage", ref: yl, children: [
            /* @__PURE__ */ c.jsxs("div", { className: "world wrestling-world", "aria-hidden": "true", children: [
              /* @__PURE__ */ c.jsx("img", { className: "world-image wrestling-hero-world", src: _t("/assets/wrestling/generated/wrestling-decision-tree-hero-parchment-v1.webp"), width: "1536", height: "1024", alt: "", fetchPriority: "high" }),
              /* @__PURE__ */ c.jsx("div", { className: "world-wash" }),
              /* @__PURE__ */ c.jsxs("div", { className: "perception-radar", children: [
                /* @__PURE__ */ c.jsx("i", {}),
                /* @__PURE__ */ c.jsx("i", {}),
                /* @__PURE__ */ c.jsx("i", {}),
                /* @__PURE__ */ c.jsx("i", {}),
                /* @__PURE__ */ c.jsx("span", {})
              ] })
            ] }),
            /* @__PURE__ */ c.jsx("div", { className: "ink-gate ink-gate-left", "aria-hidden": "true" }),
            /* @__PURE__ */ c.jsx("div", { className: "ink-gate ink-gate-right", "aria-hidden": "true" }),
            /* @__PURE__ */ c.jsx("div", { className: "cinema-vignette", "aria-hidden": "true" }),
            /* @__PURE__ */ c.jsxs("div", { className: "hero-copy", children: [
              /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "STOP COLLECTING MOVES. START READING THE NEXT CHOICE." }),
              /* @__PURE__ */ c.jsxs("h1", { children: [
                "WRESTLING IS",
                /* @__PURE__ */ c.jsx("span", { children: "A DECISION TREE" })
              ] }),
              /* @__PURE__ */ c.jsx("p", { className: "hero-deck", children: "The move is only one branch." }),
              /* @__PURE__ */ c.jsx("p", { className: "hero-explainer", children: "Learn to study stance, contact, reactions, entries, finishes and positions as one connected chain." }),
              /* @__PURE__ */ c.jsx("p", { className: "hero-proof", children: "THE $97 DIGITAL WRESTLING CODEX · EXISTING PROTECTED READER ACCESS" }),
              /* @__PURE__ */ c.jsxs("div", { className: "hero-actions", children: [
                /* @__PURE__ */ c.jsx("button", { type: "button", onClick: () => Kl("hero"), children: "Get the digital Codex · $97" }),
                /* @__PURE__ */ c.jsx("button", { type: "button", onClick: () => document.querySelector("#audit")?.scrollIntoView({ behavior: "smooth" }), children: "Test how you currently read wrestling" })
              ] }),
              /* @__PURE__ */ c.jsxs("button", { className: "scroll-invitation", type: "button", onClick: () => Z(0.24), children: [
                /* @__PURE__ */ c.jsx("span", { children: "Or scroll through the chain" }),
                /* @__PURE__ */ c.jsx("i", { "aria-hidden": "true" })
              ] }),
              /* @__PURE__ */ c.jsx("p", { className: "hero-boundary", children: "A study framework—not a guaranteed match result. $97 USD. Digital only." })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { className: "narrative-panel narrative-a", children: [
              /* @__PURE__ */ c.jsx("p", { className: "panel-index", children: "OBSERVATION / 01" }),
              /* @__PURE__ */ c.jsx("h2", { children: "If you see only the move, you are reading the final branch." }),
              /* @__PURE__ */ c.jsx("p", { children: "The stance changed. Contact shifted. A reaction appeared. The useful opening was already becoming visible." })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { className: "narrative-panel narrative-b", children: [
              /* @__PURE__ */ c.jsx("p", { className: "panel-index", children: "THE CENTRAL SHIFT" }),
              /* @__PURE__ */ c.jsx("h2", { children: "You do not need a bigger move collection." }),
              /* @__PURE__ */ c.jsx("p", { children: "You need a cleaner way to connect position, pressure, reaction and the next useful choice." })
            ] }),
            /* @__PURE__ */ c.jsxs("section", { className: "level-catalog", "aria-label": "Six wrestling decision nodes", children: [
              /* @__PURE__ */ c.jsxs("div", { className: "catalog-heading", children: [
                /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "READ THE CHAIN, NOT JUST THE FINISH" }),
                /* @__PURE__ */ c.jsx("h2", { children: "Six nodes. One exchange." })
              ] }),
              /* @__PURE__ */ c.jsxs("div", { className: "rail-shell", children: [
                /* @__PURE__ */ c.jsx("div", { className: "level-rail", ref: F, tabIndex: 0, "aria-label": "Scroll through six wrestling decision nodes", children: _a.map((z) => /* @__PURE__ */ c.jsxs("article", { className: "level-card", children: [
                  /* @__PURE__ */ c.jsx("div", { className: "card-number", children: z.level }),
                  /* @__PURE__ */ c.jsx("p", { children: z.shift }),
                  /* @__PURE__ */ c.jsx("h3", { children: z.name }),
                  /* @__PURE__ */ c.jsx("span", { children: z.short })
                ] }, z.level)) }),
                /* @__PURE__ */ c.jsxs("div", { className: "rail-controls", children: [
                  /* @__PURE__ */ c.jsxs("p", { "aria-live": "polite", children: [
                    ht,
                    " / 6"
                  ] }),
                  /* @__PURE__ */ c.jsx("button", { type: "button", onClick: () => Ht(-1), "aria-label": "Previous node", children: "←" }),
                  /* @__PURE__ */ c.jsx("button", { type: "button", onClick: () => Ht(1), "aria-label": "Next node", children: "→" })
                ] })
              ] }),
              /* @__PURE__ */ c.jsx("button", { className: "continue-button", type: "button", onClick: () => document.querySelector("#audit")?.scrollIntoView({ behavior: "smooth" }), children: "Find your starting node" })
            ] })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "reduced-story", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "STOP COLLECTING MOVES. START READING THE NEXT CHOICE." }),
            /* @__PURE__ */ c.jsx("h1", { children: "WRESTLING IS A DECISION TREE" }),
            /* @__PURE__ */ c.jsx("p", { children: "The move is only one branch." }),
            /* @__PURE__ */ c.jsx("p", { className: "reduced-proof", children: "The $97 digital Wrestling Codex organizes 100 rules across the full chain." }),
            /* @__PURE__ */ c.jsx("button", { className: "reduced-offer-button", type: "button", onClick: () => Kl("reduced-motion-hero"), children: "Get the digital Codex · $97" }),
            /* @__PURE__ */ c.jsx("ol", { children: _a.map((z) => /* @__PURE__ */ c.jsxs("li", { children: [
              /* @__PURE__ */ c.jsx("span", { children: z.level }),
              /* @__PURE__ */ c.jsx("strong", { children: z.name }),
              /* @__PURE__ */ c.jsx("p", { children: z.short })
            ] }, z.level)) })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "audit-section", id: "audit", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "section-intro", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "THE DECISION AUDIT" }),
            /* @__PURE__ */ c.jsx("h2", { children: "Where does your thinking stop when wrestling becomes fast?" }),
            /* @__PURE__ */ c.jsx("p", { children: "This is not a skill rank. It is a study prompt for finding the first missing link in your chain." })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "audit-grid", children: [
            /* @__PURE__ */ c.jsxs("div", { className: "audit-compass", "aria-hidden": "true", children: [
              /* @__PURE__ */ c.jsxs("div", { className: "compass-rings", children: [
                _a.map((z, O) => /* @__PURE__ */ c.jsx("span", { style: { "--ring": O } }, z.level)),
                /* @__PURE__ */ c.jsx("i", {})
              ] }),
              /* @__PURE__ */ c.jsx("p", { children: "MOVE" }),
              /* @__PURE__ */ c.jsx("p", { children: "CHAIN" })
            ] }),
            /* @__PURE__ */ c.jsx("div", { className: "quiz-card", children: E === null ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
              /* @__PURE__ */ c.jsx("div", { className: "quiz-progress", "aria-label": `Question ${sl + 1} of ${Da.length}`, children: /* @__PURE__ */ c.jsx("span", { style: { width: `${(sl + 1) / Da.length * 100}%` } }) }),
              /* @__PURE__ */ c.jsxs("p", { className: "quiz-count", children: [
                "QUESTION ",
                sl + 1,
                " / ",
                Da.length
              ] }),
              /* @__PURE__ */ c.jsx("h3", { children: Da[sl].prompt }),
              /* @__PURE__ */ c.jsx("div", { className: "quiz-options", children: Da[sl].options.map(([z, O]) => /* @__PURE__ */ c.jsxs("button", { type: "button", onClick: () => Vl(O), children: [
                /* @__PURE__ */ c.jsx("span", { children: z }),
                /* @__PURE__ */ c.jsx("i", { "aria-hidden": "true", children: "→" })
              ] }, z)) })
            ] }) : /* @__PURE__ */ c.jsxs("div", { className: "quiz-result", "aria-live": "polite", children: [
              /* @__PURE__ */ c.jsx("p", { className: "quiz-count", children: "A STUDY STARTING POINT · NOT A RANK" }),
              /* @__PURE__ */ c.jsx("div", { className: "result-lens", children: _a[E - 1].name }),
              /* @__PURE__ */ c.jsx("h3", { children: Mr[E - 1][0] }),
              /* @__PURE__ */ c.jsx("p", { children: Mr[E - 1][1] }),
              /* @__PURE__ */ c.jsxs("div", { className: "result-actions", children: [
                /* @__PURE__ */ c.jsx("a", { href: "#sample-drill", children: "See a sample rule" }),
                /* @__PURE__ */ c.jsx("button", { type: "button", onClick: () => {
                  El(0), U([]), $(null);
                }, children: "Retake audit" })
              ] })
            ] }) })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "manifesto-section", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "manifesto-copy", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "THE PROBLEM IS NOT A LACK OF MOVES" }),
            /* @__PURE__ */ c.jsxs("h2", { children: [
              "THE MOVE MAKES SENSE",
              /* @__PURE__ */ c.jsx("br", {}),
              "ONLY INSIDE THE CHAIN."
            ] }),
            /* @__PURE__ */ c.jsx("p", { children: "Wrestling choices depend on stance, contact, reaction, angle, finish and position. The Codex gives you rules for studying how those pieces connect." })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "body-cue-frame", children: [
            /* @__PURE__ */ c.jsx("img", { src: _t("/assets/wrestling/generated/wrestling-contact-study-parchment-v1.webp"), width: "972", height: "1619", loading: "lazy", alt: "Original parchment study of wrestling contact, stance and branching decisions" }),
            /* @__PURE__ */ c.jsxs("div", { className: "cue-note cue-one", children: [
              /* @__PURE__ */ c.jsx("span", { children: "01" }),
              " Keep decision-making inside your stance."
            ] }),
            /* @__PURE__ */ c.jsxs("div", { className: "cue-note cue-two", children: [
              /* @__PURE__ */ c.jsx("span", { children: "02" }),
              " Draw a reaction before forcing an entry."
            ] }),
            /* @__PURE__ */ c.jsxs("div", { className: "cue-note cue-three", children: [
              /* @__PURE__ */ c.jsx("span", { children: "03" }),
              " Plan the next answer before contact."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "manual-section", id: "complete-edition", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "manual-art-wrap", children: [
            /* @__PURE__ */ c.jsx("div", { className: "book-shadow", "aria-hidden": "true" }),
            /* @__PURE__ */ c.jsx("article", { className: "book-cover", "aria-label": "The Wrestling Codex cover", children: /* @__PURE__ */ c.jsx("img", { src: _t("/assets/wrestling/codex-cover.webp"), width: "720", height: "960", loading: "lazy", alt: "The Wrestling Codex digital cover" }) }),
            /* @__PURE__ */ c.jsx("p", { className: "book-caption", children: "THE WRESTLING CODEX / DIGITAL EDITION / PROTECTED READER" })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "manual-copy", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "THE $97 DIGITAL EDITION" }),
            /* @__PURE__ */ c.jsxs("h2", { children: [
              "See the branch.",
              /* @__PURE__ */ c.jsx("br", {}),
              "Study the chain."
            ] }),
            /* @__PURE__ */ c.jsx("p", { className: "manual-lede", children: "The Wrestling Codex turns isolated techniques into pressure decisions you can study with a coach, partner or match film." }),
            /* @__PURE__ */ c.jsxs("ul", { className: "manual-stats", "aria-label": "Wrestling Codex contents", children: [
              /* @__PURE__ */ c.jsxs("li", { children: [
                /* @__PURE__ */ c.jsx("strong", { children: "100" }),
                /* @__PURE__ */ c.jsx("span", { children: "decision rules" })
              ] }),
              /* @__PURE__ */ c.jsxs("li", { children: [
                /* @__PURE__ */ c.jsx("strong", { children: "7" }),
                /* @__PURE__ */ c.jsx("span", { children: "training gates" })
              ] }),
              /* @__PURE__ */ c.jsxs("li", { children: [
                /* @__PURE__ */ c.jsx("strong", { children: "1" }),
                /* @__PURE__ */ c.jsx("span", { children: "connected system" })
              ] }),
              /* @__PURE__ */ c.jsxs("li", { children: [
                /* @__PURE__ */ c.jsx("strong", { children: "0" }),
                /* @__PURE__ */ c.jsx("span", { children: "physical items" })
              ] })
            ] }),
            /* @__PURE__ */ c.jsxs("div", { className: "manual-includes", children: [
              /* @__PURE__ */ c.jsx("p", { children: "Your existing digital edition includes" }),
              /* @__PURE__ */ c.jsxs("ul", { children: [
                /* @__PURE__ */ c.jsx("li", { children: "Protected Wrestling Codex reader access" }),
                /* @__PURE__ */ c.jsx("li", { children: "Rules spanning stance, contact, entries, finishes, top, bottom and match management" }),
                /* @__PURE__ */ c.jsx("li", { children: "Why each rule matters, what failure costs and how to drill it" }),
                /* @__PURE__ */ c.jsx("li", { children: "Real reader pages shown on this page" })
              ] })
            ] }),
            /* @__PURE__ */ c.jsxs("button", { className: "primary-offer-button", type: "button", onClick: () => Kl("complete-edition"), children: [
              /* @__PURE__ */ c.jsx("span", { children: "Get the digital Wrestling Codex" }),
              /* @__PURE__ */ c.jsx("strong", { children: "$97" })
            ] }),
            /* @__PURE__ */ c.jsx("p", { className: "purchase-note", children: "One payment. Existing protected My Library access after verified payment. No subscription. Nothing shipped." })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "product-truth-section", "aria-labelledby": "product-truth-title", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "truth-heading", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "ONE CODEX · ONE OPTIONAL DIGITAL DECK" }),
            /* @__PURE__ */ c.jsxs("h2", { id: "product-truth-title", children: [
              "Understand it.",
              /* @__PURE__ */ c.jsx("br", {}),
              "Study it. Carry it."
            ] }),
            /* @__PURE__ */ c.jsx("p", { children: "The Codex is the complete system. The optional deck will later turn fourteen decision prompts into a phone-first practice aid." })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "truth-grid", children: [
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("span", { children: "01 / UNDERSTAND" }),
              /* @__PURE__ */ c.jsx("h3", { children: "Wrestling Decision Tree" }),
              /* @__PURE__ */ c.jsx("p", { children: "Read the exchange as linked choices instead of disconnected moves." }),
              /* @__PURE__ */ c.jsx("strong", { children: "Explained across the page" })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("span", { children: "02 / STUDY" }),
              /* @__PURE__ */ c.jsx("h3", { children: "The Wrestling Codex" }),
              /* @__PURE__ */ c.jsx("p", { children: "One hundred rules organized across seven gates, with live application and drilling guidance." }),
              /* @__PURE__ */ c.jsx("strong", { children: "Included for $97" })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("span", { children: "03 / CARRY" }),
              /* @__PURE__ */ c.jsx("h3", { children: "Decision Tree Drill Deck" }),
              /* @__PURE__ */ c.jsx("p", { children: "Fourteen planned phone-first cards, a printable chain map and accessible HTML edition." }),
              /* @__PURE__ */ c.jsx("strong", { children: "Optional +$12 · not yet purchasable" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "page-preview-section", "aria-labelledby": "page-preview-title", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "page-preview-heading", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "REAL PAGES FROM THE WRESTLING CODEX" }),
            /* @__PURE__ */ c.jsxs("h2", { id: "page-preview-title", children: [
              "Four decisions.",
              /* @__PURE__ */ c.jsx("br", {}),
              "One connected language."
            ] }),
            /* @__PURE__ */ c.jsx("p", { children: "These are real pages from the current protected digital product—not generic martial-arts filler." })
          ] }),
          /* @__PURE__ */ c.jsx("div", { className: "manual-page-grid", children: vv.map(([z, O, ol], Nl) => /* @__PURE__ */ c.jsxs("figure", { className: Nl % 2 ? "page-preview is-lower" : "page-preview", children: [
            /* @__PURE__ */ c.jsx("div", { children: /* @__PURE__ */ c.jsx("img", { src: _t(z), width: "612", height: "792", loading: "lazy", alt: `Wrestling Codex study: ${ol}` }) }),
            /* @__PURE__ */ c.jsxs("figcaption", { children: [
              /* @__PURE__ */ c.jsxs("span", { children: [
                "STUDY ",
                O
              ] }),
              ol
            ] })
          ] }, z)) }),
          /* @__PURE__ */ c.jsxs("div", { className: "branching-preview", "aria-labelledby": "branching-preview-title", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "BRANCHING PREVIEW" }),
            /* @__PURE__ */ c.jsx("h3", { id: "branching-preview-title", children: "Change the position. Change the next node." }),
            /* @__PURE__ */ c.jsxs("figure", { className: "branching-map-art", children: [
              /* @__PURE__ */ c.jsx("img", { src: _t("/assets/wrestling/generated/wrestling-branch-map-parchment-v1.webp"), width: "1774", height: "887", loading: "lazy", alt: "Original parchment branch map connecting wrestling stance, contact, reaction and finish decisions" }),
              /* @__PURE__ */ c.jsx("figcaption", { children: "THE DECISION MAP / ORIGINAL WRESTLING STUDY ART" })
            ] }),
            /* @__PURE__ */ c.jsx("div", { className: "branch-tabs", role: "tablist", "aria-label": "Preview a neutral, top or bottom wrestling branch", children: On.map((z, O) => /* @__PURE__ */ c.jsx("button", { type: "button", role: "tab", "aria-selected": Al === O, className: Al === O ? "is-active" : "", onClick: () => Dt(O), children: z.label }, z.id)) }),
            /* @__PURE__ */ c.jsxs("article", { className: "branch-panel", "aria-live": "polite", children: [
              /* @__PURE__ */ c.jsx("div", { className: "branch-pages", children: On[Al].pages.map((z) => /* @__PURE__ */ c.jsx("img", { src: _t(z), width: "612", height: "792", loading: "lazy", alt: `${On[Al].label} Wrestling Codex preview page` }, z)) }),
              /* @__PURE__ */ c.jsxs("div", { children: [
                /* @__PURE__ */ c.jsx("span", { children: "NEXT DECISION NODE" }),
                /* @__PURE__ */ c.jsx("h4", { children: On[Al].title }),
                /* @__PURE__ */ c.jsx("p", { children: On[Al].next })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ c.jsxs("a", { className: "preview-cta", href: "#sample-drill", children: [
            "Then test one rule ",
            /* @__PURE__ */ c.jsx("span", { children: "See the sample →" })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "sample-section", id: "sample-drill", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "sample-heading", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "FROM THE WRESTLING CODEX" }),
            /* @__PURE__ */ c.jsxs("h2", { children: [
              "Do not rise",
              /* @__PURE__ */ c.jsx("br", {}),
              "to think."
            ] })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "sample-layout", children: [
            /* @__PURE__ */ c.jsxs("div", { className: "sample-art", children: [
              /* @__PURE__ */ c.jsx("img", { src: _t("/assets/wrestling/page-031.svg"), width: "612", height: "792", loading: "lazy", alt: "Wrestling Codex applied rule page: Do Not Rise to Think" }),
              /* @__PURE__ */ c.jsx("span", { className: "sample-stamp", children: "GATE I / RULE 06" })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { className: "drill-card", children: [
              /* @__PURE__ */ c.jsx("p", { className: "panel-index", children: "STANCE / DECISION POSTURE" }),
              /* @__PURE__ */ c.jsx("h3", { children: "Keep the next choice inside your stance." }),
              /* @__PURE__ */ c.jsxs("ol", { children: [
                /* @__PURE__ */ c.jsxs("li", { children: [
                  /* @__PURE__ */ c.jsx("span", { children: "01" }),
                  /* @__PURE__ */ c.jsx("p", { children: "Begin in a position that can shoot, sprawl, circle and re-attack without standing tall." })
                ] }),
                /* @__PURE__ */ c.jsxs("li", { children: [
                  /* @__PURE__ */ c.jsx("span", { children: "02" }),
                  /* @__PURE__ */ c.jsx("p", { children: "Partner gives a simple motion, tie or level-change cue at controlled speed." })
                ] }),
                /* @__PURE__ */ c.jsxs("li", { children: [
                  /* @__PURE__ */ c.jsx("span", { children: "03" }),
                  /* @__PURE__ */ c.jsx("p", { children: "Answer without losing hip protection, four-direction movement or access to your own offense." })
                ] }),
                /* @__PURE__ */ c.jsxs("li", { children: [
                  /* @__PURE__ */ c.jsx("span", { children: "04" }),
                  /* @__PURE__ */ c.jsx("p", { children: "If posture rises before the decision, reduce speed and rebuild the stance." })
                ] })
              ] }),
              /* @__PURE__ */ c.jsxs("div", { className: "drill-constraint", children: [
                /* @__PURE__ */ c.jsx("strong", { children: "Constraint" }),
                /* @__PURE__ */ c.jsx("p", { children: "This is a study example, not individualized coaching. Use safe intensity, qualified supervision and your ruleset." })
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "protocol-section", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "section-intro light-intro", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "A SIMPLE 21-DAY STUDY RHYTHM" }),
            /* @__PURE__ */ c.jsxs("h2", { children: [
              "Do not memorize everything.",
              /* @__PURE__ */ c.jsx("br", {}),
              "Follow one branch at a time."
            ] })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "protocol-weeks", children: [
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("p", { children: "WEEK 01 / SEE" }),
              /* @__PURE__ */ c.jsx("h3", { children: "Name the current node." }),
              /* @__PURE__ */ c.jsx("span", { children: "Stance → Contact → Reaction" }),
              /* @__PURE__ */ c.jsxs("ul", { children: [
                /* @__PURE__ */ c.jsx("li", { children: "Record where the exchange starts" }),
                /* @__PURE__ */ c.jsx("li", { children: "Name the first useful reaction" }),
                /* @__PURE__ */ c.jsx("li", { children: "Choose one rule to test" })
              ] })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("p", { children: "WEEK 02 / CHAIN" }),
              /* @__PURE__ */ c.jsx("h3", { children: "Prepare the second answer." }),
              /* @__PURE__ */ c.jsx("span", { children: "Entry → Defense → Finish" }),
              /* @__PURE__ */ c.jsxs("ul", { children: [
                /* @__PURE__ */ c.jsx("li", { children: "Link one attack to one likely defense" }),
                /* @__PURE__ */ c.jsx("li", { children: "Keep posture through the transition" }),
                /* @__PURE__ */ c.jsx("li", { children: "Score decision quality, not novelty" })
              ] })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("p", { children: "WEEK 03 / ADAPT" }),
              /* @__PURE__ */ c.jsx("h3", { children: "Change the branch." }),
              /* @__PURE__ */ c.jsx("span", { children: "Top → Bottom → Match" }),
              /* @__PURE__ */ c.jsxs("ul", { children: [
                /* @__PURE__ */ c.jsx("li", { children: "Study how position changes the answer" }),
                /* @__PURE__ */ c.jsx("li", { children: "Add score, edge or clock context" }),
                /* @__PURE__ */ c.jsx("li", { children: "Carry one correction forward" })
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "codex-reveal-section", id: "illustrated-codex", "aria-labelledby": "codex-title", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "codex-copy", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "THE DIGITAL WRESTLING CODEX" }),
            /* @__PURE__ */ c.jsxs("h2", { id: "codex-title", children: [
              "One hundred rules.",
              /* @__PURE__ */ c.jsx("br", {}),
              "Seven gates."
            ] }),
            /* @__PURE__ */ c.jsx("p", { children: "Each rule names the decision, explains why it matters, shows the cost of ignoring it and gives you a way to test it." }),
            /* @__PURE__ */ c.jsxs("ul", { children: [
              /* @__PURE__ */ c.jsx("li", { children: "Real pages from the existing paid product" }),
              /* @__PURE__ */ c.jsx("li", { children: "Neutral, finish, top, bottom and match-management decisions" }),
              /* @__PURE__ */ c.jsx("li", { children: "Designed for protected reading in My Library" }),
              /* @__PURE__ */ c.jsx("li", { children: "No change to the existing product or physical preorder" })
            ] }),
            /* @__PURE__ */ c.jsx("div", { className: "codex-selector", role: "tablist", "aria-label": "Wrestling Codex pages", children: Ur.map((z, O) => /* @__PURE__ */ c.jsxs("button", { type: "button", className: jl === O ? "is-active" : "", onClick: () => jt(O), role: "tab", "aria-selected": jl === O, children: [
              /* @__PURE__ */ c.jsx("span", { children: String(O + 1).padStart(2, "0") }),
              z[1]
            ] }, z[1])) })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "codex-stage", children: [
            /* @__PURE__ */ c.jsx("div", { className: "codex-page-stack", "aria-live": "polite", children: Ur.map((z, O) => /* @__PURE__ */ c.jsxs("figure", { className: jl === O ? "is-active" : "", "aria-hidden": jl !== O, children: [
              /* @__PURE__ */ c.jsx("img", { src: _t(z[0]), width: "612", height: "792", loading: "lazy", alt: z[2] }),
              /* @__PURE__ */ c.jsx("figcaption", { children: z[1] })
            ] }, z[0])) }),
            /* @__PURE__ */ c.jsxs("p", { className: "proof-status", children: [
              /* @__PURE__ */ c.jsx("span", {}),
              " Existing digital product. Real protected-reader pages."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "deck-section", id: "decision-deck", "aria-labelledby": "deck-title", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "deck-visual deck-placeholder", "aria-label": "Planned Wrestling Decision Tree Drill Deck", children: [
            /* @__PURE__ */ c.jsxs("div", { className: "digital-card-stack", children: [
              /* @__PURE__ */ c.jsxs("article", { children: [
                /* @__PURE__ */ c.jsx("span", { children: "01" }),
                /* @__PURE__ */ c.jsx("strong", { children: "STANCE" }),
                /* @__PURE__ */ c.jsx("p", { children: "What choices remain available without a reset?" })
              ] }),
              /* @__PURE__ */ c.jsxs("article", { children: [
                /* @__PURE__ */ c.jsx("span", { children: "07" }),
                /* @__PURE__ */ c.jsx("strong", { children: "FINISH" }),
                /* @__PURE__ */ c.jsx("p", { children: "Which defense tells you the next branch?" })
              ] }),
              /* @__PURE__ */ c.jsxs("article", { children: [
                /* @__PURE__ */ c.jsx("span", { children: "14" }),
                /* @__PURE__ */ c.jsx("strong", { children: "MATCH" }),
                /* @__PURE__ */ c.jsx("p", { children: "How does score or edge change the risk?" })
              ] })
            ] }),
            /* @__PURE__ */ c.jsx("p", { children: "14 PLANNED PHONE-FIRST CARDS · DIGITAL ONLY" })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "deck-copy", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "OPTIONAL WRESTLING DECISION TREE DRILL DECK · +$12" }),
            /* @__PURE__ */ c.jsx("h2", { id: "deck-title", children: "Carry the question, not the whole book." }),
            /* @__PURE__ */ c.jsx("p", { children: "The planned deck turns fourteen decision prompts into phone-first practice cues, with a printable chain map and accessible HTML edition." }),
            /* @__PURE__ */ c.jsxs("p", { className: "deck-boundary", children: [
              /* @__PURE__ */ c.jsx("strong", { children: "Unchecked by default and not yet purchasable." }),
              " The add-on stays disabled until its exact Shopify variant and protected Member entitlement exist."
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "proof-section", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "proof-copy", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "THE ORGANIC IDEA, EXPANDED" }),
            /* @__PURE__ */ c.jsxs("h2", { children: [
              "The carousel named the pattern.",
              /* @__PURE__ */ c.jsx("br", {}),
              "The Codex gives it structure."
            ] }),
            /* @__PURE__ */ c.jsx("p", { children: "The exact Instagram post is preserved for the future paid test. This page uses real Codex previews while the owned five-slide source artwork is still being bound into the storefront package." }),
            /* @__PURE__ */ c.jsx("a", { className: "organic-post-link", href: hv, target: "_blank", rel: "noreferrer", children: "View the original Wrestling decision-tree carousel ↗" })
          ] }),
          /* @__PURE__ */ c.jsx("div", { className: "carousel-strip", "aria-label": "Real Wrestling Codex page previews", children: ["030", "092", "164", "188", "212"].map((z, O) => /* @__PURE__ */ c.jsxs("figure", { children: [
            /* @__PURE__ */ c.jsx("img", { src: _t(`/assets/wrestling/page-${z}.svg`), width: "612", height: "792", loading: "lazy", alt: `Real Wrestling Codex page preview ${O + 1}` }),
            /* @__PURE__ */ c.jsxs("figcaption", { children: [
              String(O + 1).padStart(2, "0"),
              " / 05"
            ] })
          ] }, z)) })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "positioning-section", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "positioning-heading", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "WHAT THIS IS - AND IS NOT" }),
            /* @__PURE__ */ c.jsxs("h2", { children: [
              "Decision-making without magic.",
              /* @__PURE__ */ c.jsx("br", {}),
              "Structure without rigidity."
            ] })
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "positioning-grid", children: [
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("span", { children: "NOT" }),
              /* @__PURE__ */ c.jsx("h3", { children: "A guaranteed system" }),
              /* @__PURE__ */ c.jsx("p", { children: "No rule replaces live judgment, coaching, ruleset or the opponent in front of you." })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("span", { children: "NOT" }),
              /* @__PURE__ */ c.jsx("h3", { children: "A move encyclopedia" }),
              /* @__PURE__ */ c.jsx("p", { children: "The goal is not more technique names. It is a cleaner map between position, reaction and next action." })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("span", { children: "IS" }),
              /* @__PURE__ */ c.jsx("h3", { children: "A wrestling study system" }),
              /* @__PURE__ */ c.jsx("p", { children: "One hundred rules connect stance, ties, entries, finishes, top, bottom and match management." })
            ] }),
            /* @__PURE__ */ c.jsxs("article", { children: [
              /* @__PURE__ */ c.jsx("span", { children: "IS" }),
              /* @__PURE__ */ c.jsx("h3", { children: "A language for practice" }),
              /* @__PURE__ */ c.jsx("p", { children: "Use it to choose questions, review footage and discuss decisions with a qualified coach." })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "research-section", children: [
          /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "PRACTICE NOTES / SAFETY FIRST" }),
          /* @__PURE__ */ c.jsxs("div", { className: "research-grid", children: [
            /* @__PURE__ */ c.jsxs("h2", { children: [
              "The framework is a study lens.",
              /* @__PURE__ */ c.jsx("br", {}),
              "The mat decides."
            ] }),
            /* @__PURE__ */ c.jsxs("div", { children: [
              /* @__PURE__ */ c.jsx("p", { children: "Train with progressive resistance, appropriate supervision and the rules of your discipline. Keep claims proportionate: this page teaches a way to organize wrestling study, not guaranteed outcomes, injury prevention or coaching equivalence." }),
              /* @__PURE__ */ c.jsxs("ol", { children: [
                /* @__PURE__ */ c.jsx("li", { children: "Test one rule at a time." }),
                /* @__PURE__ */ c.jsx("li", { children: "Release a branch when live evidence contradicts it." }),
                /* @__PURE__ */ c.jsx("li", { children: "Stop whenever safety, structure or judgment degrades." })
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "offer-section", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "offer-rings", "aria-hidden": "true", children: [
            /* @__PURE__ */ c.jsx("i", {}),
            /* @__PURE__ */ c.jsx("i", {}),
            /* @__PURE__ */ c.jsx("i", {}),
            /* @__PURE__ */ c.jsx("i", {}),
            /* @__PURE__ */ c.jsx("i", {}),
            /* @__PURE__ */ c.jsx("i", {})
          ] }),
          /* @__PURE__ */ c.jsxs("div", { className: "offer-content", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "THE WRESTLING DECISION TREE" }),
            /* @__PURE__ */ c.jsx("h2", { children: "The next move begins with the reaction." }),
            /* @__PURE__ */ c.jsx("p", { children: "Study the chain before you add another technique." }),
            /* @__PURE__ */ c.jsxs("div", { className: "offer-price", children: [
              /* @__PURE__ */ c.jsx("span", { children: "$97" }),
              /* @__PURE__ */ c.jsx("small", { children: "ONE-TIME / DIGITAL WRESTLING CODEX" })
            ] }),
            /* @__PURE__ */ c.jsxs("button", { type: "button", onClick: () => Kl("closing-offer"), children: [
              "Get the digital Codex ",
              /* @__PURE__ */ c.jsx("span", { children: "→" })
            ] }),
            /* @__PURE__ */ c.jsx("p", { className: "offer-meta", children: "100 rules · 7 training gates · protected reader · no subscription · nothing shipped" })
          ] })
        ] }),
        /* @__PURE__ */ c.jsxs("section", { className: "faq-section", children: [
          /* @__PURE__ */ c.jsxs("div", { className: "faq-heading", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "MAT QUESTIONS" }),
            /* @__PURE__ */ c.jsx("h2", { children: "Before you begin." })
          ] }),
          /* @__PURE__ */ c.jsx("div", { className: "faq-list", children: mv.map((z, O) => /* @__PURE__ */ c.jsxs("article", { className: zl === O ? "is-open" : "", children: [
            /* @__PURE__ */ c.jsxs("button", { type: "button", onClick: () => kl(zl === O ? null : O), "aria-expanded": zl === O, children: [
              /* @__PURE__ */ c.jsx("span", { children: z.q }),
              /* @__PURE__ */ c.jsx("i", { "aria-hidden": "true", children: "+" })
            ] }),
            /* @__PURE__ */ c.jsx("div", { children: /* @__PURE__ */ c.jsx("p", { children: z.a }) })
          ] }, z.q)) })
        ] }),
        /* @__PURE__ */ c.jsxs("footer", { children: [
          /* @__PURE__ */ c.jsxs("div", { className: "wordmark footer-wordmark", children: [
            /* @__PURE__ */ c.jsx("img", { className: "wordmark-mark", src: Dr, width: "48", height: "48", alt: "", "aria-hidden": "true" }),
            /* @__PURE__ */ c.jsxs("span", { children: [
              "SPIRAL COMBAT",
              /* @__PURE__ */ c.jsx("small", { children: "INTELLIGENCE UNDER PRESSURE" })
            ] })
          ] }),
          /* @__PURE__ */ c.jsx("p", { children: "Train responsibly. Use progressive resistance, appropriate supervision and the rules of your discipline." }),
          /* @__PURE__ */ c.jsxs("div", { className: "footer-links", children: [
            /* @__PURE__ */ c.jsx("a", { href: "#top", children: "Return to the beginning ↑" }),
            /* @__PURE__ */ c.jsx("a", { href: "/pages/terms-of-service", children: "Terms" }),
            /* @__PURE__ */ c.jsx("a", { href: "/pages/privacy-policy", children: "Privacy" }),
            /* @__PURE__ */ c.jsx("a", { href: "mailto:mike@spiralcombat.com", children: "Support" }),
            /* @__PURE__ */ c.jsx("span", { children: "© 2026 SPIRAL COMBAT" })
          ] })
        ] }),
        H ? /* @__PURE__ */ c.jsx("div", { className: "checkout-backdrop", role: "presentation", onMouseDown: (z) => {
          z.target === z.currentTarget && el(!1);
        }, children: /* @__PURE__ */ c.jsxs("section", { className: "checkout-sheet checkout-v2", role: "dialog", "aria-modal": "true", "aria-labelledby": "checkout-title", "aria-describedby": "checkout-description", ref: y, children: [
          /* @__PURE__ */ c.jsx("button", { className: "checkout-close", type: "button", onClick: () => el(!1), "aria-label": "Close purchase panel", children: "×" }),
          /* @__PURE__ */ c.jsxs("div", { className: "checkout-stage", children: [
            /* @__PURE__ */ c.jsx("p", { className: "eyebrow", children: "YOUR DIGITAL WRESTLING CODEX" }),
            /* @__PURE__ */ c.jsx("h2", { id: "checkout-title", children: "One Codex. One connected system." }),
            /* @__PURE__ */ c.jsx("p", { className: "checkout-subtitle", id: "checkout-description", children: "Study stance, contact, entries, finishes, position and match management as one chain." }),
            E ? /* @__PURE__ */ c.jsxs("p", { className: "checkout-diagnostic", children: [
              "Decision Audit starting node: ",
              /* @__PURE__ */ c.jsx("strong", { children: _a[E - 1].name }),
              ". A study prompt, not a rank."
            ] }) : null,
            /* @__PURE__ */ c.jsxs("ul", { children: [
              /* @__PURE__ */ c.jsx("li", { children: "Existing digital Wrestling Codex" }),
              /* @__PURE__ */ c.jsx("li", { children: "100 decision rules across seven gates" }),
              /* @__PURE__ */ c.jsx("li", { children: "Protected My Library reader access" }),
              /* @__PURE__ */ c.jsx("li", { children: "Digital only; the physical preorder is excluded" })
            ] }),
            /* @__PURE__ */ c.jsxs("button", { className: gl ? "checkout-bump is-selected" : "checkout-bump", type: "button", role: "checkbox", "aria-checked": gl, onClick: () => {
              Zl((z) => !z), Ma(gl ? "deck_removed" : "deck_selected_preview");
            }, children: [
              /* @__PURE__ */ c.jsx("i", { "aria-hidden": "true", children: gl ? "✓" : "" }),
              /* @__PURE__ */ c.jsxs("span", { children: [
                /* @__PURE__ */ c.jsx("strong", { children: "Add the 14-Card Wrestling Decision Tree Drill Deck" }),
                /* @__PURE__ */ c.jsx("small", { children: "Planned phone-first cards + printable chain map + accessible HTML. Digital only." })
              ] }),
              /* @__PURE__ */ c.jsx("b", { children: "+$12" })
            ] }),
            /* @__PURE__ */ c.jsxs("div", { className: "checkout-total", "aria-live": "polite", children: [
              /* @__PURE__ */ c.jsx("span", { children: "Order total" }),
              /* @__PURE__ */ c.jsxs("strong", { children: [
                "$",
                gl ? 109 : 97,
                " USD"
              ] })
            ] }),
            gl ? /* @__PURE__ */ c.jsx("p", { className: "checkout-status", role: "status", children: "The optional deck is still being bound to its exact Shopify variant and protected delivery. Uncheck it to continue with the ready $97 Codex." }) : null,
            gl ? /* @__PURE__ */ c.jsx("button", { className: "checkout-connect", type: "button", disabled: !0, children: "Deck checkout not available yet" }) : /* @__PURE__ */ c.jsx("a", { className: "checkout-connect checkout-link", "data-core-cart-link": !0, href: _r, onClick: () => Ma("checkout_initiated", { value: 97, destination: _r }), children: "Continue to secure Shopify checkout" }),
            /* @__PURE__ */ c.jsx("p", { className: "purchase-assurance", children: "One-time purchase. Existing protected My Library access after verified payment. No subscription. Nothing shipped." })
          ] })
        ] }) }) : null
      ] })
    }
  );
}
window.__scWrestlingDecisionTreeAuthorized !== !1 && document.querySelectorAll("[data-sc-wrestling-decision-tree-root]").forEach((N) => {
  N.dataset.scMounted !== "true" && (N.dataset.scMounted = "true", dv.createRoot(N).render(/* @__PURE__ */ c.jsx(yv, {})));
});
